"use strict";

function r(r) {
  return r && "object" == typeof r && "default" in r ? r.default : r;
}

var e = require("react"),
    t = r(e),
    n = require("styled-components"),
    o = r(n),
    i = r(require("path")),
    a = r(require("util"));

function l() {
  return (l = Object.assign || function (r) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];

      for (var n in t) {
        Object.prototype.hasOwnProperty.call(t, n) && (r[n] = t[n]);
      }
    }

    return r;
  }).apply(this, arguments);
}

function s(r, e) {
  if (null == r) return {};
  var t,
      n,
      o = {},
      i = Object.keys(r);

  for (n = 0; n < i.length; n++) {
    t = i[n], e.indexOf(t) >= 0 || (o[t] = r[t]);
  }

  return o;
}

function c(r, e) {
  return e || (e = r.slice(0)), r.raw = e, r;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


var u = Object.getOwnPropertySymbols,
    p = Object.prototype.hasOwnProperty,
    f = Object.prototype.propertyIsEnumerable;

function d(r) {
  if (null == r) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(r);
}

var g = function () {
  try {
    if (!Object.assign) return !1;
    var r = new String("abc");
    if (r[5] = "de", "5" === Object.getOwnPropertyNames(r)[0]) return !1;

    for (var e = {}, t = 0; t < 10; t++) {
      e["_" + String.fromCharCode(t)] = t;
    }

    if ("0123456789" !== Object.getOwnPropertyNames(e).map(function (r) {
      return e[r];
    }).join("")) return !1;
    var n = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (r) {
      n[r] = r;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
  } catch (r) {
    return !1;
  }
}() ? Object.assign : function (r, e) {
  for (var t, n, o = d(r), i = 1; i < arguments.length; i++) {
    for (var a in t = Object(arguments[i])) {
      p.call(t, a) && (o[a] = t[a]);
    }

    if (u) {
      n = u(t);

      for (var l = 0; l < n.length; l++) {
        f.call(t, n[l]) && (o[n[l]] = t[n[l]]);
      }
    }
  }

  return o;
},
    h = function h(r, e) {
  var t = g({}, r, e);

  for (var n in r) {
    var o;
    r[n] && "object" == typeof e[n] && g(t, ((o = {})[n] = g(r[n], e[n]), o));
  }

  return t;
},
    m = {
  breakpoints: [40, 52, 64].map(function (r) {
    return r + "em";
  })
},
    b = function b(r) {
  return "@media screen and (min-width: " + r + ")";
},
    y = function y(r, e) {
  return v(e, r, r);
},
    v = function v(r, e, t, n, o) {
  for (e = e && e.split ? e.split(".") : [e], n = 0; n < e.length; n++) {
    r = r ? r[e[n]] : o;
  }

  return r === o ? t : r;
},
    w = function r(e) {
  var t = {},
      n = function n(r) {
    var n,
        o,
        i = {},
        a = !1,
        l = r.theme && r.theme.disableStyledSystemCache;

    for (var s in r) {
      if (e[s]) {
        var c = e[s],
            u = r[s],
            p = v(r.theme, c.scale, c.defaults);
        if ("object" != typeof u) g(i, c(u, p, r));else {
          if (t.breakpoints = !l && t.breakpoints || v(r.theme, "breakpoints", m.breakpoints), Array.isArray(u)) {
            t.media = !l && t.media || [null].concat(t.breakpoints.map(b)), i = h(i, k(t.media, c, p, u, r));
            continue;
          }

          null !== u && (i = h(i, q(t.breakpoints, c, p, u, r)), a = !0);
        }
      }
    }

    return a && (n = i, o = {}, Object.keys(n).sort(function (r, e) {
      return r.localeCompare(e, void 0, {
        numeric: !0,
        sensitivity: "base"
      });
    }).forEach(function (r) {
      o[r] = n[r];
    }), i = o), i;
  };

  n.config = e, n.propNames = Object.keys(e), n.cache = t;
  var o = Object.keys(e).filter(function (r) {
    return "config" !== r;
  });
  return o.length > 1 && o.forEach(function (t) {
    var o;
    n[t] = r(((o = {})[t] = e[t], o));
  }), n;
},
    k = function k(r, e, t, n, o) {
  var i = {};
  return n.slice(0, r.length).forEach(function (n, a) {
    var l,
        s = r[a],
        c = e(n, t, o);
    s ? g(i, ((l = {})[s] = g({}, i[s], c), l)) : g(i, c);
  }), i;
},
    q = function q(r, e, t, n, o) {
  var i = {};

  for (var a in n) {
    var l = r[a],
        s = e(n[a], t, o);

    if (l) {
      var c,
          u = b(l);
      g(i, ((c = {})[u] = g({}, i[u], s), c));
    } else g(i, s);
  }

  return i;
},
    A = function A(r) {
  var e = r.properties,
      t = r.property,
      n = r.scale,
      o = r.transform,
      i = void 0 === o ? y : o,
      a = r.defaultScale;
  e = e || [t];

  var l = function l(r, t, n) {
    var o = {},
        a = i(r, t, n);
    if (null !== a) return e.forEach(function (r) {
      o[r] = a;
    }), o;
  };

  return l.scale = n, l.defaults = a, l;
},
    x = function x(r) {
  void 0 === r && (r = {});
  var e = {};
  return Object.keys(r).forEach(function (t) {
    var n = r[t];
    e[t] = !0 !== n ? "function" != typeof n ? A(n) : n : A({
      property: t,
      scale: t
    });
  }), w(e);
},
    S = function S() {
  for (var r = {}, e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
    t[n] = arguments[n];
  }

  t.forEach(function (e) {
    e && e.config && g(r, e.config);
  });
  var o = w(r);
  return o;
},
    E = x({
  width: {
    property: "width",
    scale: "sizes",
    transform: function transform(r, e) {
      return v(e, r, !function (r) {
        return "number" == typeof r && !isNaN(r);
      }(r) || r > 1 ? r : 100 * r + "%");
    }
  },
  height: {
    property: "height",
    scale: "sizes"
  },
  minWidth: {
    property: "minWidth",
    scale: "sizes"
  },
  minHeight: {
    property: "minHeight",
    scale: "sizes"
  },
  maxWidth: {
    property: "maxWidth",
    scale: "sizes"
  },
  maxHeight: {
    property: "maxHeight",
    scale: "sizes"
  },
  size: {
    properties: ["width", "height"],
    scale: "sizes"
  },
  overflow: !0,
  overflowX: !0,
  overflowY: !0,
  display: !0,
  verticalAlign: !0
}),
    L = {
  color: {
    property: "color",
    scale: "colors"
  },
  backgroundColor: {
    property: "backgroundColor",
    scale: "colors"
  },
  opacity: !0
};

L.bg = L.backgroundColor;
var T = x(L),
    R = x({
  fontFamily: {
    property: "fontFamily",
    scale: "fonts"
  },
  fontSize: {
    property: "fontSize",
    scale: "fontSizes",
    defaultScale: [12, 14, 16, 20, 24, 32, 48, 64, 72]
  },
  fontWeight: {
    property: "fontWeight",
    scale: "fontWeights"
  },
  lineHeight: {
    property: "lineHeight",
    scale: "lineHeights"
  },
  letterSpacing: {
    property: "letterSpacing",
    scale: "letterSpacings"
  },
  textAlign: !0,
  fontStyle: !0
}),
    C = x({
  alignItems: !0,
  alignContent: !0,
  justifyItems: !0,
  justifyContent: !0,
  flexWrap: !0,
  flexDirection: !0,
  flex: !0,
  flexGrow: !0,
  flexShrink: !0,
  flexBasis: !0,
  justifySelf: !0,
  alignSelf: !0,
  order: !0
}),
    D = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
},
    O = x({
  gridGap: {
    property: "gridGap",
    scale: "space",
    defaultScale: D.space
  },
  gridColumnGap: {
    property: "gridColumnGap",
    scale: "space",
    defaultScale: D.space
  },
  gridRowGap: {
    property: "gridRowGap",
    scale: "space",
    defaultScale: D.space
  },
  gridColumn: !0,
  gridRow: !0,
  gridAutoFlow: !0,
  gridAutoColumns: !0,
  gridAutoRows: !0,
  gridTemplateColumns: !0,
  gridTemplateRows: !0,
  gridTemplateAreas: !0,
  gridArea: !0
}),
    B = {
  border: {
    property: "border",
    scale: "borders"
  },
  borderWidth: {
    property: "borderWidth",
    scale: "borderWidths"
  },
  borderStyle: {
    property: "borderStyle",
    scale: "borderStyles"
  },
  borderColor: {
    property: "borderColor",
    scale: "colors"
  },
  borderRadius: {
    property: "borderRadius",
    scale: "radii"
  },
  borderTop: {
    property: "borderTop",
    scale: "borders"
  },
  borderTopLeftRadius: {
    property: "borderTopLeftRadius",
    scale: "radii"
  },
  borderTopRightRadius: {
    property: "borderTopRightRadius",
    scale: "radii"
  },
  borderRight: {
    property: "borderRight",
    scale: "borders"
  },
  borderBottom: {
    property: "borderBottom",
    scale: "borders"
  },
  borderBottomLeftRadius: {
    property: "borderBottomLeftRadius",
    scale: "radii"
  },
  borderBottomRightRadius: {
    property: "borderBottomRightRadius",
    scale: "radii"
  },
  borderLeft: {
    property: "borderLeft",
    scale: "borders"
  },
  borderX: {
    properties: ["borderLeft", "borderRight"],
    scale: "borders"
  },
  borderY: {
    properties: ["borderTop", "borderBottom"],
    scale: "borders"
  },
  borderTopWidth: {
    property: "borderTopWidth",
    scale: "borderWidths"
  },
  borderTopColor: {
    property: "borderTopColor",
    scale: "colors"
  },
  borderTopStyle: {
    property: "borderTopStyle",
    scale: "borderStyles"
  }
};
B.borderTopLeftRadius = {
  property: "borderTopLeftRadius",
  scale: "radii"
}, B.borderTopRightRadius = {
  property: "borderTopRightRadius",
  scale: "radii"
}, B.borderBottomWidth = {
  property: "borderBottomWidth",
  scale: "borderWidths"
}, B.borderBottomColor = {
  property: "borderBottomColor",
  scale: "colors"
}, B.borderBottomStyle = {
  property: "borderBottomStyle",
  scale: "borderStyles"
}, B.borderBottomLeftRadius = {
  property: "borderBottomLeftRadius",
  scale: "radii"
}, B.borderBottomRightRadius = {
  property: "borderBottomRightRadius",
  scale: "radii"
}, B.borderLeftWidth = {
  property: "borderLeftWidth",
  scale: "borderWidths"
}, B.borderLeftColor = {
  property: "borderLeftColor",
  scale: "colors"
}, B.borderLeftStyle = {
  property: "borderLeftStyle",
  scale: "borderStyles"
}, B.borderRightWidth = {
  property: "borderRightWidth",
  scale: "borderWidths"
}, B.borderRightColor = {
  property: "borderRightColor",
  scale: "colors"
}, B.borderRightStyle = {
  property: "borderRightStyle",
  scale: "borderStyles"
};
var N = x(B),
    I = {
  background: !0,
  backgroundImage: !0,
  backgroundSize: !0,
  backgroundPosition: !0,
  backgroundRepeat: !0
};
I.bgImage = I.backgroundImage, I.bgSize = I.backgroundSize, I.bgPosition = I.backgroundPosition, I.bgRepeat = I.backgroundRepeat;

var z = x(I),
    j = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
},
    U = x({
  position: !0,
  zIndex: {
    property: "zIndex",
    scale: "zIndices"
  },
  top: {
    property: "top",
    scale: "space",
    defaultScale: j.space
  },
  right: {
    property: "right",
    scale: "space",
    defaultScale: j.space
  },
  bottom: {
    property: "bottom",
    scale: "space",
    defaultScale: j.space
  },
  left: {
    property: "left",
    scale: "space",
    defaultScale: j.space
  }
}),
    P = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
},
    H = function H(r) {
  return "number" == typeof r && !isNaN(r);
},
    V = function V(r, e) {
  if (!H(r)) return v(e, r, r);
  var t = r < 0,
      n = Math.abs(r),
      o = v(e, n, n);
  return H(o) ? o * (t ? -1 : 1) : t ? "-" + o : o;
},
    G = {};

G.margin = {
  margin: {
    property: "margin",
    scale: "space",
    transform: V,
    defaultScale: P.space
  },
  marginTop: {
    property: "marginTop",
    scale: "space",
    transform: V,
    defaultScale: P.space
  },
  marginRight: {
    property: "marginRight",
    scale: "space",
    transform: V,
    defaultScale: P.space
  },
  marginBottom: {
    property: "marginBottom",
    scale: "space",
    transform: V,
    defaultScale: P.space
  },
  marginLeft: {
    property: "marginLeft",
    scale: "space",
    transform: V,
    defaultScale: P.space
  },
  marginX: {
    properties: ["marginLeft", "marginRight"],
    scale: "space",
    transform: V,
    defaultScale: P.space
  },
  marginY: {
    properties: ["marginTop", "marginBottom"],
    scale: "space",
    transform: V,
    defaultScale: P.space
  }
}, G.margin.m = G.margin.margin, G.margin.mt = G.margin.marginTop, G.margin.mr = G.margin.marginRight, G.margin.mb = G.margin.marginBottom, G.margin.ml = G.margin.marginLeft, G.margin.mx = G.margin.marginX, G.margin.my = G.margin.marginY, G.padding = {
  padding: {
    property: "padding",
    scale: "space",
    defaultScale: P.space
  },
  paddingTop: {
    property: "paddingTop",
    scale: "space",
    defaultScale: P.space
  },
  paddingRight: {
    property: "paddingRight",
    scale: "space",
    defaultScale: P.space
  },
  paddingBottom: {
    property: "paddingBottom",
    scale: "space",
    defaultScale: P.space
  },
  paddingLeft: {
    property: "paddingLeft",
    scale: "space",
    defaultScale: P.space
  },
  paddingX: {
    properties: ["paddingLeft", "paddingRight"],
    scale: "space",
    defaultScale: P.space
  },
  paddingY: {
    properties: ["paddingTop", "paddingBottom"],
    scale: "space",
    defaultScale: P.space
  }
}, G.padding.p = G.padding.padding, G.padding.pt = G.padding.paddingTop, G.padding.pr = G.padding.paddingRight, G.padding.pb = G.padding.paddingBottom, G.padding.pl = G.padding.paddingLeft, G.padding.px = G.padding.paddingX, G.padding.py = G.padding.paddingY;
S(x(G.margin), x(G.padding));
var W = x({
  boxShadow: {
    property: "boxShadow",
    scale: "shadows"
  },
  textShadow: {
    property: "textShadow",
    scale: "shadows"
  }
});

function _() {
  return (_ = Object.assign || function (r) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];

      for (var n in t) {
        Object.prototype.hasOwnProperty.call(t, n) && (r[n] = t[n]);
      }
    }

    return r;
  }).apply(this, arguments);
}

var F = function F(r, e, t, n, o) {
  for (e = e && e.split ? e.split(".") : [e], n = 0; n < e.length; n++) {
    r = r ? r[e[n]] : o;
  }

  return r === o ? t : r;
},
    M = [40, 52, 64].map(function (r) {
  return r + "em";
}),
    Y = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
},
    $ = {
  bg: "backgroundColor",
  m: "margin",
  mt: "marginTop",
  mr: "marginRight",
  mb: "marginBottom",
  ml: "marginLeft",
  mx: "marginX",
  my: "marginY",
  p: "padding",
  pt: "paddingTop",
  pr: "paddingRight",
  pb: "paddingBottom",
  pl: "paddingLeft",
  px: "paddingX",
  py: "paddingY"
},
    X = {
  marginX: ["marginLeft", "marginRight"],
  marginY: ["marginTop", "marginBottom"],
  paddingX: ["paddingLeft", "paddingRight"],
  paddingY: ["paddingTop", "paddingBottom"],
  size: ["width", "height"]
},
    Z = {
  color: "colors",
  backgroundColor: "colors",
  borderColor: "colors",
  margin: "space",
  marginTop: "space",
  marginRight: "space",
  marginBottom: "space",
  marginLeft: "space",
  marginX: "space",
  marginY: "space",
  padding: "space",
  paddingTop: "space",
  paddingRight: "space",
  paddingBottom: "space",
  paddingLeft: "space",
  paddingX: "space",
  paddingY: "space",
  top: "space",
  right: "space",
  bottom: "space",
  left: "space",
  gridGap: "space",
  gridColumnGap: "space",
  gridRowGap: "space",
  gap: "space",
  columnGap: "space",
  rowGap: "space",
  fontFamily: "fonts",
  fontSize: "fontSizes",
  fontWeight: "fontWeights",
  lineHeight: "lineHeights",
  letterSpacing: "letterSpacings",
  border: "borders",
  borderTop: "borders",
  borderRight: "borders",
  borderBottom: "borders",
  borderLeft: "borders",
  borderWidth: "borderWidths",
  borderStyle: "borderStyles",
  borderRadius: "radii",
  borderTopRightRadius: "radii",
  borderTopLeftRadius: "radii",
  borderBottomRightRadius: "radii",
  borderBottomLeftRadius: "radii",
  borderTopWidth: "borderWidths",
  borderTopColor: "colors",
  borderTopStyle: "borderStyles",
  borderBottomWidth: "borderWidths",
  borderBottomColor: "colors",
  borderBottomStyle: "borderStyles",
  borderLeftWidth: "borderWidths",
  borderLeftColor: "colors",
  borderLeftStyle: "borderStyles",
  borderRightWidth: "borderWidths",
  borderRightColor: "colors",
  borderRightStyle: "borderStyles",
  outlineColor: "colors",
  boxShadow: "shadows",
  textShadow: "shadows",
  zIndex: "zIndices",
  width: "sizes",
  minWidth: "sizes",
  maxWidth: "sizes",
  height: "sizes",
  minHeight: "sizes",
  maxHeight: "sizes",
  flexBasis: "sizes",
  size: "sizes",
  fill: "colors",
  stroke: "colors"
},
    J = function J(r, e) {
  if ("number" != typeof e || e >= 0) return F(r, e, e);
  var t = Math.abs(e),
      n = F(r, t, t);
  return "string" == typeof n ? "-" + n : -1 * n;
},
    K = ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "top", "bottom", "left", "right"].reduce(function (r, e) {
  var t;
  return _({}, r, ((t = {})[e] = J, t));
}, {}),
    Q = function r(e) {
  return function (t) {
    void 0 === t && (t = {});

    var n = _({}, Y, {}, t.theme || t),
        o = {},
        i = function (r) {
      return function (e) {
        var t = {},
            n = F(e, "breakpoints", M),
            o = [null].concat(n.map(function (r) {
          return "@media screen and (min-width: " + r + ")";
        }));

        for (var i in r) {
          var a = "function" == typeof r[i] ? r[i](e) : r[i];
          if (null != a) if (Array.isArray(a)) for (var l = 0; l < a.slice(0, o.length).length; l++) {
            var s = o[l];
            s ? (t[s] = t[s] || {}, null != a[l] && (t[s][i] = a[l])) : t[i] = a[l];
          } else t[i] = a;
        }

        return t;
      };
    }("function" == typeof e ? e(n) : e)(n);

    for (var a in i) {
      var l = i[a],
          s = "function" == typeof l ? l(n) : l;
      if ("variant" !== a) {
        if (s && "object" == typeof s) o[a] = r(s)(n);else {
          var c = F($, a, a),
              u = F(Z, c),
              p = F(n, u, F(n, c, {})),
              f = F(K, c, F)(p, s, s);
          if (X[c]) for (var d = X[c], g = 0; g < d.length; g++) {
            o[d[g]] = f;
          } else o[c] = f;
        }
      } else o = _({}, o, {}, r(F(n, s))(n));
    }

    return o;
  };
},
    rr = function rr(r) {
  var e,
      t,
      n = r.scale,
      o = r.prop,
      i = void 0 === o ? "variant" : o,
      a = r.variants,
      l = void 0 === a ? {} : a,
      s = r.key;
  (t = Object.keys(l).length ? function (r, e, t) {
    return Q(v(e, r, null))(t.theme);
  } : function (r, e) {
    return v(e, r, null);
  }).scale = n || s, t.defaults = l;
  var c = ((e = {})[i] = t, e);
  return w(c);
},
    er = (rr({
  key: "buttons"
}), rr({
  key: "textStyles",
  prop: "textStyle"
}), rr({
  key: "colorStyles",
  prop: "colors"
}), function (r) {
  var e = r.prop,
      t = r.cssProperty,
      n = r.alias,
      o = r.key,
      i = r.transformValue,
      a = r.scale,
      l = r.properties,
      s = {};
  return s[e] = A({
    properties: l,
    property: t || e,
    scale: o,
    defaultScale: a,
    transform: i
  }), n && (s[n] = s[e]), w(s);
}),
    tr = [].concat(["width", "height", "p", "pt", "pr", "pb", "pl", "px", "py", "m", "mt", "mr", "mb", "ml", "mx", "my", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "nmt", "nm", "nmr", "nmb", "nml", "nmx", "nmy", "nmargin", "nmarginTop", "nmarginRight", "nmarginBottom", "nmarginLeft", "nmarginX", "nmarginY"], ["color", "bg"], ["fontFamily", "fontSize", "fontWeight", "lineHeight", "letterSpacing", "textAlign", "fontStyle"], ["width", "height", "display", "minWidth", "minHeight", "maxWidth", "maxHeight", "size", "verticalAlign", "overflow", "overflowX", "overflowY"], ["alignItems", "alignContent", "justifyItems", "justifyContent", "flexWrap", "flexDirection", "flex", "flexGrow", "flexShrink", "flexBasis", "justifySelf", "alignSelf", "order"], ["gridGap", "gridColumnGap", "gridRowGap", "gridColumn", "gridRow", "gridAutoFlow", "gridAutoColumns", "gridAutoRows", "gridTemplateColumns", "gridTemplateRows", "gridTemplateAreas", "gridArea"], ["backgroundImage", "backgroundSize", "backgroundPosition", "backgroundRepeat"], ["border", "borderWidth", "borderStyle", "borderColor", "borderRadius", "borderTop", "borderTopWidth", "borderTopStyle", "borderTopColor", "borderTopLeftRadius", "borderTopRightRadius", "borderRight", "borderRightWidth", "borderRightStyle", "borderRightColor", "borderBottom", "borderBottomWidth", "borderBottomStyle", "borderBottomColor", "borderBottomLeftRadius", "borderBottomRightRadius", "borderLeft", "borderLeftWidth", "borderLeftStyle", "borderLeftColor", "borderX", "borderY"], ["position", "zIndex", "top", "righ", "bottom", "left"], ["textShadow", "boxShadow"]),
    nr = o.div.withConfig({
  shouldForwardProp: function shouldForwardProp(r, e) {
    return ![].concat(tr).includes(r);
  }
})(S(z, N, T, S, C, O, E, U, W, x, R), x({
  p: {
    property: "padding",
    scale: "spacing"
  },
  pt: {
    property: "paddingTop",
    scale: "spacing"
  },
  pr: {
    property: "paddingRight",
    scale: "spacing"
  },
  pb: {
    property: "paddingBottom",
    scale: "spacing"
  },
  pl: {
    property: "paddingLeft",
    scale: "spacing"
  },
  px: {
    properties: ["paddingLeft", "paddingRight"],
    scale: "spacing"
  },
  py: {
    properties: ["paddingTop", "paddingBottom"],
    scale: "spacing"
  },
  m: {
    property: "margin",
    scale: "spacing",
    defaultScale: "spacing"
  },
  mt: {
    property: "marginTop",
    scale: "spacing"
  },
  mr: {
    property: "marginRight",
    scale: "spacing"
  },
  mb: {
    property: "marginBottom",
    scale: "spacing"
  },
  ml: {
    property: "marginLeft",
    scale: "spacing"
  },
  mx: {
    properties: ["marginLeft", "marginRight"],
    scale: "spacing"
  },
  my: {
    properties: ["marginTop", "marginBottom"],
    scale: "spacing"
  },
  padding: {
    property: "padding",
    scale: "spacing"
  },
  paddingTop: {
    property: "paddingTop",
    scale: "spacing"
  },
  paddingRight: {
    property: "paddingRight",
    scale: "spacing"
  },
  paddingBottom: {
    property: "paddingBottom",
    scale: "spacing"
  },
  paddingLeft: {
    property: "paddingLeft",
    scale: "spacing"
  },
  paddingX: {
    properties: ["paddingLeft", "paddingRight"],
    scale: "spacing"
  },
  paddingY: {
    properties: ["paddingTop", "paddingBottom"],
    scale: "spacing"
  },
  margin: {
    property: "margin",
    scale: "spacing",
    defaultScale: "spacing"
  },
  marginTop: {
    property: "marginTop",
    scale: "spacing"
  },
  marginRight: {
    property: "marginRight",
    scale: "spacing"
  },
  marginBottom: {
    property: "marginBottom",
    scale: "spacing"
  },
  marginLeft: {
    property: "marginLeft",
    scale: "spacing"
  },
  marginX: {
    properties: ["marginLeft", "marginRight"],
    scale: "spacing"
  },
  marginY: {
    properties: ["marginTop", "marginBottom"],
    scale: "spacing"
  },
  nm: {
    property: "margin",
    scale: "negateSpacing",
    defaultScale: "negateSpacing"
  },
  nmt: {
    property: "marginTop",
    scale: "negateSpacing"
  },
  nmr: {
    property: "marginRight",
    scale: "negateSpacing"
  },
  nmb: {
    property: "marginBottom",
    scale: "negateSpacing"
  },
  nml: {
    property: "marginLeft",
    scale: "negateSpacing"
  },
  nmx: {
    properties: ["marginLeft", "marginRight"],
    scale: "negateSpacing"
  },
  nmy: {
    properties: ["marginTop", "marginBottom"],
    scale: "negateSpacing"
  },
  nmargin: {
    property: "margin",
    scale: "negateSpacing",
    defaultScale: "spacing"
  },
  nmarginTop: {
    property: "marginTop",
    scale: "negateSpacing"
  },
  nmarginRight: {
    property: "marginRight",
    scale: "negateSpacing"
  },
  nmarginBottom: {
    property: "marginBottom",
    scale: "negateSpacing"
  },
  nmarginLeft: {
    property: "marginLeft",
    scale: "negateSpacing"
  },
  nmarginX: {
    properties: ["marginLeft", "marginRight"],
    scale: "negateSpacing"
  },
  nmarginY: {
    properties: ["marginTop", "marginBottom"],
    scale: "negateSpacing"
  }
}));

function or(r, e) {
  return r(e = {
    exports: {}
  }, e.exports), e.exports;
}

function ir(r) {
  return r && r.default || r;
}

function ar() {}

function lr() {}

lr.resetWarningCache = ar;
var sr,
    cr = or(function (r) {
  r.exports = function () {
    function r(r, e, t, n, o, i) {
      if ("SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED" !== i) {
        var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw a.name = "Invariant Violation", a;
      }
    }

    function e() {
      return r;
    }

    r.isRequired = r;
    var t = {
      array: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: e,
      element: r,
      elementType: r,
      instanceOf: e,
      node: r,
      objectOf: e,
      oneOf: e,
      oneOfType: e,
      shape: e,
      exact: e,
      checkPropTypes: lr,
      resetWarningCache: ar
    };
    return t.PropTypes = t, t;
  }();
}),
    ur = er({
  prop: "caps",
  cssProperty: "textTransform",
  transformValue: function transformValue(r) {
    return r ? "uppercase" : "unset";
  }
}),
    pr = er({
  prop: "truncate",
  cssProperty: "textOverflow",
  transformValue: function transformValue(r) {
    return r ? "ellipsis" : "unset";
  }
}),
    fr = er({
  prop: "truncate",
  cssProperty: "display",
  transformValue: function transformValue(r) {
    return r ? "block" : "inherit";
  }
}),
    dr = er({
  prop: "truncate",
  cssProperty: "whiteSpace",
  transformValue: function transformValue(r) {
    return r ? "nowrap" : "wrap";
  }
}),
    gr = er({
  prop: "truncate",
  cssProperty: "overflow",
  transformValue: function transformValue(r) {
    return r ? "hidden" : "visible";
  }
}),
    hr = o(nr).withConfig({
  shouldForwardProp: function shouldForwardProp(r, e) {
    return !["crop", "textStyle", "truncate", "caps", "weight", "wordBreak"].includes(r);
  }
}).attrs(function (r) {
  return {
    as: r.as || "span"
  };
})(sr || (sr = c(["\n  ", "\n\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  /*\n  Elimina (al poner content:unset) los pseudoelementos si el usuario no\n  establece crop, topCrop o bottomCrop.\n  */\n  ", "\n\n  /* bottomCrop corta solo la parte inferior */\n  ", "\n\n  /* topCrop corta solo la parte superior */\n  ", "\n\n"])), function (r) {
  return r.textStyle && r.theme.textStyle[r.textStyle];
}, x({
  weight: {
    property: "fontWeight",
    scale: "fontWeight"
  }
}), pr, fr, dr, gr, ur, function (r) {
  return !r.crop && !r.topCrop && !r.bottomCrop && n.css(["&::after,&:before{content:unset;margin-top:0;margin-bottom:0;}"]);
}, function (r) {
  return r.bottomCrop && !r.topCrop && n.css(["&::before{content:unset;margin-top:0;margin-bottom:0;}"]);
}, function (r) {
  return r.topCrop && !r.bottomCrop && n.css(["&::after{content:unset;margin-top:0;margin-bottom:0;}"]);
});
hr.propTypes = {
  textStyle: cr.string,
  caps: cr.bool,
  fontWeight: cr.string,
  truncate: cr.bool,
  crop: cr.bool
};

var mr,
    br,
    yr = o(nr).withConfig({
  componentId: "sc-1exdzm0-0"
})(["cursor:", ";&:focus{color:", ";}"], function (r) {
  return r._css;
}, function (r) {
  return r.theme.color.linkHover01;
}),
    vr = o(nr).attrs(function (r) {
  return {
    display: r.display || "flex"
  };
})(mr || (mr = c([""]))),
    wr = function wr(r, e) {
  var t = r.split(".");
  return t[t.length - 1] = e, t.join(".");
};

var kr,
    qr,
    Ar,
    xr,
    Sr,
    Er,
    Lr,
    Tr,
    Rr = n.createGlobalStyle(br || (br = c(["\n  ", "\n\n  html,\n\n  body {\n    font-family: ", ";\n    line-height: ", ";\n    font-family: ", ";\n    background-color: ", ";\n    color: ", ";\n    -webkit-font-smoothing: antialiased;\n  }\n\n  * {\n    box-sizing: border-box;\n  }\n\n  ol,\n  ul,\n  li {\n    margin: 0;\n    padding: 0;\n  }\n\n  li {\n    list-style: none;\n  }\n\n  img {\n    display: block;\n    width: 100%;\n  }\n\n  a {\n    text-decoration: none;\n  }\n"])), [(kr = {
  html: {
    lineHeight: "1.15",
    textSizeAdjust: "100%"
  },
  body: {
    margin: "0"
  },
  main: {
    display: "block"
  },
  h1: {
    fontSize: "2em",
    margin: "0.67em 0"
  },
  hr: {
    boxSizing: "content-box",
    height: "0",
    overflow: "visible"
  },
  pre: {
    fontFamily: "monospace, monospace",
    fontSize: "1em"
  },
  a: {
    backgroundColor: "transparent"
  },
  "abbr[title]": {
    borderBottom: "none",
    textDecoration: "underline"
  }
}, kr["b,\n    strong"] = {
  fontWeight: "bolder"
}, kr["code,\n    kbd,\n    samp"] = {
  fontFamily: "monospace, monospace",
  fontSize: "1em"
}, kr.small = {
  fontSize: "80%"
}, kr["sub,\n    sup"] = {
  fontSize: "75%",
  lineHeight: "0",
  position: "relative",
  verticalAlign: "baseline"
}, kr.sub = {
  bottom: "-0.25em"
}, kr.sup = {
  top: "-0.5em"
}, kr.img = {
  borderStyle: "none"
}, kr["button,\n    input,\n    optgroup,\n    select,\n    textarea"] = {
  fontFamily: "inherit",
  fontSize: "100%",
  lineHeight: "1.15",
  margin: "0"
}, kr["button,\n    input"] = {
  overflow: "visible"
}, kr["button,\n    select"] = {
  textTransform: "none"
}, kr['button,\n    html [type="button"],\n    [type="reset"],\n    [type="submit"]'] = {
  WebkitAppearance: "button"
}, kr['button::-moz-focus-inner,\n    [type="button"]::-moz-focus-inner,\n    [type="reset"]::-moz-focus-inner,\n    [type="submit"]::-moz-focus-inner'] = {
  borderStyle: "none",
  padding: "0"
}, kr['button:-moz-focusring,\n    [type="button"]:-moz-focusring,\n    [type="reset"]:-moz-focusring,\n    [type="submit"]:-moz-focusring'] = {
  outline: "1px dotted ButtonText"
}, kr.fieldset = {
  padding: "0.35em 0.625em 0.75em"
}, kr.legend = {
  boxSizing: "border-box",
  color: "inherit",
  display: "table",
  maxWidth: "100%",
  padding: "0",
  whiteSpace: "normal"
}, kr.progress = {
  verticalAlign: "baseline"
}, kr.textarea = {
  overflow: "auto"
}, kr['[type="checkbox"],\n    [type="radio"]'] = {
  boxSizing: "border-box",
  padding: "0"
}, kr['[type="number"]::-webkit-inner-spin-button,\n    [type="number"]::-webkit-outer-spin-button'] = {
  height: "auto"
}, kr['[type="search"]'] = {
  WebkitAppearance: "textfield",
  outlineOffset: "-2px"
}, kr['[type="search"]::-webkit-search-decoration'] = {
  WebkitAppearance: "none"
}, kr["::-webkit-file-upload-button"] = {
  WebkitAppearance: "button",
  font: "inherit"
}, kr.details = {
  display: "block"
}, kr.summary = {
  display: "list-item"
}, kr.template = {
  display: "none"
}, kr["[hidden]"] = {
  display: "none"
}, kr), {
  "abbr[title]": {
    textDecoration: "underline dotted"
  }
}], function (r) {
  return r.theme.fontFamily.primary;
}, function (r) {
  return r.theme.lineHeightBase;
}, function (r) {
  return r.theme.fontFamily.primary;
}, function (r) {
  return r.theme.color.ui02;
}, function (r) {
  return r.theme.color.text01;
}),
    Cr = o(hr)(qr || (qr = c(["\n  display: block;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"]))),
    Dr = o(vr).withConfig({
  shouldForwardProp: function shouldForwardProp(r) {
    return !["verticalSpace", "vs", "space", "s", "horizontalSpace", "hs"].includes(r);
  }
})(Ar || (Ar = c(["\n  /* SHAME: Margen negativo para contrarestar el margen inferior de los hijos.*/\n  ", "\n\n  & > * {\n    ", "\n\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n"])), x({
  verticalSpace: {
    property: "marginBottom",
    scale: "negateSpacing"
  },
  vs: {
    property: "marginBottom",
    scale: "negateSpacing"
  },
  space: {
    properties: ["marginBottom", "marginRight"],
    scale: "negateSpacing"
  },
  s: {
    properties: ["marginBottom", "marginRight"],
    scale: "negateSpacing"
  }
}), x({
  hs: {
    property: "marginRight",
    scale: "spacing"
  },
  vs: {
    property: "marginBottom",
    scale: "spacing"
  },
  s: {
    properties: ["marginBottom", "marginRight"],
    scale: "spacing"
  },
  horizontalSpace: {
    property: "marginRight",
    scale: "spacing"
  },
  verticalSpace: {
    property: "marginBottom",
    scale: "spacing"
  },
  space: {
    properties: ["marginBottom", "marginRight"],
    scale: "spacing"
  }
})),
    Or = ["hs", "vs", "vsr", "hsr"],
    Br = o(vr).withConfig({
  shouldForwardProp: function shouldForwardProp(r) {
    return !Or.includes(r);
  }
})(xr || (xr = c(["\n  & > * + * {\n    ", "\n  }\n"])), x({
  vsr: {
    property: "marginBottom",
    scale: "spacing"
  },
  vs: {
    property: "marginTop",
    scale: "spacing"
  },
  hs: {
    property: "marginLeft",
    scale: "spacing"
  },
  hsr: {
    property: "marginRight",
    scale: "spacing"
  }
})),
    Nr = er({
  prop: "cols",
  cssProperty: "width",
  transformValue: function transformValue(r) {
    return 100 / r + "%";
  }
}),
    Ir = o(nr).withConfig({
  shouldForwardProp: function shouldForwardProp(r) {
    return !["cols", "s", "vs", "hs"].includes(r);
  }
})(Sr || (Sr = c(["\n  /* Este height es para que podamos poner height: 100% o align-items: stretch\n  en los cards y así ocupen todo el alto independientemente del contenido del\n  card */\n  ", "\n\n  & > div {\n    height: 100%;\n  }\n\n  ", "\n"])), Nr, x({
  s: {
    properties: ["paddingTop", "paddingLeft"],
    scale: "spacing"
  },
  vs: {
    property: "paddingTop",
    scale: "spacing"
  },
  hs: {
    property: "paddingLeft",
    scale: "spacing"
  }
})),
    zr = o(vr).withConfig({
  shouldForwardProp: function shouldForwardProp(r) {
    return !["s", "vs", "hs"].includes(r);
  }
})(Er || (Er = c(["\n  ", "\n"])), x({
  s: {
    properties: ["marginTop", "marginLeft"],
    scale: "spacing",
    transform: function transform(r, e) {
      return void 0 !== e[r] ? "-" + e[r] : "-" + r;
    }
  },
  vs: {
    property: "marginTop",
    scale: "spacing",
    transform: function transform(r, e) {
      return void 0 !== e[r] ? "-" + e[r] : "-" + r;
    }
  },
  hs: {
    property: "marginLeft",
    scale: "spacing",
    transform: function transform(r, e) {
      return void 0 !== e[r] ? "-" + e[r] : "-" + r;
    }
  }
})),
    jr = ["s", "vs", "hs"],
    Ur = o(nr).withConfig({
  shouldForwardProp: function shouldForwardProp(r) {
    return !jr.includes(r);
  }
})(Lr || (Lr = c(["\n  ", "\n"])), x({
  s: {
    properties: ["paddingTop", "paddingLeft"],
    scale: "spacing"
  },
  vs: {
    property: "paddingTop",
    scale: "spacing"
  },
  hs: {
    property: "paddingLeft",
    scale: "spacing"
  }
})),
    Pr = o(nr).attrs(function (r) {
  return {
    as: r.as || "button"
  };
})(Tr || (Tr = c(["\n  cursor: pointer;\n  ", "\n"])), function (r) {
  return r.loading && n.css(["cursor:progress;"]);
}),
    Hr = function Hr() {
  for (var r = {}, e = 0; e < arguments.length; e++) {
    var t = arguments[e];

    for (var n in t) {
      Vr.call(t, n) && (r[n] = t[n]);
    }
  }

  return r;
},
    Vr = Object.prototype.hasOwnProperty;

var Gr = Object.prototype.hasOwnProperty,
    Wr = Object.prototype.toString,
    _r = Object.defineProperty,
    Fr = Object.getOwnPropertyDescriptor,
    Mr = function Mr(r) {
  return "function" == typeof Array.isArray ? Array.isArray(r) : "[object Array]" === Wr.call(r);
},
    Yr = function Yr(r) {
  if (!r || "[object Object]" !== Wr.call(r)) return !1;
  var e,
      t = Gr.call(r, "constructor"),
      n = r.constructor && r.constructor.prototype && Gr.call(r.constructor.prototype, "isPrototypeOf");
  if (r.constructor && !t && !n) return !1;

  for (e in r) {
    ;
  }

  return void 0 === e || Gr.call(r, e);
},
    $r = function $r(r, e) {
  _r && "__proto__" === e.name ? _r(r, e.name, {
    enumerable: !0,
    configurable: !0,
    value: e.newValue,
    writable: !0
  }) : r[e.name] = e.newValue;
},
    Xr = function Xr(r, e) {
  if ("__proto__" === e) {
    if (!Gr.call(r, e)) return;
    if (Fr) return Fr(r, e).value;
  }

  return r[e];
},
    Zr = function r() {
  var e,
      t,
      n,
      o,
      i,
      a,
      l = arguments[0],
      s = 1,
      c = arguments.length,
      u = !1;

  for ("boolean" == typeof l && (u = l, l = arguments[1] || {}, s = 2), (null == l || "object" != typeof l && "function" != typeof l) && (l = {}); s < c; ++s) {
    if (null != (e = arguments[s])) for (t in e) {
      n = Xr(l, t), l !== (o = Xr(e, t)) && (u && o && (Yr(o) || (i = Mr(o))) ? (i ? (i = !1, a = n && Mr(n) ? n : []) : a = n && Yr(n) ? n : {}, $r(l, {
        name: t,
        newValue: r(u, a, o)
      })) : void 0 !== o && $r(l, {
        name: t,
        newValue: o
      }));
    }
  }

  return l;
},
    Jr = function Jr(r) {
  if (r) throw r;
};

var Kr = {}.hasOwnProperty,
    Qr = function Qr(r) {
  if (!r || "object" != typeof r) return null;
  if (Kr.call(r, "position") || Kr.call(r, "type")) return ee(r.position);
  if (Kr.call(r, "start") || Kr.call(r, "end")) return ee(r);
  if (Kr.call(r, "line") || Kr.call(r, "column")) return re(r);
  return null;
};

function re(r) {
  return r && "object" == typeof r || (r = {}), te(r.line) + ":" + te(r.column);
}

function ee(r) {
  return r && "object" == typeof r || (r = {}), re(r.start) + "-" + re(r.end);
}

function te(r) {
  return r && "number" == typeof r ? r : 1;
}

var ne = ae;

function oe() {}

oe.prototype = Error.prototype, ae.prototype = new oe();
var ie = ae.prototype;

function ae(r, e, t) {
  var n, o, i;
  "string" == typeof e && (t = e, e = null), n = function (r) {
    var e,
        t = [null, null];
    "string" == typeof r && (-1 === (e = r.indexOf(":")) ? t[1] = r : (t[0] = r.slice(0, e), t[1] = r.slice(e + 1)));
    return t;
  }(t), o = Qr(e) || "1:1", i = {
    start: {
      line: null,
      column: null
    },
    end: {
      line: null,
      column: null
    }
  }, e && e.position && (e = e.position), e && (e.start ? (i = e, e = e.start) : i.start = e), r.stack && (this.stack = r.stack, r = r.message), this.message = r, this.name = o, this.reason = r, this.line = e ? e.line : null, this.column = e ? e.column : null, this.location = i, this.source = n[0], this.ruleId = n[1];
}

ie.file = "", ie.name = "", ie.reason = "", ie.message = "", ie.stack = "", ie.fatal = null, ie.column = null, ie.line = null;

var le = function le(r, e) {
  if ("string" != typeof r) return r;
  if (0 === r.length) return r;
  var t = i.basename(r, i.extname(r)) + e;
  return i.join(i.dirname(r), t);
},
    se = function se(r) {
  return null != r && (ce(r) || function (r) {
    return "function" == typeof r.readFloatLE && "function" == typeof r.slice && ce(r.slice(0, 0));
  }(r) || !!r._isBuffer);
};
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */


function ce(r) {
  return !!r.constructor && "function" == typeof r.constructor.isBuffer && r.constructor.isBuffer(r);
}

var ue = ge,
    pe = {}.hasOwnProperty,
    fe = ge.prototype;

fe.toString = function (r) {
  var e = this.contents || "";
  return se(e) ? e.toString(r) : String(e);
};

var de = ["history", "path", "basename", "stem", "extname", "dirname"];

function ge(r) {
  var e, t, n;

  if (r) {
    if ("string" == typeof r || se(r)) r = {
      contents: r
    };else if ("message" in r && "messages" in r) return r;
  } else r = {};

  if (!(this instanceof ge)) return new ge(r);

  for (this.data = {}, this.messages = [], this.history = [], this.cwd = process.cwd(), t = -1, n = de.length; ++t < n;) {
    e = de[t], pe.call(r, e) && (this[e] = r[e]);
  }

  for (e in r) {
    -1 === de.indexOf(e) && (this[e] = r[e]);
  }
}

function he(r, e) {
  if (-1 !== r.indexOf(i.sep)) throw new Error("`" + e + "` cannot be a path: did not expect `" + i.sep + "`");
}

function me(r, e) {
  if (!r) throw new Error("`" + e + "` cannot be empty");
}

function be(r, e) {
  if (!r) throw new Error("Setting `" + e + "` requires `path` to be set too");
}

Object.defineProperty(fe, "path", {
  get: function get() {
    return this.history[this.history.length - 1];
  },
  set: function set(r) {
    me(r, "path"), r !== this.path && this.history.push(r);
  }
}), Object.defineProperty(fe, "dirname", {
  get: function get() {
    return "string" == typeof this.path ? i.dirname(this.path) : void 0;
  },
  set: function set(r) {
    be(this.path, "dirname"), this.path = i.join(r || "", this.basename);
  }
}), Object.defineProperty(fe, "basename", {
  get: function get() {
    return "string" == typeof this.path ? i.basename(this.path) : void 0;
  },
  set: function set(r) {
    me(r, "basename"), he(r, "basename"), this.path = i.join(this.dirname || "", r);
  }
}), Object.defineProperty(fe, "extname", {
  get: function get() {
    return "string" == typeof this.path ? i.extname(this.path) : void 0;
  },
  set: function set(r) {
    var e = r || "";

    if (he(e, "extname"), be(this.path, "extname"), e) {
      if ("." !== e.charAt(0)) throw new Error("`extname` must start with `.`");
      if (-1 !== e.indexOf(".", 1)) throw new Error("`extname` cannot contain multiple dots");
    }

    this.path = le(this.path, e);
  }
}), Object.defineProperty(fe, "stem", {
  get: function get() {
    return "string" == typeof this.path ? i.basename(this.path, this.extname) : void 0;
  },
  set: function set(r) {
    me(r, "stem"), he(r, "stem"), this.path = i.join(this.dirname || "", r + (this.extname || ""));
  }
});
var ye = ue,
    ve = ue.prototype;

function we(r, e, t) {
  var n = this.path,
      o = new ne(r, e, t);
  return n && (o.name = n + ":" + o.name, o.file = n), o.fatal = !1, this.messages.push(o), o;
}

ve.message = we, ve.info = function () {
  var r = this.message.apply(this, arguments);
  return r.fatal = null, r;
}, ve.fail = function () {
  var r = this.message.apply(this, arguments);
  throw r.fatal = !0, r;
}, ve.warn = we;

var ke = [].slice,
    qe = function qe(r, e) {
  var t;
  return function () {
    var e,
        i = ke.call(arguments, 0),
        a = r.length > i.length;
    a && i.push(n);

    try {
      e = r.apply(null, i);
    } catch (r) {
      if (a && t) throw r;
      return n(r);
    }

    a || (e && "function" == typeof e.then ? e.then(o, n) : e instanceof Error ? n(e) : o(e));
  };

  function n() {
    t || (t = !0, e.apply(null, arguments));
  }

  function o(r) {
    n(null, r);
  }
};

var Ae = Se;
Se.wrap = qe;
var xe = [].slice;

function Se() {
  var r = [],
      e = {
    run: function run() {
      var e = -1,
          t = xe.call(arguments, 0, -1),
          n = arguments[arguments.length - 1];
      if ("function" != typeof n) throw new Error("Expected function as last argument, not " + n);

      function o(i) {
        var a = r[++e],
            l = xe.call(arguments, 0),
            s = l.slice(1),
            c = t.length,
            u = -1;
        if (i) n(i);else {
          for (; ++u < c;) {
            null !== s[u] && void 0 !== s[u] || (s[u] = t[u]);
          }

          t = s, a ? qe(a, o).apply(null, t) : n.apply(null, [null].concat(t));
        }
      }

      o.apply(null, [null].concat(t));
    },
    use: function use(t) {
      if ("function" != typeof t) throw new Error("Expected `fn` to be a function, not " + t);
      return r.push(t), e;
    }
  };
  return e;
}

var Ee = Object.prototype.toString,
    Le = function Le(r) {
  return "[object String]" === Ee.call(r);
};

var Te = Object.prototype.toString,
    Re = function Re(r) {
  var e;
  return "[object Object]" === Te.call(r) && (null === (e = Object.getPrototypeOf(r)) || e === Object.getPrototypeOf({}));
},
    Ce = function r() {
  var e = [],
      t = Ae(),
      n = {},
      o = !1,
      i = -1;
  return a.data = function (r, e) {
    if (Le(r)) return 2 === arguments.length ? (je("data", o), n[r] = e, a) : Oe.call(n, r) && n[r] || null;
    if (r) return je("data", o), n = r, a;
    return n;
  }, a.freeze = l, a.attachers = e, a.use = function (r) {
    var t;
    if (je("use", o), null == r) ;else if ("function" == typeof r) u.apply(null, arguments);else {
      if ("object" != typeof r) throw new Error("Expected usable value, not `" + r + "`");
      "length" in r ? c(r) : i(r);
    }
    t && (n.settings = Zr(n.settings || {}, t));
    return a;

    function i(r) {
      c(r.plugins), r.settings && (t = Zr(t || {}, r.settings));
    }

    function l(r) {
      if ("function" == typeof r) u(r);else {
        if ("object" != typeof r) throw new Error("Expected usable value, not `" + r + "`");
        "length" in r ? u.apply(null, r) : i(r);
      }
    }

    function c(r) {
      var e, t;
      if (null == r) ;else {
        if ("object" != typeof r || !("length" in r)) throw new Error("Expected a list of plugins, not `" + r + "`");

        for (e = r.length, t = -1; ++t < e;) {
          l(r[t]);
        }
      }
    }

    function u(r, t) {
      var n = s(r);
      n ? (Re(n[1]) && Re(t) && (t = Zr(n[1], t)), n[1] = t) : e.push(De.call(arguments));
    }
  }, a.parse = function (r) {
    var e,
        t = ye(r);
    if (l(), Ie("parse", e = a.Parser), Ne(e)) return new e(String(t), t).parse();
    return e(String(t), t);
  }, a.stringify = function (r, e) {
    var t,
        n = ye(e);
    if (l(), ze("stringify", t = a.Compiler), Ue(r), Ne(t)) return new t(r, n).compile();
    return t(r, n);
  }, a.run = c, a.runSync = function (r, e) {
    var t,
        n = !1;
    return c(r, e, function (r, e) {
      n = !0, Jr(r), t = e;
    }), Pe("runSync", "run", n), t;
  }, a.process = u, a.processSync = function (r) {
    var e,
        t = !1;
    return l(), Ie("processSync", a.Parser), ze("processSync", a.Compiler), u(e = ye(r), function (r) {
      t = !0, Jr(r);
    }), Pe("processSync", "process", t), e;
  }, a;

  function a() {
    for (var t = r(), o = e.length, i = -1; ++i < o;) {
      t.use.apply(null, e[i]);
    }

    return t.data(Zr(!0, {}, n)), t;
  }

  function l() {
    var r, n, l, s;
    if (o) return a;

    for (; ++i < e.length;) {
      n = (r = e[i])[0], null, !1 !== (l = r[1]) && (!0 === l && (r[1] = void 0), "function" == typeof (s = n.apply(a, r.slice(1))) && t.use(s));
    }

    return o = !0, i = 1 / 0, a;
  }

  function s(r) {
    for (var t, n = e.length, o = -1; ++o < n;) {
      if ((t = e[o])[0] === r) return t;
    }
  }

  function c(r, e, n) {
    if (Ue(r), l(), n || "function" != typeof e || (n = e, e = null), !n) return new Promise(o);

    function o(o, i) {
      t.run(r, ye(e), function (e, t, a) {
        t = t || r, e ? i(e) : o ? o(t) : n(null, t, a);
      });
    }

    o(null, n);
  }

  function u(r, e) {
    if (l(), Ie("process", a.Parser), ze("process", a.Compiler), !e) return new Promise(t);

    function t(t, n) {
      var o = ye(r);
      Be.run(a, {
        file: o
      }, function (r) {
        r ? n(r) : t ? t(o) : e(null, o);
      });
    }

    t(null, e);
  }
}().freeze(),
    De = [].slice,
    Oe = {}.hasOwnProperty,
    Be = Ae().use(function (r, e) {
  e.tree = r.parse(e.file);
}).use(function (r, e, t) {
  r.run(e.tree, e.file, function (r, n, o) {
    r ? t(r) : (e.tree = n, e.file = o, t());
  });
}).use(function (r, e) {
  e.file.contents = r.stringify(e.tree, e.file);
});

function Ne(r) {
  return "function" == typeof r && function (r) {
    var e;

    for (e in r) {
      return !0;
    }

    return !1;
  }(r.prototype);
}

function Ie(r, e) {
  if ("function" != typeof e) throw new Error("Cannot `" + r + "` without `Parser`");
}

function ze(r, e) {
  if ("function" != typeof e) throw new Error("Cannot `" + r + "` without `Compiler`");
}

function je(r, e) {
  if (e) throw new Error(["Cannot invoke `" + r + "` on a frozen processor.\nCreate a new ", "processor first, by invoking it: use `processor()` instead of ", "`processor`."].join(""));
}

function Ue(r) {
  if (!r || !Le(r.type)) throw new Error("Expected node, got `" + r + "`");
}

function Pe(r, e, t) {
  if (!t) throw new Error("`" + r + "` finished async. Use `" + e + "` instead");
}

var He = or(function (r) {
  "function" == typeof Object.create ? r.exports = function (r, e) {
    e && (r.super_ = e, r.prototype = Object.create(e.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : r.exports = function (r, e) {
    if (e) {
      r.super_ = e;

      var t = function t() {};

      t.prototype = e.prototype, r.prototype = new t(), r.prototype.constructor = r;
    }
  };
}),
    Ve = or(function (r) {
  try {
    var e = a;
    if ("function" != typeof e.inherits) throw "";
    r.exports = e.inherits;
  } catch (e) {
    r.exports = He;
  }
}),
    Ge = function Ge(r) {
  var e, t, n;

  for (t in Ve(i, r), Ve(o, i), e = i.prototype) {
    (n = e[t]) && "object" == typeof n && (e[t] = "concat" in n ? n.concat() : Hr(n));
  }

  return i;

  function o(e) {
    return r.apply(this, e);
  }

  function i() {
    return this instanceof i ? r.apply(this, arguments) : new o(arguments);
  }
};

var We = function We(r, e, t) {
  return function () {
    var n = t || this,
        o = n[r];
    return n[r] = !e, function () {
      n[r] = o;
    };
  };
};

var _e = function _e(r) {
  var e = function (r) {
    var e = [],
        t = r.indexOf("\n");

    for (; -1 !== t;) {
      e.push(t + 1), t = r.indexOf("\n", t + 1);
    }

    return e.push(r.length + 1), e;
  }(String(r));

  return {
    toPosition: Fe(e),
    toOffset: Me(e)
  };
};

function Fe(r) {
  return function (e) {
    var t = -1,
        n = r.length;
    if (e < 0) return {};

    for (; ++t < n;) {
      if (r[t] > e) return {
        line: t + 1,
        column: e - (r[t - 1] || 0) + 1,
        offset: e
      };
    }

    return {};
  };
}

function Me(r) {
  return function (e) {
    var t = e && e.line,
        n = e && e.column;
    if (!isNaN(t) && !isNaN(n) && t - 1 in r) return (r[t - 2] || 0) + n - 1 || 0;
    return -1;
  };
}

var Ye = function Ye(r, e) {
  return function (t) {
    var n,
        o = 0,
        i = t.indexOf("\\"),
        a = r[e],
        l = [];

    for (; -1 !== i;) {
      l.push(t.slice(o, i)), o = i + 1, (n = t.charAt(o)) && -1 !== a.indexOf(n) || l.push("\\"), i = t.indexOf("\\", o);
    }

    return l.push(t.slice(o)), l.join("");
  };
};

var $e = {
  AElig: "Æ",
  AMP: "&",
  Aacute: "Á",
  Acirc: "Â",
  Agrave: "À",
  Aring: "Å",
  Atilde: "Ã",
  Auml: "Ä",
  COPY: "©",
  Ccedil: "Ç",
  ETH: "Ð",
  Eacute: "É",
  Ecirc: "Ê",
  Egrave: "È",
  Euml: "Ë",
  GT: ">",
  Iacute: "Í",
  Icirc: "Î",
  Igrave: "Ì",
  Iuml: "Ï",
  LT: "<",
  Ntilde: "Ñ",
  Oacute: "Ó",
  Ocirc: "Ô",
  Ograve: "Ò",
  Oslash: "Ø",
  Otilde: "Õ",
  Ouml: "Ö",
  QUOT: '"',
  REG: "®",
  THORN: "Þ",
  Uacute: "Ú",
  Ucirc: "Û",
  Ugrave: "Ù",
  Uuml: "Ü",
  Yacute: "Ý",
  aacute: "á",
  acirc: "â",
  acute: "´",
  aelig: "æ",
  agrave: "à",
  amp: "&",
  aring: "å",
  atilde: "ã",
  auml: "ä",
  brvbar: "¦",
  ccedil: "ç",
  cedil: "¸",
  cent: "¢",
  copy: "©",
  curren: "¤",
  deg: "°",
  divide: "÷",
  eacute: "é",
  ecirc: "ê",
  egrave: "è",
  eth: "ð",
  euml: "ë",
  frac12: "½",
  frac14: "¼",
  frac34: "¾",
  gt: ">",
  iacute: "í",
  icirc: "î",
  iexcl: "¡",
  igrave: "ì",
  iquest: "¿",
  iuml: "ï",
  laquo: "«",
  lt: "<",
  macr: "¯",
  micro: "µ",
  middot: "·",
  nbsp: " ",
  not: "¬",
  ntilde: "ñ",
  oacute: "ó",
  ocirc: "ô",
  ograve: "ò",
  ordf: "ª",
  ordm: "º",
  oslash: "ø",
  otilde: "õ",
  ouml: "ö",
  para: "¶",
  plusmn: "±",
  pound: "£",
  quot: '"',
  raquo: "»",
  reg: "®",
  sect: "§",
  shy: "­",
  sup1: "¹",
  sup2: "²",
  sup3: "³",
  szlig: "ß",
  thorn: "þ",
  times: "×",
  uacute: "ú",
  ucirc: "û",
  ugrave: "ù",
  uml: "¨",
  uuml: "ü",
  yacute: "ý",
  yen: "¥",
  yuml: "ÿ"
},
    Xe = Object.freeze({
  __proto__: null,
  AElig: "Æ",
  AMP: "&",
  Aacute: "Á",
  Acirc: "Â",
  Agrave: "À",
  Aring: "Å",
  Atilde: "Ã",
  Auml: "Ä",
  COPY: "©",
  Ccedil: "Ç",
  ETH: "Ð",
  Eacute: "É",
  Ecirc: "Ê",
  Egrave: "È",
  Euml: "Ë",
  GT: ">",
  Iacute: "Í",
  Icirc: "Î",
  Igrave: "Ì",
  Iuml: "Ï",
  LT: "<",
  Ntilde: "Ñ",
  Oacute: "Ó",
  Ocirc: "Ô",
  Ograve: "Ò",
  Oslash: "Ø",
  Otilde: "Õ",
  Ouml: "Ö",
  QUOT: '"',
  REG: "®",
  THORN: "Þ",
  Uacute: "Ú",
  Ucirc: "Û",
  Ugrave: "Ù",
  Uuml: "Ü",
  Yacute: "Ý",
  aacute: "á",
  acirc: "â",
  acute: "´",
  aelig: "æ",
  agrave: "à",
  amp: "&",
  aring: "å",
  atilde: "ã",
  auml: "ä",
  brvbar: "¦",
  ccedil: "ç",
  cedil: "¸",
  cent: "¢",
  copy: "©",
  curren: "¤",
  deg: "°",
  divide: "÷",
  eacute: "é",
  ecirc: "ê",
  egrave: "è",
  eth: "ð",
  euml: "ë",
  frac12: "½",
  frac14: "¼",
  frac34: "¾",
  gt: ">",
  iacute: "í",
  icirc: "î",
  iexcl: "¡",
  igrave: "ì",
  iquest: "¿",
  iuml: "ï",
  laquo: "«",
  lt: "<",
  macr: "¯",
  micro: "µ",
  middot: "·",
  nbsp: " ",
  not: "¬",
  ntilde: "ñ",
  oacute: "ó",
  ocirc: "ô",
  ograve: "ò",
  ordf: "ª",
  ordm: "º",
  oslash: "ø",
  otilde: "õ",
  ouml: "ö",
  para: "¶",
  plusmn: "±",
  pound: "£",
  quot: '"',
  raquo: "»",
  reg: "®",
  sect: "§",
  shy: "­",
  sup1: "¹",
  sup2: "²",
  sup3: "³",
  szlig: "ß",
  thorn: "þ",
  times: "×",
  uacute: "ú",
  ucirc: "û",
  ugrave: "ù",
  uml: "¨",
  uuml: "ü",
  yacute: "ý",
  yen: "¥",
  yuml: "ÿ",
  default: $e
}),
    Ze = Object.freeze({
  __proto__: null,
  default: {
    0: "�",
    128: "€",
    130: "‚",
    131: "ƒ",
    132: "„",
    133: "…",
    134: "†",
    135: "‡",
    136: "ˆ",
    137: "‰",
    138: "Š",
    139: "‹",
    140: "Œ",
    142: "Ž",
    145: "‘",
    146: "’",
    147: "“",
    148: "”",
    149: "•",
    150: "–",
    151: "—",
    152: "˜",
    153: "™",
    154: "š",
    155: "›",
    156: "œ",
    158: "ž",
    159: "Ÿ"
  }
}),
    Je = function Je(r) {
  var e = "string" == typeof r ? r.charCodeAt(0) : r;
  return e >= 48 && e <= 57;
};

var Ke = function Ke(r) {
  var e = "string" == typeof r ? r.charCodeAt(0) : r;
  return e >= 97 && e <= 102 || e >= 65 && e <= 70 || e >= 48 && e <= 57;
};

var Qe = function Qe(r) {
  var e = "string" == typeof r ? r.charCodeAt(0) : r;
  return e >= 97 && e <= 122 || e >= 65 && e <= 90;
};

var rt = function rt(r) {
  return Qe(r) || Je(r);
};

var et = {
  AEli: "Æ",
  AElig: "Æ",
  AM: "&",
  AMP: "&",
  Aacut: "Á",
  Aacute: "Á",
  Abreve: "Ă",
  Acir: "Â",
  Acirc: "Â",
  Acy: "А",
  Afr: "𝔄",
  Agrav: "À",
  Agrave: "À",
  Alpha: "Α",
  Amacr: "Ā",
  And: "⩓",
  Aogon: "Ą",
  Aopf: "𝔸",
  ApplyFunction: "⁡",
  Arin: "Å",
  Aring: "Å",
  Ascr: "𝒜",
  Assign: "≔",
  Atild: "Ã",
  Atilde: "Ã",
  Aum: "Ä",
  Auml: "Ä",
  Backslash: "∖",
  Barv: "⫧",
  Barwed: "⌆",
  Bcy: "Б",
  Because: "∵",
  Bernoullis: "ℬ",
  Beta: "Β",
  Bfr: "𝔅",
  Bopf: "𝔹",
  Breve: "˘",
  Bscr: "ℬ",
  Bumpeq: "≎",
  CHcy: "Ч",
  COP: "©",
  COPY: "©",
  Cacute: "Ć",
  Cap: "⋒",
  CapitalDifferentialD: "ⅅ",
  Cayleys: "ℭ",
  Ccaron: "Č",
  Ccedi: "Ç",
  Ccedil: "Ç",
  Ccirc: "Ĉ",
  Cconint: "∰",
  Cdot: "Ċ",
  Cedilla: "¸",
  CenterDot: "·",
  Cfr: "ℭ",
  Chi: "Χ",
  CircleDot: "⊙",
  CircleMinus: "⊖",
  CirclePlus: "⊕",
  CircleTimes: "⊗",
  ClockwiseContourIntegral: "∲",
  CloseCurlyDoubleQuote: "”",
  CloseCurlyQuote: "’",
  Colon: "∷",
  Colone: "⩴",
  Congruent: "≡",
  Conint: "∯",
  ContourIntegral: "∮",
  Copf: "ℂ",
  Coproduct: "∐",
  CounterClockwiseContourIntegral: "∳",
  Cross: "⨯",
  Cscr: "𝒞",
  Cup: "⋓",
  CupCap: "≍",
  DD: "ⅅ",
  DDotrahd: "⤑",
  DJcy: "Ђ",
  DScy: "Ѕ",
  DZcy: "Џ",
  Dagger: "‡",
  Darr: "↡",
  Dashv: "⫤",
  Dcaron: "Ď",
  Dcy: "Д",
  Del: "∇",
  Delta: "Δ",
  Dfr: "𝔇",
  DiacriticalAcute: "´",
  DiacriticalDot: "˙",
  DiacriticalDoubleAcute: "˝",
  DiacriticalGrave: "`",
  DiacriticalTilde: "˜",
  Diamond: "⋄",
  DifferentialD: "ⅆ",
  Dopf: "𝔻",
  Dot: "¨",
  DotDot: "⃜",
  DotEqual: "≐",
  DoubleContourIntegral: "∯",
  DoubleDot: "¨",
  DoubleDownArrow: "⇓",
  DoubleLeftArrow: "⇐",
  DoubleLeftRightArrow: "⇔",
  DoubleLeftTee: "⫤",
  DoubleLongLeftArrow: "⟸",
  DoubleLongLeftRightArrow: "⟺",
  DoubleLongRightArrow: "⟹",
  DoubleRightArrow: "⇒",
  DoubleRightTee: "⊨",
  DoubleUpArrow: "⇑",
  DoubleUpDownArrow: "⇕",
  DoubleVerticalBar: "∥",
  DownArrow: "↓",
  DownArrowBar: "⤓",
  DownArrowUpArrow: "⇵",
  DownBreve: "̑",
  DownLeftRightVector: "⥐",
  DownLeftTeeVector: "⥞",
  DownLeftVector: "↽",
  DownLeftVectorBar: "⥖",
  DownRightTeeVector: "⥟",
  DownRightVector: "⇁",
  DownRightVectorBar: "⥗",
  DownTee: "⊤",
  DownTeeArrow: "↧",
  Downarrow: "⇓",
  Dscr: "𝒟",
  Dstrok: "Đ",
  ENG: "Ŋ",
  ET: "Ð",
  ETH: "Ð",
  Eacut: "É",
  Eacute: "É",
  Ecaron: "Ě",
  Ecir: "Ê",
  Ecirc: "Ê",
  Ecy: "Э",
  Edot: "Ė",
  Efr: "𝔈",
  Egrav: "È",
  Egrave: "È",
  Element: "∈",
  Emacr: "Ē",
  EmptySmallSquare: "◻",
  EmptyVerySmallSquare: "▫",
  Eogon: "Ę",
  Eopf: "𝔼",
  Epsilon: "Ε",
  Equal: "⩵",
  EqualTilde: "≂",
  Equilibrium: "⇌",
  Escr: "ℰ",
  Esim: "⩳",
  Eta: "Η",
  Eum: "Ë",
  Euml: "Ë",
  Exists: "∃",
  ExponentialE: "ⅇ",
  Fcy: "Ф",
  Ffr: "𝔉",
  FilledSmallSquare: "◼",
  FilledVerySmallSquare: "▪",
  Fopf: "𝔽",
  ForAll: "∀",
  Fouriertrf: "ℱ",
  Fscr: "ℱ",
  GJcy: "Ѓ",
  G: ">",
  GT: ">",
  Gamma: "Γ",
  Gammad: "Ϝ",
  Gbreve: "Ğ",
  Gcedil: "Ģ",
  Gcirc: "Ĝ",
  Gcy: "Г",
  Gdot: "Ġ",
  Gfr: "𝔊",
  Gg: "⋙",
  Gopf: "𝔾",
  GreaterEqual: "≥",
  GreaterEqualLess: "⋛",
  GreaterFullEqual: "≧",
  GreaterGreater: "⪢",
  GreaterLess: "≷",
  GreaterSlantEqual: "⩾",
  GreaterTilde: "≳",
  Gscr: "𝒢",
  Gt: "≫",
  HARDcy: "Ъ",
  Hacek: "ˇ",
  Hat: "^",
  Hcirc: "Ĥ",
  Hfr: "ℌ",
  HilbertSpace: "ℋ",
  Hopf: "ℍ",
  HorizontalLine: "─",
  Hscr: "ℋ",
  Hstrok: "Ħ",
  HumpDownHump: "≎",
  HumpEqual: "≏",
  IEcy: "Е",
  IJlig: "Ĳ",
  IOcy: "Ё",
  Iacut: "Í",
  Iacute: "Í",
  Icir: "Î",
  Icirc: "Î",
  Icy: "И",
  Idot: "İ",
  Ifr: "ℑ",
  Igrav: "Ì",
  Igrave: "Ì",
  Im: "ℑ",
  Imacr: "Ī",
  ImaginaryI: "ⅈ",
  Implies: "⇒",
  Int: "∬",
  Integral: "∫",
  Intersection: "⋂",
  InvisibleComma: "⁣",
  InvisibleTimes: "⁢",
  Iogon: "Į",
  Iopf: "𝕀",
  Iota: "Ι",
  Iscr: "ℐ",
  Itilde: "Ĩ",
  Iukcy: "І",
  Ium: "Ï",
  Iuml: "Ï",
  Jcirc: "Ĵ",
  Jcy: "Й",
  Jfr: "𝔍",
  Jopf: "𝕁",
  Jscr: "𝒥",
  Jsercy: "Ј",
  Jukcy: "Є",
  KHcy: "Х",
  KJcy: "Ќ",
  Kappa: "Κ",
  Kcedil: "Ķ",
  Kcy: "К",
  Kfr: "𝔎",
  Kopf: "𝕂",
  Kscr: "𝒦",
  LJcy: "Љ",
  L: "<",
  LT: "<",
  Lacute: "Ĺ",
  Lambda: "Λ",
  Lang: "⟪",
  Laplacetrf: "ℒ",
  Larr: "↞",
  Lcaron: "Ľ",
  Lcedil: "Ļ",
  Lcy: "Л",
  LeftAngleBracket: "⟨",
  LeftArrow: "←",
  LeftArrowBar: "⇤",
  LeftArrowRightArrow: "⇆",
  LeftCeiling: "⌈",
  LeftDoubleBracket: "⟦",
  LeftDownTeeVector: "⥡",
  LeftDownVector: "⇃",
  LeftDownVectorBar: "⥙",
  LeftFloor: "⌊",
  LeftRightArrow: "↔",
  LeftRightVector: "⥎",
  LeftTee: "⊣",
  LeftTeeArrow: "↤",
  LeftTeeVector: "⥚",
  LeftTriangle: "⊲",
  LeftTriangleBar: "⧏",
  LeftTriangleEqual: "⊴",
  LeftUpDownVector: "⥑",
  LeftUpTeeVector: "⥠",
  LeftUpVector: "↿",
  LeftUpVectorBar: "⥘",
  LeftVector: "↼",
  LeftVectorBar: "⥒",
  Leftarrow: "⇐",
  Leftrightarrow: "⇔",
  LessEqualGreater: "⋚",
  LessFullEqual: "≦",
  LessGreater: "≶",
  LessLess: "⪡",
  LessSlantEqual: "⩽",
  LessTilde: "≲",
  Lfr: "𝔏",
  Ll: "⋘",
  Lleftarrow: "⇚",
  Lmidot: "Ŀ",
  LongLeftArrow: "⟵",
  LongLeftRightArrow: "⟷",
  LongRightArrow: "⟶",
  Longleftarrow: "⟸",
  Longleftrightarrow: "⟺",
  Longrightarrow: "⟹",
  Lopf: "𝕃",
  LowerLeftArrow: "↙",
  LowerRightArrow: "↘",
  Lscr: "ℒ",
  Lsh: "↰",
  Lstrok: "Ł",
  Lt: "≪",
  Map: "⤅",
  Mcy: "М",
  MediumSpace: " ",
  Mellintrf: "ℳ",
  Mfr: "𝔐",
  MinusPlus: "∓",
  Mopf: "𝕄",
  Mscr: "ℳ",
  Mu: "Μ",
  NJcy: "Њ",
  Nacute: "Ń",
  Ncaron: "Ň",
  Ncedil: "Ņ",
  Ncy: "Н",
  NegativeMediumSpace: "​",
  NegativeThickSpace: "​",
  NegativeThinSpace: "​",
  NegativeVeryThinSpace: "​",
  NestedGreaterGreater: "≫",
  NestedLessLess: "≪",
  NewLine: "\n",
  Nfr: "𝔑",
  NoBreak: "⁠",
  NonBreakingSpace: " ",
  Nopf: "ℕ",
  Not: "⫬",
  NotCongruent: "≢",
  NotCupCap: "≭",
  NotDoubleVerticalBar: "∦",
  NotElement: "∉",
  NotEqual: "≠",
  NotEqualTilde: "≂̸",
  NotExists: "∄",
  NotGreater: "≯",
  NotGreaterEqual: "≱",
  NotGreaterFullEqual: "≧̸",
  NotGreaterGreater: "≫̸",
  NotGreaterLess: "≹",
  NotGreaterSlantEqual: "⩾̸",
  NotGreaterTilde: "≵",
  NotHumpDownHump: "≎̸",
  NotHumpEqual: "≏̸",
  NotLeftTriangle: "⋪",
  NotLeftTriangleBar: "⧏̸",
  NotLeftTriangleEqual: "⋬",
  NotLess: "≮",
  NotLessEqual: "≰",
  NotLessGreater: "≸",
  NotLessLess: "≪̸",
  NotLessSlantEqual: "⩽̸",
  NotLessTilde: "≴",
  NotNestedGreaterGreater: "⪢̸",
  NotNestedLessLess: "⪡̸",
  NotPrecedes: "⊀",
  NotPrecedesEqual: "⪯̸",
  NotPrecedesSlantEqual: "⋠",
  NotReverseElement: "∌",
  NotRightTriangle: "⋫",
  NotRightTriangleBar: "⧐̸",
  NotRightTriangleEqual: "⋭",
  NotSquareSubset: "⊏̸",
  NotSquareSubsetEqual: "⋢",
  NotSquareSuperset: "⊐̸",
  NotSquareSupersetEqual: "⋣",
  NotSubset: "⊂⃒",
  NotSubsetEqual: "⊈",
  NotSucceeds: "⊁",
  NotSucceedsEqual: "⪰̸",
  NotSucceedsSlantEqual: "⋡",
  NotSucceedsTilde: "≿̸",
  NotSuperset: "⊃⃒",
  NotSupersetEqual: "⊉",
  NotTilde: "≁",
  NotTildeEqual: "≄",
  NotTildeFullEqual: "≇",
  NotTildeTilde: "≉",
  NotVerticalBar: "∤",
  Nscr: "𝒩",
  Ntild: "Ñ",
  Ntilde: "Ñ",
  Nu: "Ν",
  OElig: "Œ",
  Oacut: "Ó",
  Oacute: "Ó",
  Ocir: "Ô",
  Ocirc: "Ô",
  Ocy: "О",
  Odblac: "Ő",
  Ofr: "𝔒",
  Ograv: "Ò",
  Ograve: "Ò",
  Omacr: "Ō",
  Omega: "Ω",
  Omicron: "Ο",
  Oopf: "𝕆",
  OpenCurlyDoubleQuote: "“",
  OpenCurlyQuote: "‘",
  Or: "⩔",
  Oscr: "𝒪",
  Oslas: "Ø",
  Oslash: "Ø",
  Otild: "Õ",
  Otilde: "Õ",
  Otimes: "⨷",
  Oum: "Ö",
  Ouml: "Ö",
  OverBar: "‾",
  OverBrace: "⏞",
  OverBracket: "⎴",
  OverParenthesis: "⏜",
  PartialD: "∂",
  Pcy: "П",
  Pfr: "𝔓",
  Phi: "Φ",
  Pi: "Π",
  PlusMinus: "±",
  Poincareplane: "ℌ",
  Popf: "ℙ",
  Pr: "⪻",
  Precedes: "≺",
  PrecedesEqual: "⪯",
  PrecedesSlantEqual: "≼",
  PrecedesTilde: "≾",
  Prime: "″",
  Product: "∏",
  Proportion: "∷",
  Proportional: "∝",
  Pscr: "𝒫",
  Psi: "Ψ",
  QUO: '"',
  QUOT: '"',
  Qfr: "𝔔",
  Qopf: "ℚ",
  Qscr: "𝒬",
  RBarr: "⤐",
  RE: "®",
  REG: "®",
  Racute: "Ŕ",
  Rang: "⟫",
  Rarr: "↠",
  Rarrtl: "⤖",
  Rcaron: "Ř",
  Rcedil: "Ŗ",
  Rcy: "Р",
  Re: "ℜ",
  ReverseElement: "∋",
  ReverseEquilibrium: "⇋",
  ReverseUpEquilibrium: "⥯",
  Rfr: "ℜ",
  Rho: "Ρ",
  RightAngleBracket: "⟩",
  RightArrow: "→",
  RightArrowBar: "⇥",
  RightArrowLeftArrow: "⇄",
  RightCeiling: "⌉",
  RightDoubleBracket: "⟧",
  RightDownTeeVector: "⥝",
  RightDownVector: "⇂",
  RightDownVectorBar: "⥕",
  RightFloor: "⌋",
  RightTee: "⊢",
  RightTeeArrow: "↦",
  RightTeeVector: "⥛",
  RightTriangle: "⊳",
  RightTriangleBar: "⧐",
  RightTriangleEqual: "⊵",
  RightUpDownVector: "⥏",
  RightUpTeeVector: "⥜",
  RightUpVector: "↾",
  RightUpVectorBar: "⥔",
  RightVector: "⇀",
  RightVectorBar: "⥓",
  Rightarrow: "⇒",
  Ropf: "ℝ",
  RoundImplies: "⥰",
  Rrightarrow: "⇛",
  Rscr: "ℛ",
  Rsh: "↱",
  RuleDelayed: "⧴",
  SHCHcy: "Щ",
  SHcy: "Ш",
  SOFTcy: "Ь",
  Sacute: "Ś",
  Sc: "⪼",
  Scaron: "Š",
  Scedil: "Ş",
  Scirc: "Ŝ",
  Scy: "С",
  Sfr: "𝔖",
  ShortDownArrow: "↓",
  ShortLeftArrow: "←",
  ShortRightArrow: "→",
  ShortUpArrow: "↑",
  Sigma: "Σ",
  SmallCircle: "∘",
  Sopf: "𝕊",
  Sqrt: "√",
  Square: "□",
  SquareIntersection: "⊓",
  SquareSubset: "⊏",
  SquareSubsetEqual: "⊑",
  SquareSuperset: "⊐",
  SquareSupersetEqual: "⊒",
  SquareUnion: "⊔",
  Sscr: "𝒮",
  Star: "⋆",
  Sub: "⋐",
  Subset: "⋐",
  SubsetEqual: "⊆",
  Succeeds: "≻",
  SucceedsEqual: "⪰",
  SucceedsSlantEqual: "≽",
  SucceedsTilde: "≿",
  SuchThat: "∋",
  Sum: "∑",
  Sup: "⋑",
  Superset: "⊃",
  SupersetEqual: "⊇",
  Supset: "⋑",
  THOR: "Þ",
  THORN: "Þ",
  TRADE: "™",
  TSHcy: "Ћ",
  TScy: "Ц",
  Tab: "\t",
  Tau: "Τ",
  Tcaron: "Ť",
  Tcedil: "Ţ",
  Tcy: "Т",
  Tfr: "𝔗",
  Therefore: "∴",
  Theta: "Θ",
  ThickSpace: "  ",
  ThinSpace: " ",
  Tilde: "∼",
  TildeEqual: "≃",
  TildeFullEqual: "≅",
  TildeTilde: "≈",
  Topf: "𝕋",
  TripleDot: "⃛",
  Tscr: "𝒯",
  Tstrok: "Ŧ",
  Uacut: "Ú",
  Uacute: "Ú",
  Uarr: "↟",
  Uarrocir: "⥉",
  Ubrcy: "Ў",
  Ubreve: "Ŭ",
  Ucir: "Û",
  Ucirc: "Û",
  Ucy: "У",
  Udblac: "Ű",
  Ufr: "𝔘",
  Ugrav: "Ù",
  Ugrave: "Ù",
  Umacr: "Ū",
  UnderBar: "_",
  UnderBrace: "⏟",
  UnderBracket: "⎵",
  UnderParenthesis: "⏝",
  Union: "⋃",
  UnionPlus: "⊎",
  Uogon: "Ų",
  Uopf: "𝕌",
  UpArrow: "↑",
  UpArrowBar: "⤒",
  UpArrowDownArrow: "⇅",
  UpDownArrow: "↕",
  UpEquilibrium: "⥮",
  UpTee: "⊥",
  UpTeeArrow: "↥",
  Uparrow: "⇑",
  Updownarrow: "⇕",
  UpperLeftArrow: "↖",
  UpperRightArrow: "↗",
  Upsi: "ϒ",
  Upsilon: "Υ",
  Uring: "Ů",
  Uscr: "𝒰",
  Utilde: "Ũ",
  Uum: "Ü",
  Uuml: "Ü",
  VDash: "⊫",
  Vbar: "⫫",
  Vcy: "В",
  Vdash: "⊩",
  Vdashl: "⫦",
  Vee: "⋁",
  Verbar: "‖",
  Vert: "‖",
  VerticalBar: "∣",
  VerticalLine: "|",
  VerticalSeparator: "❘",
  VerticalTilde: "≀",
  VeryThinSpace: " ",
  Vfr: "𝔙",
  Vopf: "𝕍",
  Vscr: "𝒱",
  Vvdash: "⊪",
  Wcirc: "Ŵ",
  Wedge: "⋀",
  Wfr: "𝔚",
  Wopf: "𝕎",
  Wscr: "𝒲",
  Xfr: "𝔛",
  Xi: "Ξ",
  Xopf: "𝕏",
  Xscr: "𝒳",
  YAcy: "Я",
  YIcy: "Ї",
  YUcy: "Ю",
  Yacut: "Ý",
  Yacute: "Ý",
  Ycirc: "Ŷ",
  Ycy: "Ы",
  Yfr: "𝔜",
  Yopf: "𝕐",
  Yscr: "𝒴",
  Yuml: "Ÿ",
  ZHcy: "Ж",
  Zacute: "Ź",
  Zcaron: "Ž",
  Zcy: "З",
  Zdot: "Ż",
  ZeroWidthSpace: "​",
  Zeta: "Ζ",
  Zfr: "ℨ",
  Zopf: "ℤ",
  Zscr: "𝒵",
  aacut: "á",
  aacute: "á",
  abreve: "ă",
  ac: "∾",
  acE: "∾̳",
  acd: "∿",
  acir: "â",
  acirc: "â",
  acut: "´",
  acute: "´",
  acy: "а",
  aeli: "æ",
  aelig: "æ",
  af: "⁡",
  afr: "𝔞",
  agrav: "à",
  agrave: "à",
  alefsym: "ℵ",
  aleph: "ℵ",
  alpha: "α",
  amacr: "ā",
  amalg: "⨿",
  am: "&",
  amp: "&",
  and: "∧",
  andand: "⩕",
  andd: "⩜",
  andslope: "⩘",
  andv: "⩚",
  ang: "∠",
  ange: "⦤",
  angle: "∠",
  angmsd: "∡",
  angmsdaa: "⦨",
  angmsdab: "⦩",
  angmsdac: "⦪",
  angmsdad: "⦫",
  angmsdae: "⦬",
  angmsdaf: "⦭",
  angmsdag: "⦮",
  angmsdah: "⦯",
  angrt: "∟",
  angrtvb: "⊾",
  angrtvbd: "⦝",
  angsph: "∢",
  angst: "Å",
  angzarr: "⍼",
  aogon: "ą",
  aopf: "𝕒",
  ap: "≈",
  apE: "⩰",
  apacir: "⩯",
  ape: "≊",
  apid: "≋",
  apos: "'",
  approx: "≈",
  approxeq: "≊",
  arin: "å",
  aring: "å",
  ascr: "𝒶",
  ast: "*",
  asymp: "≈",
  asympeq: "≍",
  atild: "ã",
  atilde: "ã",
  aum: "ä",
  auml: "ä",
  awconint: "∳",
  awint: "⨑",
  bNot: "⫭",
  backcong: "≌",
  backepsilon: "϶",
  backprime: "‵",
  backsim: "∽",
  backsimeq: "⋍",
  barvee: "⊽",
  barwed: "⌅",
  barwedge: "⌅",
  bbrk: "⎵",
  bbrktbrk: "⎶",
  bcong: "≌",
  bcy: "б",
  bdquo: "„",
  becaus: "∵",
  because: "∵",
  bemptyv: "⦰",
  bepsi: "϶",
  bernou: "ℬ",
  beta: "β",
  beth: "ℶ",
  between: "≬",
  bfr: "𝔟",
  bigcap: "⋂",
  bigcirc: "◯",
  bigcup: "⋃",
  bigodot: "⨀",
  bigoplus: "⨁",
  bigotimes: "⨂",
  bigsqcup: "⨆",
  bigstar: "★",
  bigtriangledown: "▽",
  bigtriangleup: "△",
  biguplus: "⨄",
  bigvee: "⋁",
  bigwedge: "⋀",
  bkarow: "⤍",
  blacklozenge: "⧫",
  blacksquare: "▪",
  blacktriangle: "▴",
  blacktriangledown: "▾",
  blacktriangleleft: "◂",
  blacktriangleright: "▸",
  blank: "␣",
  blk12: "▒",
  blk14: "░",
  blk34: "▓",
  block: "█",
  bne: "=⃥",
  bnequiv: "≡⃥",
  bnot: "⌐",
  bopf: "𝕓",
  bot: "⊥",
  bottom: "⊥",
  bowtie: "⋈",
  boxDL: "╗",
  boxDR: "╔",
  boxDl: "╖",
  boxDr: "╓",
  boxH: "═",
  boxHD: "╦",
  boxHU: "╩",
  boxHd: "╤",
  boxHu: "╧",
  boxUL: "╝",
  boxUR: "╚",
  boxUl: "╜",
  boxUr: "╙",
  boxV: "║",
  boxVH: "╬",
  boxVL: "╣",
  boxVR: "╠",
  boxVh: "╫",
  boxVl: "╢",
  boxVr: "╟",
  boxbox: "⧉",
  boxdL: "╕",
  boxdR: "╒",
  boxdl: "┐",
  boxdr: "┌",
  boxh: "─",
  boxhD: "╥",
  boxhU: "╨",
  boxhd: "┬",
  boxhu: "┴",
  boxminus: "⊟",
  boxplus: "⊞",
  boxtimes: "⊠",
  boxuL: "╛",
  boxuR: "╘",
  boxul: "┘",
  boxur: "└",
  boxv: "│",
  boxvH: "╪",
  boxvL: "╡",
  boxvR: "╞",
  boxvh: "┼",
  boxvl: "┤",
  boxvr: "├",
  bprime: "‵",
  breve: "˘",
  brvba: "¦",
  brvbar: "¦",
  bscr: "𝒷",
  bsemi: "⁏",
  bsim: "∽",
  bsime: "⋍",
  bsol: "\\",
  bsolb: "⧅",
  bsolhsub: "⟈",
  bull: "•",
  bullet: "•",
  bump: "≎",
  bumpE: "⪮",
  bumpe: "≏",
  bumpeq: "≏",
  cacute: "ć",
  cap: "∩",
  capand: "⩄",
  capbrcup: "⩉",
  capcap: "⩋",
  capcup: "⩇",
  capdot: "⩀",
  caps: "∩︀",
  caret: "⁁",
  caron: "ˇ",
  ccaps: "⩍",
  ccaron: "č",
  ccedi: "ç",
  ccedil: "ç",
  ccirc: "ĉ",
  ccups: "⩌",
  ccupssm: "⩐",
  cdot: "ċ",
  cedi: "¸",
  cedil: "¸",
  cemptyv: "⦲",
  cen: "¢",
  cent: "¢",
  centerdot: "·",
  cfr: "𝔠",
  chcy: "ч",
  check: "✓",
  checkmark: "✓",
  chi: "χ",
  cir: "○",
  cirE: "⧃",
  circ: "ˆ",
  circeq: "≗",
  circlearrowleft: "↺",
  circlearrowright: "↻",
  circledR: "®",
  circledS: "Ⓢ",
  circledast: "⊛",
  circledcirc: "⊚",
  circleddash: "⊝",
  cire: "≗",
  cirfnint: "⨐",
  cirmid: "⫯",
  cirscir: "⧂",
  clubs: "♣",
  clubsuit: "♣",
  colon: ":",
  colone: "≔",
  coloneq: "≔",
  comma: ",",
  commat: "@",
  comp: "∁",
  compfn: "∘",
  complement: "∁",
  complexes: "ℂ",
  cong: "≅",
  congdot: "⩭",
  conint: "∮",
  copf: "𝕔",
  coprod: "∐",
  cop: "©",
  copy: "©",
  copysr: "℗",
  crarr: "↵",
  cross: "✗",
  cscr: "𝒸",
  csub: "⫏",
  csube: "⫑",
  csup: "⫐",
  csupe: "⫒",
  ctdot: "⋯",
  cudarrl: "⤸",
  cudarrr: "⤵",
  cuepr: "⋞",
  cuesc: "⋟",
  cularr: "↶",
  cularrp: "⤽",
  cup: "∪",
  cupbrcap: "⩈",
  cupcap: "⩆",
  cupcup: "⩊",
  cupdot: "⊍",
  cupor: "⩅",
  cups: "∪︀",
  curarr: "↷",
  curarrm: "⤼",
  curlyeqprec: "⋞",
  curlyeqsucc: "⋟",
  curlyvee: "⋎",
  curlywedge: "⋏",
  curre: "¤",
  curren: "¤",
  curvearrowleft: "↶",
  curvearrowright: "↷",
  cuvee: "⋎",
  cuwed: "⋏",
  cwconint: "∲",
  cwint: "∱",
  cylcty: "⌭",
  dArr: "⇓",
  dHar: "⥥",
  dagger: "†",
  daleth: "ℸ",
  darr: "↓",
  dash: "‐",
  dashv: "⊣",
  dbkarow: "⤏",
  dblac: "˝",
  dcaron: "ď",
  dcy: "д",
  dd: "ⅆ",
  ddagger: "‡",
  ddarr: "⇊",
  ddotseq: "⩷",
  de: "°",
  deg: "°",
  delta: "δ",
  demptyv: "⦱",
  dfisht: "⥿",
  dfr: "𝔡",
  dharl: "⇃",
  dharr: "⇂",
  diam: "⋄",
  diamond: "⋄",
  diamondsuit: "♦",
  diams: "♦",
  die: "¨",
  digamma: "ϝ",
  disin: "⋲",
  div: "÷",
  divid: "÷",
  divide: "÷",
  divideontimes: "⋇",
  divonx: "⋇",
  djcy: "ђ",
  dlcorn: "⌞",
  dlcrop: "⌍",
  dollar: "$",
  dopf: "𝕕",
  dot: "˙",
  doteq: "≐",
  doteqdot: "≑",
  dotminus: "∸",
  dotplus: "∔",
  dotsquare: "⊡",
  doublebarwedge: "⌆",
  downarrow: "↓",
  downdownarrows: "⇊",
  downharpoonleft: "⇃",
  downharpoonright: "⇂",
  drbkarow: "⤐",
  drcorn: "⌟",
  drcrop: "⌌",
  dscr: "𝒹",
  dscy: "ѕ",
  dsol: "⧶",
  dstrok: "đ",
  dtdot: "⋱",
  dtri: "▿",
  dtrif: "▾",
  duarr: "⇵",
  duhar: "⥯",
  dwangle: "⦦",
  dzcy: "џ",
  dzigrarr: "⟿",
  eDDot: "⩷",
  eDot: "≑",
  eacut: "é",
  eacute: "é",
  easter: "⩮",
  ecaron: "ě",
  ecir: "ê",
  ecirc: "ê",
  ecolon: "≕",
  ecy: "э",
  edot: "ė",
  ee: "ⅇ",
  efDot: "≒",
  efr: "𝔢",
  eg: "⪚",
  egrav: "è",
  egrave: "è",
  egs: "⪖",
  egsdot: "⪘",
  el: "⪙",
  elinters: "⏧",
  ell: "ℓ",
  els: "⪕",
  elsdot: "⪗",
  emacr: "ē",
  empty: "∅",
  emptyset: "∅",
  emptyv: "∅",
  emsp13: " ",
  emsp14: " ",
  emsp: " ",
  eng: "ŋ",
  ensp: " ",
  eogon: "ę",
  eopf: "𝕖",
  epar: "⋕",
  eparsl: "⧣",
  eplus: "⩱",
  epsi: "ε",
  epsilon: "ε",
  epsiv: "ϵ",
  eqcirc: "≖",
  eqcolon: "≕",
  eqsim: "≂",
  eqslantgtr: "⪖",
  eqslantless: "⪕",
  equals: "=",
  equest: "≟",
  equiv: "≡",
  equivDD: "⩸",
  eqvparsl: "⧥",
  erDot: "≓",
  erarr: "⥱",
  escr: "ℯ",
  esdot: "≐",
  esim: "≂",
  eta: "η",
  et: "ð",
  eth: "ð",
  eum: "ë",
  euml: "ë",
  euro: "€",
  excl: "!",
  exist: "∃",
  expectation: "ℰ",
  exponentiale: "ⅇ",
  fallingdotseq: "≒",
  fcy: "ф",
  female: "♀",
  ffilig: "ﬃ",
  fflig: "ﬀ",
  ffllig: "ﬄ",
  ffr: "𝔣",
  filig: "ﬁ",
  fjlig: "fj",
  flat: "♭",
  fllig: "ﬂ",
  fltns: "▱",
  fnof: "ƒ",
  fopf: "𝕗",
  forall: "∀",
  fork: "⋔",
  forkv: "⫙",
  fpartint: "⨍",
  frac1: "¼",
  frac12: "½",
  frac13: "⅓",
  frac14: "¼",
  frac15: "⅕",
  frac16: "⅙",
  frac18: "⅛",
  frac23: "⅔",
  frac25: "⅖",
  frac3: "¾",
  frac34: "¾",
  frac35: "⅗",
  frac38: "⅜",
  frac45: "⅘",
  frac56: "⅚",
  frac58: "⅝",
  frac78: "⅞",
  frasl: "⁄",
  frown: "⌢",
  fscr: "𝒻",
  gE: "≧",
  gEl: "⪌",
  gacute: "ǵ",
  gamma: "γ",
  gammad: "ϝ",
  gap: "⪆",
  gbreve: "ğ",
  gcirc: "ĝ",
  gcy: "г",
  gdot: "ġ",
  ge: "≥",
  gel: "⋛",
  geq: "≥",
  geqq: "≧",
  geqslant: "⩾",
  ges: "⩾",
  gescc: "⪩",
  gesdot: "⪀",
  gesdoto: "⪂",
  gesdotol: "⪄",
  gesl: "⋛︀",
  gesles: "⪔",
  gfr: "𝔤",
  gg: "≫",
  ggg: "⋙",
  gimel: "ℷ",
  gjcy: "ѓ",
  gl: "≷",
  glE: "⪒",
  gla: "⪥",
  glj: "⪤",
  gnE: "≩",
  gnap: "⪊",
  gnapprox: "⪊",
  gne: "⪈",
  gneq: "⪈",
  gneqq: "≩",
  gnsim: "⋧",
  gopf: "𝕘",
  grave: "`",
  gscr: "ℊ",
  gsim: "≳",
  gsime: "⪎",
  gsiml: "⪐",
  g: ">",
  gt: ">",
  gtcc: "⪧",
  gtcir: "⩺",
  gtdot: "⋗",
  gtlPar: "⦕",
  gtquest: "⩼",
  gtrapprox: "⪆",
  gtrarr: "⥸",
  gtrdot: "⋗",
  gtreqless: "⋛",
  gtreqqless: "⪌",
  gtrless: "≷",
  gtrsim: "≳",
  gvertneqq: "≩︀",
  gvnE: "≩︀",
  hArr: "⇔",
  hairsp: " ",
  half: "½",
  hamilt: "ℋ",
  hardcy: "ъ",
  harr: "↔",
  harrcir: "⥈",
  harrw: "↭",
  hbar: "ℏ",
  hcirc: "ĥ",
  hearts: "♥",
  heartsuit: "♥",
  hellip: "…",
  hercon: "⊹",
  hfr: "𝔥",
  hksearow: "⤥",
  hkswarow: "⤦",
  hoarr: "⇿",
  homtht: "∻",
  hookleftarrow: "↩",
  hookrightarrow: "↪",
  hopf: "𝕙",
  horbar: "―",
  hscr: "𝒽",
  hslash: "ℏ",
  hstrok: "ħ",
  hybull: "⁃",
  hyphen: "‐",
  iacut: "í",
  iacute: "í",
  ic: "⁣",
  icir: "î",
  icirc: "î",
  icy: "и",
  iecy: "е",
  iexc: "¡",
  iexcl: "¡",
  iff: "⇔",
  ifr: "𝔦",
  igrav: "ì",
  igrave: "ì",
  ii: "ⅈ",
  iiiint: "⨌",
  iiint: "∭",
  iinfin: "⧜",
  iiota: "℩",
  ijlig: "ĳ",
  imacr: "ī",
  image: "ℑ",
  imagline: "ℐ",
  imagpart: "ℑ",
  imath: "ı",
  imof: "⊷",
  imped: "Ƶ",
  in: "∈",
  incare: "℅",
  infin: "∞",
  infintie: "⧝",
  inodot: "ı",
  int: "∫",
  intcal: "⊺",
  integers: "ℤ",
  intercal: "⊺",
  intlarhk: "⨗",
  intprod: "⨼",
  iocy: "ё",
  iogon: "į",
  iopf: "𝕚",
  iota: "ι",
  iprod: "⨼",
  iques: "¿",
  iquest: "¿",
  iscr: "𝒾",
  isin: "∈",
  isinE: "⋹",
  isindot: "⋵",
  isins: "⋴",
  isinsv: "⋳",
  isinv: "∈",
  it: "⁢",
  itilde: "ĩ",
  iukcy: "і",
  ium: "ï",
  iuml: "ï",
  jcirc: "ĵ",
  jcy: "й",
  jfr: "𝔧",
  jmath: "ȷ",
  jopf: "𝕛",
  jscr: "𝒿",
  jsercy: "ј",
  jukcy: "є",
  kappa: "κ",
  kappav: "ϰ",
  kcedil: "ķ",
  kcy: "к",
  kfr: "𝔨",
  kgreen: "ĸ",
  khcy: "х",
  kjcy: "ќ",
  kopf: "𝕜",
  kscr: "𝓀",
  lAarr: "⇚",
  lArr: "⇐",
  lAtail: "⤛",
  lBarr: "⤎",
  lE: "≦",
  lEg: "⪋",
  lHar: "⥢",
  lacute: "ĺ",
  laemptyv: "⦴",
  lagran: "ℒ",
  lambda: "λ",
  lang: "⟨",
  langd: "⦑",
  langle: "⟨",
  lap: "⪅",
  laqu: "«",
  laquo: "«",
  larr: "←",
  larrb: "⇤",
  larrbfs: "⤟",
  larrfs: "⤝",
  larrhk: "↩",
  larrlp: "↫",
  larrpl: "⤹",
  larrsim: "⥳",
  larrtl: "↢",
  lat: "⪫",
  latail: "⤙",
  late: "⪭",
  lates: "⪭︀",
  lbarr: "⤌",
  lbbrk: "❲",
  lbrace: "{",
  lbrack: "[",
  lbrke: "⦋",
  lbrksld: "⦏",
  lbrkslu: "⦍",
  lcaron: "ľ",
  lcedil: "ļ",
  lceil: "⌈",
  lcub: "{",
  lcy: "л",
  ldca: "⤶",
  ldquo: "“",
  ldquor: "„",
  ldrdhar: "⥧",
  ldrushar: "⥋",
  ldsh: "↲",
  le: "≤",
  leftarrow: "←",
  leftarrowtail: "↢",
  leftharpoondown: "↽",
  leftharpoonup: "↼",
  leftleftarrows: "⇇",
  leftrightarrow: "↔",
  leftrightarrows: "⇆",
  leftrightharpoons: "⇋",
  leftrightsquigarrow: "↭",
  leftthreetimes: "⋋",
  leg: "⋚",
  leq: "≤",
  leqq: "≦",
  leqslant: "⩽",
  les: "⩽",
  lescc: "⪨",
  lesdot: "⩿",
  lesdoto: "⪁",
  lesdotor: "⪃",
  lesg: "⋚︀",
  lesges: "⪓",
  lessapprox: "⪅",
  lessdot: "⋖",
  lesseqgtr: "⋚",
  lesseqqgtr: "⪋",
  lessgtr: "≶",
  lesssim: "≲",
  lfisht: "⥼",
  lfloor: "⌊",
  lfr: "𝔩",
  lg: "≶",
  lgE: "⪑",
  lhard: "↽",
  lharu: "↼",
  lharul: "⥪",
  lhblk: "▄",
  ljcy: "љ",
  ll: "≪",
  llarr: "⇇",
  llcorner: "⌞",
  llhard: "⥫",
  lltri: "◺",
  lmidot: "ŀ",
  lmoust: "⎰",
  lmoustache: "⎰",
  lnE: "≨",
  lnap: "⪉",
  lnapprox: "⪉",
  lne: "⪇",
  lneq: "⪇",
  lneqq: "≨",
  lnsim: "⋦",
  loang: "⟬",
  loarr: "⇽",
  lobrk: "⟦",
  longleftarrow: "⟵",
  longleftrightarrow: "⟷",
  longmapsto: "⟼",
  longrightarrow: "⟶",
  looparrowleft: "↫",
  looparrowright: "↬",
  lopar: "⦅",
  lopf: "𝕝",
  loplus: "⨭",
  lotimes: "⨴",
  lowast: "∗",
  lowbar: "_",
  loz: "◊",
  lozenge: "◊",
  lozf: "⧫",
  lpar: "(",
  lparlt: "⦓",
  lrarr: "⇆",
  lrcorner: "⌟",
  lrhar: "⇋",
  lrhard: "⥭",
  lrm: "‎",
  lrtri: "⊿",
  lsaquo: "‹",
  lscr: "𝓁",
  lsh: "↰",
  lsim: "≲",
  lsime: "⪍",
  lsimg: "⪏",
  lsqb: "[",
  lsquo: "‘",
  lsquor: "‚",
  lstrok: "ł",
  l: "<",
  lt: "<",
  ltcc: "⪦",
  ltcir: "⩹",
  ltdot: "⋖",
  lthree: "⋋",
  ltimes: "⋉",
  ltlarr: "⥶",
  ltquest: "⩻",
  ltrPar: "⦖",
  ltri: "◃",
  ltrie: "⊴",
  ltrif: "◂",
  lurdshar: "⥊",
  luruhar: "⥦",
  lvertneqq: "≨︀",
  lvnE: "≨︀",
  mDDot: "∺",
  mac: "¯",
  macr: "¯",
  male: "♂",
  malt: "✠",
  maltese: "✠",
  map: "↦",
  mapsto: "↦",
  mapstodown: "↧",
  mapstoleft: "↤",
  mapstoup: "↥",
  marker: "▮",
  mcomma: "⨩",
  mcy: "м",
  mdash: "—",
  measuredangle: "∡",
  mfr: "𝔪",
  mho: "℧",
  micr: "µ",
  micro: "µ",
  mid: "∣",
  midast: "*",
  midcir: "⫰",
  middo: "·",
  middot: "·",
  minus: "−",
  minusb: "⊟",
  minusd: "∸",
  minusdu: "⨪",
  mlcp: "⫛",
  mldr: "…",
  mnplus: "∓",
  models: "⊧",
  mopf: "𝕞",
  mp: "∓",
  mscr: "𝓂",
  mstpos: "∾",
  mu: "μ",
  multimap: "⊸",
  mumap: "⊸",
  nGg: "⋙̸",
  nGt: "≫⃒",
  nGtv: "≫̸",
  nLeftarrow: "⇍",
  nLeftrightarrow: "⇎",
  nLl: "⋘̸",
  nLt: "≪⃒",
  nLtv: "≪̸",
  nRightarrow: "⇏",
  nVDash: "⊯",
  nVdash: "⊮",
  nabla: "∇",
  nacute: "ń",
  nang: "∠⃒",
  nap: "≉",
  napE: "⩰̸",
  napid: "≋̸",
  napos: "ŉ",
  napprox: "≉",
  natur: "♮",
  natural: "♮",
  naturals: "ℕ",
  nbs: " ",
  nbsp: " ",
  nbump: "≎̸",
  nbumpe: "≏̸",
  ncap: "⩃",
  ncaron: "ň",
  ncedil: "ņ",
  ncong: "≇",
  ncongdot: "⩭̸",
  ncup: "⩂",
  ncy: "н",
  ndash: "–",
  ne: "≠",
  neArr: "⇗",
  nearhk: "⤤",
  nearr: "↗",
  nearrow: "↗",
  nedot: "≐̸",
  nequiv: "≢",
  nesear: "⤨",
  nesim: "≂̸",
  nexist: "∄",
  nexists: "∄",
  nfr: "𝔫",
  ngE: "≧̸",
  nge: "≱",
  ngeq: "≱",
  ngeqq: "≧̸",
  ngeqslant: "⩾̸",
  nges: "⩾̸",
  ngsim: "≵",
  ngt: "≯",
  ngtr: "≯",
  nhArr: "⇎",
  nharr: "↮",
  nhpar: "⫲",
  ni: "∋",
  nis: "⋼",
  nisd: "⋺",
  niv: "∋",
  njcy: "њ",
  nlArr: "⇍",
  nlE: "≦̸",
  nlarr: "↚",
  nldr: "‥",
  nle: "≰",
  nleftarrow: "↚",
  nleftrightarrow: "↮",
  nleq: "≰",
  nleqq: "≦̸",
  nleqslant: "⩽̸",
  nles: "⩽̸",
  nless: "≮",
  nlsim: "≴",
  nlt: "≮",
  nltri: "⋪",
  nltrie: "⋬",
  nmid: "∤",
  nopf: "𝕟",
  no: "¬",
  not: "¬",
  notin: "∉",
  notinE: "⋹̸",
  notindot: "⋵̸",
  notinva: "∉",
  notinvb: "⋷",
  notinvc: "⋶",
  notni: "∌",
  notniva: "∌",
  notnivb: "⋾",
  notnivc: "⋽",
  npar: "∦",
  nparallel: "∦",
  nparsl: "⫽⃥",
  npart: "∂̸",
  npolint: "⨔",
  npr: "⊀",
  nprcue: "⋠",
  npre: "⪯̸",
  nprec: "⊀",
  npreceq: "⪯̸",
  nrArr: "⇏",
  nrarr: "↛",
  nrarrc: "⤳̸",
  nrarrw: "↝̸",
  nrightarrow: "↛",
  nrtri: "⋫",
  nrtrie: "⋭",
  nsc: "⊁",
  nsccue: "⋡",
  nsce: "⪰̸",
  nscr: "𝓃",
  nshortmid: "∤",
  nshortparallel: "∦",
  nsim: "≁",
  nsime: "≄",
  nsimeq: "≄",
  nsmid: "∤",
  nspar: "∦",
  nsqsube: "⋢",
  nsqsupe: "⋣",
  nsub: "⊄",
  nsubE: "⫅̸",
  nsube: "⊈",
  nsubset: "⊂⃒",
  nsubseteq: "⊈",
  nsubseteqq: "⫅̸",
  nsucc: "⊁",
  nsucceq: "⪰̸",
  nsup: "⊅",
  nsupE: "⫆̸",
  nsupe: "⊉",
  nsupset: "⊃⃒",
  nsupseteq: "⊉",
  nsupseteqq: "⫆̸",
  ntgl: "≹",
  ntild: "ñ",
  ntilde: "ñ",
  ntlg: "≸",
  ntriangleleft: "⋪",
  ntrianglelefteq: "⋬",
  ntriangleright: "⋫",
  ntrianglerighteq: "⋭",
  nu: "ν",
  num: "#",
  numero: "№",
  numsp: " ",
  nvDash: "⊭",
  nvHarr: "⤄",
  nvap: "≍⃒",
  nvdash: "⊬",
  nvge: "≥⃒",
  nvgt: ">⃒",
  nvinfin: "⧞",
  nvlArr: "⤂",
  nvle: "≤⃒",
  nvlt: "<⃒",
  nvltrie: "⊴⃒",
  nvrArr: "⤃",
  nvrtrie: "⊵⃒",
  nvsim: "∼⃒",
  nwArr: "⇖",
  nwarhk: "⤣",
  nwarr: "↖",
  nwarrow: "↖",
  nwnear: "⤧",
  oS: "Ⓢ",
  oacut: "ó",
  oacute: "ó",
  oast: "⊛",
  ocir: "ô",
  ocirc: "ô",
  ocy: "о",
  odash: "⊝",
  odblac: "ő",
  odiv: "⨸",
  odot: "⊙",
  odsold: "⦼",
  oelig: "œ",
  ofcir: "⦿",
  ofr: "𝔬",
  ogon: "˛",
  ograv: "ò",
  ograve: "ò",
  ogt: "⧁",
  ohbar: "⦵",
  ohm: "Ω",
  oint: "∮",
  olarr: "↺",
  olcir: "⦾",
  olcross: "⦻",
  oline: "‾",
  olt: "⧀",
  omacr: "ō",
  omega: "ω",
  omicron: "ο",
  omid: "⦶",
  ominus: "⊖",
  oopf: "𝕠",
  opar: "⦷",
  operp: "⦹",
  oplus: "⊕",
  or: "∨",
  orarr: "↻",
  ord: "º",
  order: "ℴ",
  orderof: "ℴ",
  ordf: "ª",
  ordm: "º",
  origof: "⊶",
  oror: "⩖",
  orslope: "⩗",
  orv: "⩛",
  oscr: "ℴ",
  oslas: "ø",
  oslash: "ø",
  osol: "⊘",
  otild: "õ",
  otilde: "õ",
  otimes: "⊗",
  otimesas: "⨶",
  oum: "ö",
  ouml: "ö",
  ovbar: "⌽",
  par: "¶",
  para: "¶",
  parallel: "∥",
  parsim: "⫳",
  parsl: "⫽",
  part: "∂",
  pcy: "п",
  percnt: "%",
  period: ".",
  permil: "‰",
  perp: "⊥",
  pertenk: "‱",
  pfr: "𝔭",
  phi: "φ",
  phiv: "ϕ",
  phmmat: "ℳ",
  phone: "☎",
  pi: "π",
  pitchfork: "⋔",
  piv: "ϖ",
  planck: "ℏ",
  planckh: "ℎ",
  plankv: "ℏ",
  plus: "+",
  plusacir: "⨣",
  plusb: "⊞",
  pluscir: "⨢",
  plusdo: "∔",
  plusdu: "⨥",
  pluse: "⩲",
  plusm: "±",
  plusmn: "±",
  plussim: "⨦",
  plustwo: "⨧",
  pm: "±",
  pointint: "⨕",
  popf: "𝕡",
  poun: "£",
  pound: "£",
  pr: "≺",
  prE: "⪳",
  prap: "⪷",
  prcue: "≼",
  pre: "⪯",
  prec: "≺",
  precapprox: "⪷",
  preccurlyeq: "≼",
  preceq: "⪯",
  precnapprox: "⪹",
  precneqq: "⪵",
  precnsim: "⋨",
  precsim: "≾",
  prime: "′",
  primes: "ℙ",
  prnE: "⪵",
  prnap: "⪹",
  prnsim: "⋨",
  prod: "∏",
  profalar: "⌮",
  profline: "⌒",
  profsurf: "⌓",
  prop: "∝",
  propto: "∝",
  prsim: "≾",
  prurel: "⊰",
  pscr: "𝓅",
  psi: "ψ",
  puncsp: " ",
  qfr: "𝔮",
  qint: "⨌",
  qopf: "𝕢",
  qprime: "⁗",
  qscr: "𝓆",
  quaternions: "ℍ",
  quatint: "⨖",
  quest: "?",
  questeq: "≟",
  quo: '"',
  quot: '"',
  rAarr: "⇛",
  rArr: "⇒",
  rAtail: "⤜",
  rBarr: "⤏",
  rHar: "⥤",
  race: "∽̱",
  racute: "ŕ",
  radic: "√",
  raemptyv: "⦳",
  rang: "⟩",
  rangd: "⦒",
  range: "⦥",
  rangle: "⟩",
  raqu: "»",
  raquo: "»",
  rarr: "→",
  rarrap: "⥵",
  rarrb: "⇥",
  rarrbfs: "⤠",
  rarrc: "⤳",
  rarrfs: "⤞",
  rarrhk: "↪",
  rarrlp: "↬",
  rarrpl: "⥅",
  rarrsim: "⥴",
  rarrtl: "↣",
  rarrw: "↝",
  ratail: "⤚",
  ratio: "∶",
  rationals: "ℚ",
  rbarr: "⤍",
  rbbrk: "❳",
  rbrace: "}",
  rbrack: "]",
  rbrke: "⦌",
  rbrksld: "⦎",
  rbrkslu: "⦐",
  rcaron: "ř",
  rcedil: "ŗ",
  rceil: "⌉",
  rcub: "}",
  rcy: "р",
  rdca: "⤷",
  rdldhar: "⥩",
  rdquo: "”",
  rdquor: "”",
  rdsh: "↳",
  real: "ℜ",
  realine: "ℛ",
  realpart: "ℜ",
  reals: "ℝ",
  rect: "▭",
  re: "®",
  reg: "®",
  rfisht: "⥽",
  rfloor: "⌋",
  rfr: "𝔯",
  rhard: "⇁",
  rharu: "⇀",
  rharul: "⥬",
  rho: "ρ",
  rhov: "ϱ",
  rightarrow: "→",
  rightarrowtail: "↣",
  rightharpoondown: "⇁",
  rightharpoonup: "⇀",
  rightleftarrows: "⇄",
  rightleftharpoons: "⇌",
  rightrightarrows: "⇉",
  rightsquigarrow: "↝",
  rightthreetimes: "⋌",
  ring: "˚",
  risingdotseq: "≓",
  rlarr: "⇄",
  rlhar: "⇌",
  rlm: "‏",
  rmoust: "⎱",
  rmoustache: "⎱",
  rnmid: "⫮",
  roang: "⟭",
  roarr: "⇾",
  robrk: "⟧",
  ropar: "⦆",
  ropf: "𝕣",
  roplus: "⨮",
  rotimes: "⨵",
  rpar: ")",
  rpargt: "⦔",
  rppolint: "⨒",
  rrarr: "⇉",
  rsaquo: "›",
  rscr: "𝓇",
  rsh: "↱",
  rsqb: "]",
  rsquo: "’",
  rsquor: "’",
  rthree: "⋌",
  rtimes: "⋊",
  rtri: "▹",
  rtrie: "⊵",
  rtrif: "▸",
  rtriltri: "⧎",
  ruluhar: "⥨",
  rx: "℞",
  sacute: "ś",
  sbquo: "‚",
  sc: "≻",
  scE: "⪴",
  scap: "⪸",
  scaron: "š",
  sccue: "≽",
  sce: "⪰",
  scedil: "ş",
  scirc: "ŝ",
  scnE: "⪶",
  scnap: "⪺",
  scnsim: "⋩",
  scpolint: "⨓",
  scsim: "≿",
  scy: "с",
  sdot: "⋅",
  sdotb: "⊡",
  sdote: "⩦",
  seArr: "⇘",
  searhk: "⤥",
  searr: "↘",
  searrow: "↘",
  sec: "§",
  sect: "§",
  semi: ";",
  seswar: "⤩",
  setminus: "∖",
  setmn: "∖",
  sext: "✶",
  sfr: "𝔰",
  sfrown: "⌢",
  sharp: "♯",
  shchcy: "щ",
  shcy: "ш",
  shortmid: "∣",
  shortparallel: "∥",
  sh: "­",
  shy: "­",
  sigma: "σ",
  sigmaf: "ς",
  sigmav: "ς",
  sim: "∼",
  simdot: "⩪",
  sime: "≃",
  simeq: "≃",
  simg: "⪞",
  simgE: "⪠",
  siml: "⪝",
  simlE: "⪟",
  simne: "≆",
  simplus: "⨤",
  simrarr: "⥲",
  slarr: "←",
  smallsetminus: "∖",
  smashp: "⨳",
  smeparsl: "⧤",
  smid: "∣",
  smile: "⌣",
  smt: "⪪",
  smte: "⪬",
  smtes: "⪬︀",
  softcy: "ь",
  sol: "/",
  solb: "⧄",
  solbar: "⌿",
  sopf: "𝕤",
  spades: "♠",
  spadesuit: "♠",
  spar: "∥",
  sqcap: "⊓",
  sqcaps: "⊓︀",
  sqcup: "⊔",
  sqcups: "⊔︀",
  sqsub: "⊏",
  sqsube: "⊑",
  sqsubset: "⊏",
  sqsubseteq: "⊑",
  sqsup: "⊐",
  sqsupe: "⊒",
  sqsupset: "⊐",
  sqsupseteq: "⊒",
  squ: "□",
  square: "□",
  squarf: "▪",
  squf: "▪",
  srarr: "→",
  sscr: "𝓈",
  ssetmn: "∖",
  ssmile: "⌣",
  sstarf: "⋆",
  star: "☆",
  starf: "★",
  straightepsilon: "ϵ",
  straightphi: "ϕ",
  strns: "¯",
  sub: "⊂",
  subE: "⫅",
  subdot: "⪽",
  sube: "⊆",
  subedot: "⫃",
  submult: "⫁",
  subnE: "⫋",
  subne: "⊊",
  subplus: "⪿",
  subrarr: "⥹",
  subset: "⊂",
  subseteq: "⊆",
  subseteqq: "⫅",
  subsetneq: "⊊",
  subsetneqq: "⫋",
  subsim: "⫇",
  subsub: "⫕",
  subsup: "⫓",
  succ: "≻",
  succapprox: "⪸",
  succcurlyeq: "≽",
  succeq: "⪰",
  succnapprox: "⪺",
  succneqq: "⪶",
  succnsim: "⋩",
  succsim: "≿",
  sum: "∑",
  sung: "♪",
  sup: "⊃",
  sup1: "¹",
  sup2: "²",
  sup3: "³",
  supE: "⫆",
  supdot: "⪾",
  supdsub: "⫘",
  supe: "⊇",
  supedot: "⫄",
  suphsol: "⟉",
  suphsub: "⫗",
  suplarr: "⥻",
  supmult: "⫂",
  supnE: "⫌",
  supne: "⊋",
  supplus: "⫀",
  supset: "⊃",
  supseteq: "⊇",
  supseteqq: "⫆",
  supsetneq: "⊋",
  supsetneqq: "⫌",
  supsim: "⫈",
  supsub: "⫔",
  supsup: "⫖",
  swArr: "⇙",
  swarhk: "⤦",
  swarr: "↙",
  swarrow: "↙",
  swnwar: "⤪",
  szli: "ß",
  szlig: "ß",
  target: "⌖",
  tau: "τ",
  tbrk: "⎴",
  tcaron: "ť",
  tcedil: "ţ",
  tcy: "т",
  tdot: "⃛",
  telrec: "⌕",
  tfr: "𝔱",
  there4: "∴",
  therefore: "∴",
  theta: "θ",
  thetasym: "ϑ",
  thetav: "ϑ",
  thickapprox: "≈",
  thicksim: "∼",
  thinsp: " ",
  thkap: "≈",
  thksim: "∼",
  thor: "þ",
  thorn: "þ",
  tilde: "˜",
  time: "×",
  times: "×",
  timesb: "⊠",
  timesbar: "⨱",
  timesd: "⨰",
  tint: "∭",
  toea: "⤨",
  top: "⊤",
  topbot: "⌶",
  topcir: "⫱",
  topf: "𝕥",
  topfork: "⫚",
  tosa: "⤩",
  tprime: "‴",
  trade: "™",
  triangle: "▵",
  triangledown: "▿",
  triangleleft: "◃",
  trianglelefteq: "⊴",
  triangleq: "≜",
  triangleright: "▹",
  trianglerighteq: "⊵",
  tridot: "◬",
  trie: "≜",
  triminus: "⨺",
  triplus: "⨹",
  trisb: "⧍",
  tritime: "⨻",
  trpezium: "⏢",
  tscr: "𝓉",
  tscy: "ц",
  tshcy: "ћ",
  tstrok: "ŧ",
  twixt: "≬",
  twoheadleftarrow: "↞",
  twoheadrightarrow: "↠",
  uArr: "⇑",
  uHar: "⥣",
  uacut: "ú",
  uacute: "ú",
  uarr: "↑",
  ubrcy: "ў",
  ubreve: "ŭ",
  ucir: "û",
  ucirc: "û",
  ucy: "у",
  udarr: "⇅",
  udblac: "ű",
  udhar: "⥮",
  ufisht: "⥾",
  ufr: "𝔲",
  ugrav: "ù",
  ugrave: "ù",
  uharl: "↿",
  uharr: "↾",
  uhblk: "▀",
  ulcorn: "⌜",
  ulcorner: "⌜",
  ulcrop: "⌏",
  ultri: "◸",
  umacr: "ū",
  um: "¨",
  uml: "¨",
  uogon: "ų",
  uopf: "𝕦",
  uparrow: "↑",
  updownarrow: "↕",
  upharpoonleft: "↿",
  upharpoonright: "↾",
  uplus: "⊎",
  upsi: "υ",
  upsih: "ϒ",
  upsilon: "υ",
  upuparrows: "⇈",
  urcorn: "⌝",
  urcorner: "⌝",
  urcrop: "⌎",
  uring: "ů",
  urtri: "◹",
  uscr: "𝓊",
  utdot: "⋰",
  utilde: "ũ",
  utri: "▵",
  utrif: "▴",
  uuarr: "⇈",
  uum: "ü",
  uuml: "ü",
  uwangle: "⦧",
  vArr: "⇕",
  vBar: "⫨",
  vBarv: "⫩",
  vDash: "⊨",
  vangrt: "⦜",
  varepsilon: "ϵ",
  varkappa: "ϰ",
  varnothing: "∅",
  varphi: "ϕ",
  varpi: "ϖ",
  varpropto: "∝",
  varr: "↕",
  varrho: "ϱ",
  varsigma: "ς",
  varsubsetneq: "⊊︀",
  varsubsetneqq: "⫋︀",
  varsupsetneq: "⊋︀",
  varsupsetneqq: "⫌︀",
  vartheta: "ϑ",
  vartriangleleft: "⊲",
  vartriangleright: "⊳",
  vcy: "в",
  vdash: "⊢",
  vee: "∨",
  veebar: "⊻",
  veeeq: "≚",
  vellip: "⋮",
  verbar: "|",
  vert: "|",
  vfr: "𝔳",
  vltri: "⊲",
  vnsub: "⊂⃒",
  vnsup: "⊃⃒",
  vopf: "𝕧",
  vprop: "∝",
  vrtri: "⊳",
  vscr: "𝓋",
  vsubnE: "⫋︀",
  vsubne: "⊊︀",
  vsupnE: "⫌︀",
  vsupne: "⊋︀",
  vzigzag: "⦚",
  wcirc: "ŵ",
  wedbar: "⩟",
  wedge: "∧",
  wedgeq: "≙",
  weierp: "℘",
  wfr: "𝔴",
  wopf: "𝕨",
  wp: "℘",
  wr: "≀",
  wreath: "≀",
  wscr: "𝓌",
  xcap: "⋂",
  xcirc: "◯",
  xcup: "⋃",
  xdtri: "▽",
  xfr: "𝔵",
  xhArr: "⟺",
  xharr: "⟷",
  xi: "ξ",
  xlArr: "⟸",
  xlarr: "⟵",
  xmap: "⟼",
  xnis: "⋻",
  xodot: "⨀",
  xopf: "𝕩",
  xoplus: "⨁",
  xotime: "⨂",
  xrArr: "⟹",
  xrarr: "⟶",
  xscr: "𝓍",
  xsqcup: "⨆",
  xuplus: "⨄",
  xutri: "△",
  xvee: "⋁",
  xwedge: "⋀",
  yacut: "ý",
  yacute: "ý",
  yacy: "я",
  ycirc: "ŷ",
  ycy: "ы",
  ye: "¥",
  yen: "¥",
  yfr: "𝔶",
  yicy: "ї",
  yopf: "𝕪",
  yscr: "𝓎",
  yucy: "ю",
  yum: "ÿ",
  yuml: "ÿ",
  zacute: "ź",
  zcaron: "ž",
  zcy: "з",
  zdot: "ż",
  zeetrf: "ℨ",
  zeta: "ζ",
  zfr: "𝔷",
  zhcy: "ж",
  zigrarr: "⇝",
  zopf: "𝕫",
  zscr: "𝓏",
  zwj: "‍",
  zwnj: "‌"
},
    tt = ir(Object.freeze({
  __proto__: null,
  AEli: "Æ",
  AElig: "Æ",
  AM: "&",
  AMP: "&",
  Aacut: "Á",
  Aacute: "Á",
  Abreve: "Ă",
  Acir: "Â",
  Acirc: "Â",
  Acy: "А",
  Afr: "𝔄",
  Agrav: "À",
  Agrave: "À",
  Alpha: "Α",
  Amacr: "Ā",
  And: "⩓",
  Aogon: "Ą",
  Aopf: "𝔸",
  ApplyFunction: "⁡",
  Arin: "Å",
  Aring: "Å",
  Ascr: "𝒜",
  Assign: "≔",
  Atild: "Ã",
  Atilde: "Ã",
  Aum: "Ä",
  Auml: "Ä",
  Backslash: "∖",
  Barv: "⫧",
  Barwed: "⌆",
  Bcy: "Б",
  Because: "∵",
  Bernoullis: "ℬ",
  Beta: "Β",
  Bfr: "𝔅",
  Bopf: "𝔹",
  Breve: "˘",
  Bscr: "ℬ",
  Bumpeq: "≎",
  CHcy: "Ч",
  COP: "©",
  COPY: "©",
  Cacute: "Ć",
  Cap: "⋒",
  CapitalDifferentialD: "ⅅ",
  Cayleys: "ℭ",
  Ccaron: "Č",
  Ccedi: "Ç",
  Ccedil: "Ç",
  Ccirc: "Ĉ",
  Cconint: "∰",
  Cdot: "Ċ",
  Cedilla: "¸",
  CenterDot: "·",
  Cfr: "ℭ",
  Chi: "Χ",
  CircleDot: "⊙",
  CircleMinus: "⊖",
  CirclePlus: "⊕",
  CircleTimes: "⊗",
  ClockwiseContourIntegral: "∲",
  CloseCurlyDoubleQuote: "”",
  CloseCurlyQuote: "’",
  Colon: "∷",
  Colone: "⩴",
  Congruent: "≡",
  Conint: "∯",
  ContourIntegral: "∮",
  Copf: "ℂ",
  Coproduct: "∐",
  CounterClockwiseContourIntegral: "∳",
  Cross: "⨯",
  Cscr: "𝒞",
  Cup: "⋓",
  CupCap: "≍",
  DD: "ⅅ",
  DDotrahd: "⤑",
  DJcy: "Ђ",
  DScy: "Ѕ",
  DZcy: "Џ",
  Dagger: "‡",
  Darr: "↡",
  Dashv: "⫤",
  Dcaron: "Ď",
  Dcy: "Д",
  Del: "∇",
  Delta: "Δ",
  Dfr: "𝔇",
  DiacriticalAcute: "´",
  DiacriticalDot: "˙",
  DiacriticalDoubleAcute: "˝",
  DiacriticalGrave: "`",
  DiacriticalTilde: "˜",
  Diamond: "⋄",
  DifferentialD: "ⅆ",
  Dopf: "𝔻",
  Dot: "¨",
  DotDot: "⃜",
  DotEqual: "≐",
  DoubleContourIntegral: "∯",
  DoubleDot: "¨",
  DoubleDownArrow: "⇓",
  DoubleLeftArrow: "⇐",
  DoubleLeftRightArrow: "⇔",
  DoubleLeftTee: "⫤",
  DoubleLongLeftArrow: "⟸",
  DoubleLongLeftRightArrow: "⟺",
  DoubleLongRightArrow: "⟹",
  DoubleRightArrow: "⇒",
  DoubleRightTee: "⊨",
  DoubleUpArrow: "⇑",
  DoubleUpDownArrow: "⇕",
  DoubleVerticalBar: "∥",
  DownArrow: "↓",
  DownArrowBar: "⤓",
  DownArrowUpArrow: "⇵",
  DownBreve: "̑",
  DownLeftRightVector: "⥐",
  DownLeftTeeVector: "⥞",
  DownLeftVector: "↽",
  DownLeftVectorBar: "⥖",
  DownRightTeeVector: "⥟",
  DownRightVector: "⇁",
  DownRightVectorBar: "⥗",
  DownTee: "⊤",
  DownTeeArrow: "↧",
  Downarrow: "⇓",
  Dscr: "𝒟",
  Dstrok: "Đ",
  ENG: "Ŋ",
  ET: "Ð",
  ETH: "Ð",
  Eacut: "É",
  Eacute: "É",
  Ecaron: "Ě",
  Ecir: "Ê",
  Ecirc: "Ê",
  Ecy: "Э",
  Edot: "Ė",
  Efr: "𝔈",
  Egrav: "È",
  Egrave: "È",
  Element: "∈",
  Emacr: "Ē",
  EmptySmallSquare: "◻",
  EmptyVerySmallSquare: "▫",
  Eogon: "Ę",
  Eopf: "𝔼",
  Epsilon: "Ε",
  Equal: "⩵",
  EqualTilde: "≂",
  Equilibrium: "⇌",
  Escr: "ℰ",
  Esim: "⩳",
  Eta: "Η",
  Eum: "Ë",
  Euml: "Ë",
  Exists: "∃",
  ExponentialE: "ⅇ",
  Fcy: "Ф",
  Ffr: "𝔉",
  FilledSmallSquare: "◼",
  FilledVerySmallSquare: "▪",
  Fopf: "𝔽",
  ForAll: "∀",
  Fouriertrf: "ℱ",
  Fscr: "ℱ",
  GJcy: "Ѓ",
  G: ">",
  GT: ">",
  Gamma: "Γ",
  Gammad: "Ϝ",
  Gbreve: "Ğ",
  Gcedil: "Ģ",
  Gcirc: "Ĝ",
  Gcy: "Г",
  Gdot: "Ġ",
  Gfr: "𝔊",
  Gg: "⋙",
  Gopf: "𝔾",
  GreaterEqual: "≥",
  GreaterEqualLess: "⋛",
  GreaterFullEqual: "≧",
  GreaterGreater: "⪢",
  GreaterLess: "≷",
  GreaterSlantEqual: "⩾",
  GreaterTilde: "≳",
  Gscr: "𝒢",
  Gt: "≫",
  HARDcy: "Ъ",
  Hacek: "ˇ",
  Hat: "^",
  Hcirc: "Ĥ",
  Hfr: "ℌ",
  HilbertSpace: "ℋ",
  Hopf: "ℍ",
  HorizontalLine: "─",
  Hscr: "ℋ",
  Hstrok: "Ħ",
  HumpDownHump: "≎",
  HumpEqual: "≏",
  IEcy: "Е",
  IJlig: "Ĳ",
  IOcy: "Ё",
  Iacut: "Í",
  Iacute: "Í",
  Icir: "Î",
  Icirc: "Î",
  Icy: "И",
  Idot: "İ",
  Ifr: "ℑ",
  Igrav: "Ì",
  Igrave: "Ì",
  Im: "ℑ",
  Imacr: "Ī",
  ImaginaryI: "ⅈ",
  Implies: "⇒",
  Int: "∬",
  Integral: "∫",
  Intersection: "⋂",
  InvisibleComma: "⁣",
  InvisibleTimes: "⁢",
  Iogon: "Į",
  Iopf: "𝕀",
  Iota: "Ι",
  Iscr: "ℐ",
  Itilde: "Ĩ",
  Iukcy: "І",
  Ium: "Ï",
  Iuml: "Ï",
  Jcirc: "Ĵ",
  Jcy: "Й",
  Jfr: "𝔍",
  Jopf: "𝕁",
  Jscr: "𝒥",
  Jsercy: "Ј",
  Jukcy: "Є",
  KHcy: "Х",
  KJcy: "Ќ",
  Kappa: "Κ",
  Kcedil: "Ķ",
  Kcy: "К",
  Kfr: "𝔎",
  Kopf: "𝕂",
  Kscr: "𝒦",
  LJcy: "Љ",
  L: "<",
  LT: "<",
  Lacute: "Ĺ",
  Lambda: "Λ",
  Lang: "⟪",
  Laplacetrf: "ℒ",
  Larr: "↞",
  Lcaron: "Ľ",
  Lcedil: "Ļ",
  Lcy: "Л",
  LeftAngleBracket: "⟨",
  LeftArrow: "←",
  LeftArrowBar: "⇤",
  LeftArrowRightArrow: "⇆",
  LeftCeiling: "⌈",
  LeftDoubleBracket: "⟦",
  LeftDownTeeVector: "⥡",
  LeftDownVector: "⇃",
  LeftDownVectorBar: "⥙",
  LeftFloor: "⌊",
  LeftRightArrow: "↔",
  LeftRightVector: "⥎",
  LeftTee: "⊣",
  LeftTeeArrow: "↤",
  LeftTeeVector: "⥚",
  LeftTriangle: "⊲",
  LeftTriangleBar: "⧏",
  LeftTriangleEqual: "⊴",
  LeftUpDownVector: "⥑",
  LeftUpTeeVector: "⥠",
  LeftUpVector: "↿",
  LeftUpVectorBar: "⥘",
  LeftVector: "↼",
  LeftVectorBar: "⥒",
  Leftarrow: "⇐",
  Leftrightarrow: "⇔",
  LessEqualGreater: "⋚",
  LessFullEqual: "≦",
  LessGreater: "≶",
  LessLess: "⪡",
  LessSlantEqual: "⩽",
  LessTilde: "≲",
  Lfr: "𝔏",
  Ll: "⋘",
  Lleftarrow: "⇚",
  Lmidot: "Ŀ",
  LongLeftArrow: "⟵",
  LongLeftRightArrow: "⟷",
  LongRightArrow: "⟶",
  Longleftarrow: "⟸",
  Longleftrightarrow: "⟺",
  Longrightarrow: "⟹",
  Lopf: "𝕃",
  LowerLeftArrow: "↙",
  LowerRightArrow: "↘",
  Lscr: "ℒ",
  Lsh: "↰",
  Lstrok: "Ł",
  Lt: "≪",
  Mcy: "М",
  MediumSpace: " ",
  Mellintrf: "ℳ",
  Mfr: "𝔐",
  MinusPlus: "∓",
  Mopf: "𝕄",
  Mscr: "ℳ",
  Mu: "Μ",
  NJcy: "Њ",
  Nacute: "Ń",
  Ncaron: "Ň",
  Ncedil: "Ņ",
  Ncy: "Н",
  NegativeMediumSpace: "​",
  NegativeThickSpace: "​",
  NegativeThinSpace: "​",
  NegativeVeryThinSpace: "​",
  NestedGreaterGreater: "≫",
  NestedLessLess: "≪",
  NewLine: "\n",
  Nfr: "𝔑",
  NoBreak: "⁠",
  NonBreakingSpace: " ",
  Nopf: "ℕ",
  Not: "⫬",
  NotCongruent: "≢",
  NotCupCap: "≭",
  NotDoubleVerticalBar: "∦",
  NotElement: "∉",
  NotEqual: "≠",
  NotEqualTilde: "≂̸",
  NotExists: "∄",
  NotGreater: "≯",
  NotGreaterEqual: "≱",
  NotGreaterFullEqual: "≧̸",
  NotGreaterGreater: "≫̸",
  NotGreaterLess: "≹",
  NotGreaterSlantEqual: "⩾̸",
  NotGreaterTilde: "≵",
  NotHumpDownHump: "≎̸",
  NotHumpEqual: "≏̸",
  NotLeftTriangle: "⋪",
  NotLeftTriangleBar: "⧏̸",
  NotLeftTriangleEqual: "⋬",
  NotLess: "≮",
  NotLessEqual: "≰",
  NotLessGreater: "≸",
  NotLessLess: "≪̸",
  NotLessSlantEqual: "⩽̸",
  NotLessTilde: "≴",
  NotNestedGreaterGreater: "⪢̸",
  NotNestedLessLess: "⪡̸",
  NotPrecedes: "⊀",
  NotPrecedesEqual: "⪯̸",
  NotPrecedesSlantEqual: "⋠",
  NotReverseElement: "∌",
  NotRightTriangle: "⋫",
  NotRightTriangleBar: "⧐̸",
  NotRightTriangleEqual: "⋭",
  NotSquareSubset: "⊏̸",
  NotSquareSubsetEqual: "⋢",
  NotSquareSuperset: "⊐̸",
  NotSquareSupersetEqual: "⋣",
  NotSubset: "⊂⃒",
  NotSubsetEqual: "⊈",
  NotSucceeds: "⊁",
  NotSucceedsEqual: "⪰̸",
  NotSucceedsSlantEqual: "⋡",
  NotSucceedsTilde: "≿̸",
  NotSuperset: "⊃⃒",
  NotSupersetEqual: "⊉",
  NotTilde: "≁",
  NotTildeEqual: "≄",
  NotTildeFullEqual: "≇",
  NotTildeTilde: "≉",
  NotVerticalBar: "∤",
  Nscr: "𝒩",
  Ntild: "Ñ",
  Ntilde: "Ñ",
  Nu: "Ν",
  OElig: "Œ",
  Oacut: "Ó",
  Oacute: "Ó",
  Ocir: "Ô",
  Ocirc: "Ô",
  Ocy: "О",
  Odblac: "Ő",
  Ofr: "𝔒",
  Ograv: "Ò",
  Ograve: "Ò",
  Omacr: "Ō",
  Omega: "Ω",
  Omicron: "Ο",
  Oopf: "𝕆",
  OpenCurlyDoubleQuote: "“",
  OpenCurlyQuote: "‘",
  Or: "⩔",
  Oscr: "𝒪",
  Oslas: "Ø",
  Oslash: "Ø",
  Otild: "Õ",
  Otilde: "Õ",
  Otimes: "⨷",
  Oum: "Ö",
  Ouml: "Ö",
  OverBar: "‾",
  OverBrace: "⏞",
  OverBracket: "⎴",
  OverParenthesis: "⏜",
  PartialD: "∂",
  Pcy: "П",
  Pfr: "𝔓",
  Phi: "Φ",
  Pi: "Π",
  PlusMinus: "±",
  Poincareplane: "ℌ",
  Popf: "ℙ",
  Pr: "⪻",
  Precedes: "≺",
  PrecedesEqual: "⪯",
  PrecedesSlantEqual: "≼",
  PrecedesTilde: "≾",
  Prime: "″",
  Product: "∏",
  Proportion: "∷",
  Proportional: "∝",
  Pscr: "𝒫",
  Psi: "Ψ",
  QUO: '"',
  QUOT: '"',
  Qfr: "𝔔",
  Qopf: "ℚ",
  Qscr: "𝒬",
  RBarr: "⤐",
  RE: "®",
  REG: "®",
  Racute: "Ŕ",
  Rang: "⟫",
  Rarr: "↠",
  Rarrtl: "⤖",
  Rcaron: "Ř",
  Rcedil: "Ŗ",
  Rcy: "Р",
  Re: "ℜ",
  ReverseElement: "∋",
  ReverseEquilibrium: "⇋",
  ReverseUpEquilibrium: "⥯",
  Rfr: "ℜ",
  Rho: "Ρ",
  RightAngleBracket: "⟩",
  RightArrow: "→",
  RightArrowBar: "⇥",
  RightArrowLeftArrow: "⇄",
  RightCeiling: "⌉",
  RightDoubleBracket: "⟧",
  RightDownTeeVector: "⥝",
  RightDownVector: "⇂",
  RightDownVectorBar: "⥕",
  RightFloor: "⌋",
  RightTee: "⊢",
  RightTeeArrow: "↦",
  RightTeeVector: "⥛",
  RightTriangle: "⊳",
  RightTriangleBar: "⧐",
  RightTriangleEqual: "⊵",
  RightUpDownVector: "⥏",
  RightUpTeeVector: "⥜",
  RightUpVector: "↾",
  RightUpVectorBar: "⥔",
  RightVector: "⇀",
  RightVectorBar: "⥓",
  Rightarrow: "⇒",
  Ropf: "ℝ",
  RoundImplies: "⥰",
  Rrightarrow: "⇛",
  Rscr: "ℛ",
  Rsh: "↱",
  RuleDelayed: "⧴",
  SHCHcy: "Щ",
  SHcy: "Ш",
  SOFTcy: "Ь",
  Sacute: "Ś",
  Sc: "⪼",
  Scaron: "Š",
  Scedil: "Ş",
  Scirc: "Ŝ",
  Scy: "С",
  Sfr: "𝔖",
  ShortDownArrow: "↓",
  ShortLeftArrow: "←",
  ShortRightArrow: "→",
  ShortUpArrow: "↑",
  Sigma: "Σ",
  SmallCircle: "∘",
  Sopf: "𝕊",
  Sqrt: "√",
  Square: "□",
  SquareIntersection: "⊓",
  SquareSubset: "⊏",
  SquareSubsetEqual: "⊑",
  SquareSuperset: "⊐",
  SquareSupersetEqual: "⊒",
  SquareUnion: "⊔",
  Sscr: "𝒮",
  Star: "⋆",
  Sub: "⋐",
  Subset: "⋐",
  SubsetEqual: "⊆",
  Succeeds: "≻",
  SucceedsEqual: "⪰",
  SucceedsSlantEqual: "≽",
  SucceedsTilde: "≿",
  SuchThat: "∋",
  Sum: "∑",
  Sup: "⋑",
  Superset: "⊃",
  SupersetEqual: "⊇",
  Supset: "⋑",
  THOR: "Þ",
  THORN: "Þ",
  TRADE: "™",
  TSHcy: "Ћ",
  TScy: "Ц",
  Tab: "\t",
  Tau: "Τ",
  Tcaron: "Ť",
  Tcedil: "Ţ",
  Tcy: "Т",
  Tfr: "𝔗",
  Therefore: "∴",
  Theta: "Θ",
  ThickSpace: "  ",
  ThinSpace: " ",
  Tilde: "∼",
  TildeEqual: "≃",
  TildeFullEqual: "≅",
  TildeTilde: "≈",
  Topf: "𝕋",
  TripleDot: "⃛",
  Tscr: "𝒯",
  Tstrok: "Ŧ",
  Uacut: "Ú",
  Uacute: "Ú",
  Uarr: "↟",
  Uarrocir: "⥉",
  Ubrcy: "Ў",
  Ubreve: "Ŭ",
  Ucir: "Û",
  Ucirc: "Û",
  Ucy: "У",
  Udblac: "Ű",
  Ufr: "𝔘",
  Ugrav: "Ù",
  Ugrave: "Ù",
  Umacr: "Ū",
  UnderBar: "_",
  UnderBrace: "⏟",
  UnderBracket: "⎵",
  UnderParenthesis: "⏝",
  Union: "⋃",
  UnionPlus: "⊎",
  Uogon: "Ų",
  Uopf: "𝕌",
  UpArrow: "↑",
  UpArrowBar: "⤒",
  UpArrowDownArrow: "⇅",
  UpDownArrow: "↕",
  UpEquilibrium: "⥮",
  UpTee: "⊥",
  UpTeeArrow: "↥",
  Uparrow: "⇑",
  Updownarrow: "⇕",
  UpperLeftArrow: "↖",
  UpperRightArrow: "↗",
  Upsi: "ϒ",
  Upsilon: "Υ",
  Uring: "Ů",
  Uscr: "𝒰",
  Utilde: "Ũ",
  Uum: "Ü",
  Uuml: "Ü",
  VDash: "⊫",
  Vbar: "⫫",
  Vcy: "В",
  Vdash: "⊩",
  Vdashl: "⫦",
  Vee: "⋁",
  Verbar: "‖",
  Vert: "‖",
  VerticalBar: "∣",
  VerticalLine: "|",
  VerticalSeparator: "❘",
  VerticalTilde: "≀",
  VeryThinSpace: " ",
  Vfr: "𝔙",
  Vopf: "𝕍",
  Vscr: "𝒱",
  Vvdash: "⊪",
  Wcirc: "Ŵ",
  Wedge: "⋀",
  Wfr: "𝔚",
  Wopf: "𝕎",
  Wscr: "𝒲",
  Xfr: "𝔛",
  Xi: "Ξ",
  Xopf: "𝕏",
  Xscr: "𝒳",
  YAcy: "Я",
  YIcy: "Ї",
  YUcy: "Ю",
  Yacut: "Ý",
  Yacute: "Ý",
  Ycirc: "Ŷ",
  Ycy: "Ы",
  Yfr: "𝔜",
  Yopf: "𝕐",
  Yscr: "𝒴",
  Yuml: "Ÿ",
  ZHcy: "Ж",
  Zacute: "Ź",
  Zcaron: "Ž",
  Zcy: "З",
  Zdot: "Ż",
  ZeroWidthSpace: "​",
  Zeta: "Ζ",
  Zfr: "ℨ",
  Zopf: "ℤ",
  Zscr: "𝒵",
  aacut: "á",
  aacute: "á",
  abreve: "ă",
  ac: "∾",
  acE: "∾̳",
  acd: "∿",
  acir: "â",
  acirc: "â",
  acut: "´",
  acute: "´",
  acy: "а",
  aeli: "æ",
  aelig: "æ",
  af: "⁡",
  afr: "𝔞",
  agrav: "à",
  agrave: "à",
  alefsym: "ℵ",
  aleph: "ℵ",
  alpha: "α",
  amacr: "ā",
  amalg: "⨿",
  am: "&",
  amp: "&",
  and: "∧",
  andand: "⩕",
  andd: "⩜",
  andslope: "⩘",
  andv: "⩚",
  ang: "∠",
  ange: "⦤",
  angle: "∠",
  angmsd: "∡",
  angmsdaa: "⦨",
  angmsdab: "⦩",
  angmsdac: "⦪",
  angmsdad: "⦫",
  angmsdae: "⦬",
  angmsdaf: "⦭",
  angmsdag: "⦮",
  angmsdah: "⦯",
  angrt: "∟",
  angrtvb: "⊾",
  angrtvbd: "⦝",
  angsph: "∢",
  angst: "Å",
  angzarr: "⍼",
  aogon: "ą",
  aopf: "𝕒",
  ap: "≈",
  apE: "⩰",
  apacir: "⩯",
  ape: "≊",
  apid: "≋",
  apos: "'",
  approx: "≈",
  approxeq: "≊",
  arin: "å",
  aring: "å",
  ascr: "𝒶",
  ast: "*",
  asymp: "≈",
  asympeq: "≍",
  atild: "ã",
  atilde: "ã",
  aum: "ä",
  auml: "ä",
  awconint: "∳",
  awint: "⨑",
  bNot: "⫭",
  backcong: "≌",
  backepsilon: "϶",
  backprime: "‵",
  backsim: "∽",
  backsimeq: "⋍",
  barvee: "⊽",
  barwed: "⌅",
  barwedge: "⌅",
  bbrk: "⎵",
  bbrktbrk: "⎶",
  bcong: "≌",
  bcy: "б",
  bdquo: "„",
  becaus: "∵",
  because: "∵",
  bemptyv: "⦰",
  bepsi: "϶",
  bernou: "ℬ",
  beta: "β",
  beth: "ℶ",
  between: "≬",
  bfr: "𝔟",
  bigcap: "⋂",
  bigcirc: "◯",
  bigcup: "⋃",
  bigodot: "⨀",
  bigoplus: "⨁",
  bigotimes: "⨂",
  bigsqcup: "⨆",
  bigstar: "★",
  bigtriangledown: "▽",
  bigtriangleup: "△",
  biguplus: "⨄",
  bigvee: "⋁",
  bigwedge: "⋀",
  bkarow: "⤍",
  blacklozenge: "⧫",
  blacksquare: "▪",
  blacktriangle: "▴",
  blacktriangledown: "▾",
  blacktriangleleft: "◂",
  blacktriangleright: "▸",
  blank: "␣",
  blk12: "▒",
  blk14: "░",
  blk34: "▓",
  block: "█",
  bne: "=⃥",
  bnequiv: "≡⃥",
  bnot: "⌐",
  bopf: "𝕓",
  bot: "⊥",
  bottom: "⊥",
  bowtie: "⋈",
  boxDL: "╗",
  boxDR: "╔",
  boxDl: "╖",
  boxDr: "╓",
  boxH: "═",
  boxHD: "╦",
  boxHU: "╩",
  boxHd: "╤",
  boxHu: "╧",
  boxUL: "╝",
  boxUR: "╚",
  boxUl: "╜",
  boxUr: "╙",
  boxV: "║",
  boxVH: "╬",
  boxVL: "╣",
  boxVR: "╠",
  boxVh: "╫",
  boxVl: "╢",
  boxVr: "╟",
  boxbox: "⧉",
  boxdL: "╕",
  boxdR: "╒",
  boxdl: "┐",
  boxdr: "┌",
  boxh: "─",
  boxhD: "╥",
  boxhU: "╨",
  boxhd: "┬",
  boxhu: "┴",
  boxminus: "⊟",
  boxplus: "⊞",
  boxtimes: "⊠",
  boxuL: "╛",
  boxuR: "╘",
  boxul: "┘",
  boxur: "└",
  boxv: "│",
  boxvH: "╪",
  boxvL: "╡",
  boxvR: "╞",
  boxvh: "┼",
  boxvl: "┤",
  boxvr: "├",
  bprime: "‵",
  breve: "˘",
  brvba: "¦",
  brvbar: "¦",
  bscr: "𝒷",
  bsemi: "⁏",
  bsim: "∽",
  bsime: "⋍",
  bsol: "\\",
  bsolb: "⧅",
  bsolhsub: "⟈",
  bull: "•",
  bullet: "•",
  bump: "≎",
  bumpE: "⪮",
  bumpe: "≏",
  bumpeq: "≏",
  cacute: "ć",
  cap: "∩",
  capand: "⩄",
  capbrcup: "⩉",
  capcap: "⩋",
  capcup: "⩇",
  capdot: "⩀",
  caps: "∩︀",
  caret: "⁁",
  caron: "ˇ",
  ccaps: "⩍",
  ccaron: "č",
  ccedi: "ç",
  ccedil: "ç",
  ccirc: "ĉ",
  ccups: "⩌",
  ccupssm: "⩐",
  cdot: "ċ",
  cedi: "¸",
  cedil: "¸",
  cemptyv: "⦲",
  cen: "¢",
  cent: "¢",
  centerdot: "·",
  cfr: "𝔠",
  chcy: "ч",
  check: "✓",
  checkmark: "✓",
  chi: "χ",
  cir: "○",
  cirE: "⧃",
  circ: "ˆ",
  circeq: "≗",
  circlearrowleft: "↺",
  circlearrowright: "↻",
  circledR: "®",
  circledS: "Ⓢ",
  circledast: "⊛",
  circledcirc: "⊚",
  circleddash: "⊝",
  cire: "≗",
  cirfnint: "⨐",
  cirmid: "⫯",
  cirscir: "⧂",
  clubs: "♣",
  clubsuit: "♣",
  colon: ":",
  colone: "≔",
  coloneq: "≔",
  comma: ",",
  commat: "@",
  comp: "∁",
  compfn: "∘",
  complement: "∁",
  complexes: "ℂ",
  cong: "≅",
  congdot: "⩭",
  conint: "∮",
  copf: "𝕔",
  coprod: "∐",
  cop: "©",
  copy: "©",
  copysr: "℗",
  crarr: "↵",
  cross: "✗",
  cscr: "𝒸",
  csub: "⫏",
  csube: "⫑",
  csup: "⫐",
  csupe: "⫒",
  ctdot: "⋯",
  cudarrl: "⤸",
  cudarrr: "⤵",
  cuepr: "⋞",
  cuesc: "⋟",
  cularr: "↶",
  cularrp: "⤽",
  cup: "∪",
  cupbrcap: "⩈",
  cupcap: "⩆",
  cupcup: "⩊",
  cupdot: "⊍",
  cupor: "⩅",
  cups: "∪︀",
  curarr: "↷",
  curarrm: "⤼",
  curlyeqprec: "⋞",
  curlyeqsucc: "⋟",
  curlyvee: "⋎",
  curlywedge: "⋏",
  curre: "¤",
  curren: "¤",
  curvearrowleft: "↶",
  curvearrowright: "↷",
  cuvee: "⋎",
  cuwed: "⋏",
  cwconint: "∲",
  cwint: "∱",
  cylcty: "⌭",
  dArr: "⇓",
  dHar: "⥥",
  dagger: "†",
  daleth: "ℸ",
  darr: "↓",
  dash: "‐",
  dashv: "⊣",
  dbkarow: "⤏",
  dblac: "˝",
  dcaron: "ď",
  dcy: "д",
  dd: "ⅆ",
  ddagger: "‡",
  ddarr: "⇊",
  ddotseq: "⩷",
  de: "°",
  deg: "°",
  delta: "δ",
  demptyv: "⦱",
  dfisht: "⥿",
  dfr: "𝔡",
  dharl: "⇃",
  dharr: "⇂",
  diam: "⋄",
  diamond: "⋄",
  diamondsuit: "♦",
  diams: "♦",
  die: "¨",
  digamma: "ϝ",
  disin: "⋲",
  div: "÷",
  divid: "÷",
  divide: "÷",
  divideontimes: "⋇",
  divonx: "⋇",
  djcy: "ђ",
  dlcorn: "⌞",
  dlcrop: "⌍",
  dollar: "$",
  dopf: "𝕕",
  dot: "˙",
  doteq: "≐",
  doteqdot: "≑",
  dotminus: "∸",
  dotplus: "∔",
  dotsquare: "⊡",
  doublebarwedge: "⌆",
  downarrow: "↓",
  downdownarrows: "⇊",
  downharpoonleft: "⇃",
  downharpoonright: "⇂",
  drbkarow: "⤐",
  drcorn: "⌟",
  drcrop: "⌌",
  dscr: "𝒹",
  dscy: "ѕ",
  dsol: "⧶",
  dstrok: "đ",
  dtdot: "⋱",
  dtri: "▿",
  dtrif: "▾",
  duarr: "⇵",
  duhar: "⥯",
  dwangle: "⦦",
  dzcy: "џ",
  dzigrarr: "⟿",
  eDDot: "⩷",
  eDot: "≑",
  eacut: "é",
  eacute: "é",
  easter: "⩮",
  ecaron: "ě",
  ecir: "ê",
  ecirc: "ê",
  ecolon: "≕",
  ecy: "э",
  edot: "ė",
  ee: "ⅇ",
  efDot: "≒",
  efr: "𝔢",
  eg: "⪚",
  egrav: "è",
  egrave: "è",
  egs: "⪖",
  egsdot: "⪘",
  el: "⪙",
  elinters: "⏧",
  ell: "ℓ",
  els: "⪕",
  elsdot: "⪗",
  emacr: "ē",
  empty: "∅",
  emptyset: "∅",
  emptyv: "∅",
  emsp13: " ",
  emsp14: " ",
  emsp: " ",
  eng: "ŋ",
  ensp: " ",
  eogon: "ę",
  eopf: "𝕖",
  epar: "⋕",
  eparsl: "⧣",
  eplus: "⩱",
  epsi: "ε",
  epsilon: "ε",
  epsiv: "ϵ",
  eqcirc: "≖",
  eqcolon: "≕",
  eqsim: "≂",
  eqslantgtr: "⪖",
  eqslantless: "⪕",
  equals: "=",
  equest: "≟",
  equiv: "≡",
  equivDD: "⩸",
  eqvparsl: "⧥",
  erDot: "≓",
  erarr: "⥱",
  escr: "ℯ",
  esdot: "≐",
  esim: "≂",
  eta: "η",
  et: "ð",
  eth: "ð",
  eum: "ë",
  euml: "ë",
  euro: "€",
  excl: "!",
  exist: "∃",
  expectation: "ℰ",
  exponentiale: "ⅇ",
  fallingdotseq: "≒",
  fcy: "ф",
  female: "♀",
  ffilig: "ﬃ",
  fflig: "ﬀ",
  ffllig: "ﬄ",
  ffr: "𝔣",
  filig: "ﬁ",
  fjlig: "fj",
  flat: "♭",
  fllig: "ﬂ",
  fltns: "▱",
  fnof: "ƒ",
  fopf: "𝕗",
  forall: "∀",
  fork: "⋔",
  forkv: "⫙",
  fpartint: "⨍",
  frac1: "¼",
  frac12: "½",
  frac13: "⅓",
  frac14: "¼",
  frac15: "⅕",
  frac16: "⅙",
  frac18: "⅛",
  frac23: "⅔",
  frac25: "⅖",
  frac3: "¾",
  frac34: "¾",
  frac35: "⅗",
  frac38: "⅜",
  frac45: "⅘",
  frac56: "⅚",
  frac58: "⅝",
  frac78: "⅞",
  frasl: "⁄",
  frown: "⌢",
  fscr: "𝒻",
  gE: "≧",
  gEl: "⪌",
  gacute: "ǵ",
  gamma: "γ",
  gammad: "ϝ",
  gap: "⪆",
  gbreve: "ğ",
  gcirc: "ĝ",
  gcy: "г",
  gdot: "ġ",
  ge: "≥",
  gel: "⋛",
  geq: "≥",
  geqq: "≧",
  geqslant: "⩾",
  ges: "⩾",
  gescc: "⪩",
  gesdot: "⪀",
  gesdoto: "⪂",
  gesdotol: "⪄",
  gesl: "⋛︀",
  gesles: "⪔",
  gfr: "𝔤",
  gg: "≫",
  ggg: "⋙",
  gimel: "ℷ",
  gjcy: "ѓ",
  gl: "≷",
  glE: "⪒",
  gla: "⪥",
  glj: "⪤",
  gnE: "≩",
  gnap: "⪊",
  gnapprox: "⪊",
  gne: "⪈",
  gneq: "⪈",
  gneqq: "≩",
  gnsim: "⋧",
  gopf: "𝕘",
  grave: "`",
  gscr: "ℊ",
  gsim: "≳",
  gsime: "⪎",
  gsiml: "⪐",
  g: ">",
  gt: ">",
  gtcc: "⪧",
  gtcir: "⩺",
  gtdot: "⋗",
  gtlPar: "⦕",
  gtquest: "⩼",
  gtrapprox: "⪆",
  gtrarr: "⥸",
  gtrdot: "⋗",
  gtreqless: "⋛",
  gtreqqless: "⪌",
  gtrless: "≷",
  gtrsim: "≳",
  gvertneqq: "≩︀",
  gvnE: "≩︀",
  hArr: "⇔",
  hairsp: " ",
  half: "½",
  hamilt: "ℋ",
  hardcy: "ъ",
  harr: "↔",
  harrcir: "⥈",
  harrw: "↭",
  hbar: "ℏ",
  hcirc: "ĥ",
  hearts: "♥",
  heartsuit: "♥",
  hellip: "…",
  hercon: "⊹",
  hfr: "𝔥",
  hksearow: "⤥",
  hkswarow: "⤦",
  hoarr: "⇿",
  homtht: "∻",
  hookleftarrow: "↩",
  hookrightarrow: "↪",
  hopf: "𝕙",
  horbar: "―",
  hscr: "𝒽",
  hslash: "ℏ",
  hstrok: "ħ",
  hybull: "⁃",
  hyphen: "‐",
  iacut: "í",
  iacute: "í",
  ic: "⁣",
  icir: "î",
  icirc: "î",
  icy: "и",
  iecy: "е",
  iexc: "¡",
  iexcl: "¡",
  iff: "⇔",
  ifr: "𝔦",
  igrav: "ì",
  igrave: "ì",
  ii: "ⅈ",
  iiiint: "⨌",
  iiint: "∭",
  iinfin: "⧜",
  iiota: "℩",
  ijlig: "ĳ",
  imacr: "ī",
  image: "ℑ",
  imagline: "ℐ",
  imagpart: "ℑ",
  imath: "ı",
  imof: "⊷",
  imped: "Ƶ",
  incare: "℅",
  infin: "∞",
  infintie: "⧝",
  inodot: "ı",
  int: "∫",
  intcal: "⊺",
  integers: "ℤ",
  intercal: "⊺",
  intlarhk: "⨗",
  intprod: "⨼",
  iocy: "ё",
  iogon: "į",
  iopf: "𝕚",
  iota: "ι",
  iprod: "⨼",
  iques: "¿",
  iquest: "¿",
  iscr: "𝒾",
  isin: "∈",
  isinE: "⋹",
  isindot: "⋵",
  isins: "⋴",
  isinsv: "⋳",
  isinv: "∈",
  it: "⁢",
  itilde: "ĩ",
  iukcy: "і",
  ium: "ï",
  iuml: "ï",
  jcirc: "ĵ",
  jcy: "й",
  jfr: "𝔧",
  jmath: "ȷ",
  jopf: "𝕛",
  jscr: "𝒿",
  jsercy: "ј",
  jukcy: "є",
  kappa: "κ",
  kappav: "ϰ",
  kcedil: "ķ",
  kcy: "к",
  kfr: "𝔨",
  kgreen: "ĸ",
  khcy: "х",
  kjcy: "ќ",
  kopf: "𝕜",
  kscr: "𝓀",
  lAarr: "⇚",
  lArr: "⇐",
  lAtail: "⤛",
  lBarr: "⤎",
  lE: "≦",
  lEg: "⪋",
  lHar: "⥢",
  lacute: "ĺ",
  laemptyv: "⦴",
  lagran: "ℒ",
  lambda: "λ",
  lang: "⟨",
  langd: "⦑",
  langle: "⟨",
  lap: "⪅",
  laqu: "«",
  laquo: "«",
  larr: "←",
  larrb: "⇤",
  larrbfs: "⤟",
  larrfs: "⤝",
  larrhk: "↩",
  larrlp: "↫",
  larrpl: "⤹",
  larrsim: "⥳",
  larrtl: "↢",
  lat: "⪫",
  latail: "⤙",
  late: "⪭",
  lates: "⪭︀",
  lbarr: "⤌",
  lbbrk: "❲",
  lbrace: "{",
  lbrack: "[",
  lbrke: "⦋",
  lbrksld: "⦏",
  lbrkslu: "⦍",
  lcaron: "ľ",
  lcedil: "ļ",
  lceil: "⌈",
  lcub: "{",
  lcy: "л",
  ldca: "⤶",
  ldquo: "“",
  ldquor: "„",
  ldrdhar: "⥧",
  ldrushar: "⥋",
  ldsh: "↲",
  le: "≤",
  leftarrow: "←",
  leftarrowtail: "↢",
  leftharpoondown: "↽",
  leftharpoonup: "↼",
  leftleftarrows: "⇇",
  leftrightarrow: "↔",
  leftrightarrows: "⇆",
  leftrightharpoons: "⇋",
  leftrightsquigarrow: "↭",
  leftthreetimes: "⋋",
  leg: "⋚",
  leq: "≤",
  leqq: "≦",
  leqslant: "⩽",
  les: "⩽",
  lescc: "⪨",
  lesdot: "⩿",
  lesdoto: "⪁",
  lesdotor: "⪃",
  lesg: "⋚︀",
  lesges: "⪓",
  lessapprox: "⪅",
  lessdot: "⋖",
  lesseqgtr: "⋚",
  lesseqqgtr: "⪋",
  lessgtr: "≶",
  lesssim: "≲",
  lfisht: "⥼",
  lfloor: "⌊",
  lfr: "𝔩",
  lg: "≶",
  lgE: "⪑",
  lhard: "↽",
  lharu: "↼",
  lharul: "⥪",
  lhblk: "▄",
  ljcy: "љ",
  ll: "≪",
  llarr: "⇇",
  llcorner: "⌞",
  llhard: "⥫",
  lltri: "◺",
  lmidot: "ŀ",
  lmoust: "⎰",
  lmoustache: "⎰",
  lnE: "≨",
  lnap: "⪉",
  lnapprox: "⪉",
  lne: "⪇",
  lneq: "⪇",
  lneqq: "≨",
  lnsim: "⋦",
  loang: "⟬",
  loarr: "⇽",
  lobrk: "⟦",
  longleftarrow: "⟵",
  longleftrightarrow: "⟷",
  longmapsto: "⟼",
  longrightarrow: "⟶",
  looparrowleft: "↫",
  looparrowright: "↬",
  lopar: "⦅",
  lopf: "𝕝",
  loplus: "⨭",
  lotimes: "⨴",
  lowast: "∗",
  lowbar: "_",
  loz: "◊",
  lozenge: "◊",
  lozf: "⧫",
  lpar: "(",
  lparlt: "⦓",
  lrarr: "⇆",
  lrcorner: "⌟",
  lrhar: "⇋",
  lrhard: "⥭",
  lrm: "‎",
  lrtri: "⊿",
  lsaquo: "‹",
  lscr: "𝓁",
  lsh: "↰",
  lsim: "≲",
  lsime: "⪍",
  lsimg: "⪏",
  lsqb: "[",
  lsquo: "‘",
  lsquor: "‚",
  lstrok: "ł",
  l: "<",
  lt: "<",
  ltcc: "⪦",
  ltcir: "⩹",
  ltdot: "⋖",
  lthree: "⋋",
  ltimes: "⋉",
  ltlarr: "⥶",
  ltquest: "⩻",
  ltrPar: "⦖",
  ltri: "◃",
  ltrie: "⊴",
  ltrif: "◂",
  lurdshar: "⥊",
  luruhar: "⥦",
  lvertneqq: "≨︀",
  lvnE: "≨︀",
  mDDot: "∺",
  mac: "¯",
  macr: "¯",
  male: "♂",
  malt: "✠",
  maltese: "✠",
  map: "↦",
  mapsto: "↦",
  mapstodown: "↧",
  mapstoleft: "↤",
  mapstoup: "↥",
  marker: "▮",
  mcomma: "⨩",
  mcy: "м",
  mdash: "—",
  measuredangle: "∡",
  mfr: "𝔪",
  mho: "℧",
  micr: "µ",
  micro: "µ",
  mid: "∣",
  midast: "*",
  midcir: "⫰",
  middo: "·",
  middot: "·",
  minus: "−",
  minusb: "⊟",
  minusd: "∸",
  minusdu: "⨪",
  mlcp: "⫛",
  mldr: "…",
  mnplus: "∓",
  models: "⊧",
  mopf: "𝕞",
  mp: "∓",
  mscr: "𝓂",
  mstpos: "∾",
  mu: "μ",
  multimap: "⊸",
  mumap: "⊸",
  nGg: "⋙̸",
  nGt: "≫⃒",
  nGtv: "≫̸",
  nLeftarrow: "⇍",
  nLeftrightarrow: "⇎",
  nLl: "⋘̸",
  nLt: "≪⃒",
  nLtv: "≪̸",
  nRightarrow: "⇏",
  nVDash: "⊯",
  nVdash: "⊮",
  nabla: "∇",
  nacute: "ń",
  nang: "∠⃒",
  nap: "≉",
  napE: "⩰̸",
  napid: "≋̸",
  napos: "ŉ",
  napprox: "≉",
  natur: "♮",
  natural: "♮",
  naturals: "ℕ",
  nbs: " ",
  nbsp: " ",
  nbump: "≎̸",
  nbumpe: "≏̸",
  ncap: "⩃",
  ncaron: "ň",
  ncedil: "ņ",
  ncong: "≇",
  ncongdot: "⩭̸",
  ncup: "⩂",
  ncy: "н",
  ndash: "–",
  ne: "≠",
  neArr: "⇗",
  nearhk: "⤤",
  nearr: "↗",
  nearrow: "↗",
  nedot: "≐̸",
  nequiv: "≢",
  nesear: "⤨",
  nesim: "≂̸",
  nexist: "∄",
  nexists: "∄",
  nfr: "𝔫",
  ngE: "≧̸",
  nge: "≱",
  ngeq: "≱",
  ngeqq: "≧̸",
  ngeqslant: "⩾̸",
  nges: "⩾̸",
  ngsim: "≵",
  ngt: "≯",
  ngtr: "≯",
  nhArr: "⇎",
  nharr: "↮",
  nhpar: "⫲",
  ni: "∋",
  nis: "⋼",
  nisd: "⋺",
  niv: "∋",
  njcy: "њ",
  nlArr: "⇍",
  nlE: "≦̸",
  nlarr: "↚",
  nldr: "‥",
  nle: "≰",
  nleftarrow: "↚",
  nleftrightarrow: "↮",
  nleq: "≰",
  nleqq: "≦̸",
  nleqslant: "⩽̸",
  nles: "⩽̸",
  nless: "≮",
  nlsim: "≴",
  nlt: "≮",
  nltri: "⋪",
  nltrie: "⋬",
  nmid: "∤",
  nopf: "𝕟",
  no: "¬",
  not: "¬",
  notin: "∉",
  notinE: "⋹̸",
  notindot: "⋵̸",
  notinva: "∉",
  notinvb: "⋷",
  notinvc: "⋶",
  notni: "∌",
  notniva: "∌",
  notnivb: "⋾",
  notnivc: "⋽",
  npar: "∦",
  nparallel: "∦",
  nparsl: "⫽⃥",
  npart: "∂̸",
  npolint: "⨔",
  npr: "⊀",
  nprcue: "⋠",
  npre: "⪯̸",
  nprec: "⊀",
  npreceq: "⪯̸",
  nrArr: "⇏",
  nrarr: "↛",
  nrarrc: "⤳̸",
  nrarrw: "↝̸",
  nrightarrow: "↛",
  nrtri: "⋫",
  nrtrie: "⋭",
  nsc: "⊁",
  nsccue: "⋡",
  nsce: "⪰̸",
  nscr: "𝓃",
  nshortmid: "∤",
  nshortparallel: "∦",
  nsim: "≁",
  nsime: "≄",
  nsimeq: "≄",
  nsmid: "∤",
  nspar: "∦",
  nsqsube: "⋢",
  nsqsupe: "⋣",
  nsub: "⊄",
  nsubE: "⫅̸",
  nsube: "⊈",
  nsubset: "⊂⃒",
  nsubseteq: "⊈",
  nsubseteqq: "⫅̸",
  nsucc: "⊁",
  nsucceq: "⪰̸",
  nsup: "⊅",
  nsupE: "⫆̸",
  nsupe: "⊉",
  nsupset: "⊃⃒",
  nsupseteq: "⊉",
  nsupseteqq: "⫆̸",
  ntgl: "≹",
  ntild: "ñ",
  ntilde: "ñ",
  ntlg: "≸",
  ntriangleleft: "⋪",
  ntrianglelefteq: "⋬",
  ntriangleright: "⋫",
  ntrianglerighteq: "⋭",
  nu: "ν",
  num: "#",
  numero: "№",
  numsp: " ",
  nvDash: "⊭",
  nvHarr: "⤄",
  nvap: "≍⃒",
  nvdash: "⊬",
  nvge: "≥⃒",
  nvgt: ">⃒",
  nvinfin: "⧞",
  nvlArr: "⤂",
  nvle: "≤⃒",
  nvlt: "<⃒",
  nvltrie: "⊴⃒",
  nvrArr: "⤃",
  nvrtrie: "⊵⃒",
  nvsim: "∼⃒",
  nwArr: "⇖",
  nwarhk: "⤣",
  nwarr: "↖",
  nwarrow: "↖",
  nwnear: "⤧",
  oS: "Ⓢ",
  oacut: "ó",
  oacute: "ó",
  oast: "⊛",
  ocir: "ô",
  ocirc: "ô",
  ocy: "о",
  odash: "⊝",
  odblac: "ő",
  odiv: "⨸",
  odot: "⊙",
  odsold: "⦼",
  oelig: "œ",
  ofcir: "⦿",
  ofr: "𝔬",
  ogon: "˛",
  ograv: "ò",
  ograve: "ò",
  ogt: "⧁",
  ohbar: "⦵",
  ohm: "Ω",
  oint: "∮",
  olarr: "↺",
  olcir: "⦾",
  olcross: "⦻",
  oline: "‾",
  olt: "⧀",
  omacr: "ō",
  omega: "ω",
  omicron: "ο",
  omid: "⦶",
  ominus: "⊖",
  oopf: "𝕠",
  opar: "⦷",
  operp: "⦹",
  oplus: "⊕",
  or: "∨",
  orarr: "↻",
  ord: "º",
  order: "ℴ",
  orderof: "ℴ",
  ordf: "ª",
  ordm: "º",
  origof: "⊶",
  oror: "⩖",
  orslope: "⩗",
  orv: "⩛",
  oscr: "ℴ",
  oslas: "ø",
  oslash: "ø",
  osol: "⊘",
  otild: "õ",
  otilde: "õ",
  otimes: "⊗",
  otimesas: "⨶",
  oum: "ö",
  ouml: "ö",
  ovbar: "⌽",
  par: "¶",
  para: "¶",
  parallel: "∥",
  parsim: "⫳",
  parsl: "⫽",
  part: "∂",
  pcy: "п",
  percnt: "%",
  period: ".",
  permil: "‰",
  perp: "⊥",
  pertenk: "‱",
  pfr: "𝔭",
  phi: "φ",
  phiv: "ϕ",
  phmmat: "ℳ",
  phone: "☎",
  pi: "π",
  pitchfork: "⋔",
  piv: "ϖ",
  planck: "ℏ",
  planckh: "ℎ",
  plankv: "ℏ",
  plus: "+",
  plusacir: "⨣",
  plusb: "⊞",
  pluscir: "⨢",
  plusdo: "∔",
  plusdu: "⨥",
  pluse: "⩲",
  plusm: "±",
  plusmn: "±",
  plussim: "⨦",
  plustwo: "⨧",
  pm: "±",
  pointint: "⨕",
  popf: "𝕡",
  poun: "£",
  pound: "£",
  pr: "≺",
  prE: "⪳",
  prap: "⪷",
  prcue: "≼",
  pre: "⪯",
  prec: "≺",
  precapprox: "⪷",
  preccurlyeq: "≼",
  preceq: "⪯",
  precnapprox: "⪹",
  precneqq: "⪵",
  precnsim: "⋨",
  precsim: "≾",
  prime: "′",
  primes: "ℙ",
  prnE: "⪵",
  prnap: "⪹",
  prnsim: "⋨",
  prod: "∏",
  profalar: "⌮",
  profline: "⌒",
  profsurf: "⌓",
  prop: "∝",
  propto: "∝",
  prsim: "≾",
  prurel: "⊰",
  pscr: "𝓅",
  psi: "ψ",
  puncsp: " ",
  qfr: "𝔮",
  qint: "⨌",
  qopf: "𝕢",
  qprime: "⁗",
  qscr: "𝓆",
  quaternions: "ℍ",
  quatint: "⨖",
  quest: "?",
  questeq: "≟",
  quo: '"',
  quot: '"',
  rAarr: "⇛",
  rArr: "⇒",
  rAtail: "⤜",
  rBarr: "⤏",
  rHar: "⥤",
  race: "∽̱",
  racute: "ŕ",
  radic: "√",
  raemptyv: "⦳",
  rang: "⟩",
  rangd: "⦒",
  range: "⦥",
  rangle: "⟩",
  raqu: "»",
  raquo: "»",
  rarr: "→",
  rarrap: "⥵",
  rarrb: "⇥",
  rarrbfs: "⤠",
  rarrc: "⤳",
  rarrfs: "⤞",
  rarrhk: "↪",
  rarrlp: "↬",
  rarrpl: "⥅",
  rarrsim: "⥴",
  rarrtl: "↣",
  rarrw: "↝",
  ratail: "⤚",
  ratio: "∶",
  rationals: "ℚ",
  rbarr: "⤍",
  rbbrk: "❳",
  rbrace: "}",
  rbrack: "]",
  rbrke: "⦌",
  rbrksld: "⦎",
  rbrkslu: "⦐",
  rcaron: "ř",
  rcedil: "ŗ",
  rceil: "⌉",
  rcub: "}",
  rcy: "р",
  rdca: "⤷",
  rdldhar: "⥩",
  rdquo: "”",
  rdquor: "”",
  rdsh: "↳",
  real: "ℜ",
  realine: "ℛ",
  realpart: "ℜ",
  reals: "ℝ",
  rect: "▭",
  re: "®",
  reg: "®",
  rfisht: "⥽",
  rfloor: "⌋",
  rfr: "𝔯",
  rhard: "⇁",
  rharu: "⇀",
  rharul: "⥬",
  rho: "ρ",
  rhov: "ϱ",
  rightarrow: "→",
  rightarrowtail: "↣",
  rightharpoondown: "⇁",
  rightharpoonup: "⇀",
  rightleftarrows: "⇄",
  rightleftharpoons: "⇌",
  rightrightarrows: "⇉",
  rightsquigarrow: "↝",
  rightthreetimes: "⋌",
  ring: "˚",
  risingdotseq: "≓",
  rlarr: "⇄",
  rlhar: "⇌",
  rlm: "‏",
  rmoust: "⎱",
  rmoustache: "⎱",
  rnmid: "⫮",
  roang: "⟭",
  roarr: "⇾",
  robrk: "⟧",
  ropar: "⦆",
  ropf: "𝕣",
  roplus: "⨮",
  rotimes: "⨵",
  rpar: ")",
  rpargt: "⦔",
  rppolint: "⨒",
  rrarr: "⇉",
  rsaquo: "›",
  rscr: "𝓇",
  rsh: "↱",
  rsqb: "]",
  rsquo: "’",
  rsquor: "’",
  rthree: "⋌",
  rtimes: "⋊",
  rtri: "▹",
  rtrie: "⊵",
  rtrif: "▸",
  rtriltri: "⧎",
  ruluhar: "⥨",
  rx: "℞",
  sacute: "ś",
  sbquo: "‚",
  sc: "≻",
  scE: "⪴",
  scap: "⪸",
  scaron: "š",
  sccue: "≽",
  sce: "⪰",
  scedil: "ş",
  scirc: "ŝ",
  scnE: "⪶",
  scnap: "⪺",
  scnsim: "⋩",
  scpolint: "⨓",
  scsim: "≿",
  scy: "с",
  sdot: "⋅",
  sdotb: "⊡",
  sdote: "⩦",
  seArr: "⇘",
  searhk: "⤥",
  searr: "↘",
  searrow: "↘",
  sec: "§",
  sect: "§",
  semi: ";",
  seswar: "⤩",
  setminus: "∖",
  setmn: "∖",
  sext: "✶",
  sfr: "𝔰",
  sfrown: "⌢",
  sharp: "♯",
  shchcy: "щ",
  shcy: "ш",
  shortmid: "∣",
  shortparallel: "∥",
  sh: "­",
  shy: "­",
  sigma: "σ",
  sigmaf: "ς",
  sigmav: "ς",
  sim: "∼",
  simdot: "⩪",
  sime: "≃",
  simeq: "≃",
  simg: "⪞",
  simgE: "⪠",
  siml: "⪝",
  simlE: "⪟",
  simne: "≆",
  simplus: "⨤",
  simrarr: "⥲",
  slarr: "←",
  smallsetminus: "∖",
  smashp: "⨳",
  smeparsl: "⧤",
  smid: "∣",
  smile: "⌣",
  smt: "⪪",
  smte: "⪬",
  smtes: "⪬︀",
  softcy: "ь",
  sol: "/",
  solb: "⧄",
  solbar: "⌿",
  sopf: "𝕤",
  spades: "♠",
  spadesuit: "♠",
  spar: "∥",
  sqcap: "⊓",
  sqcaps: "⊓︀",
  sqcup: "⊔",
  sqcups: "⊔︀",
  sqsub: "⊏",
  sqsube: "⊑",
  sqsubset: "⊏",
  sqsubseteq: "⊑",
  sqsup: "⊐",
  sqsupe: "⊒",
  sqsupset: "⊐",
  sqsupseteq: "⊒",
  squ: "□",
  square: "□",
  squarf: "▪",
  squf: "▪",
  srarr: "→",
  sscr: "𝓈",
  ssetmn: "∖",
  ssmile: "⌣",
  sstarf: "⋆",
  star: "☆",
  starf: "★",
  straightepsilon: "ϵ",
  straightphi: "ϕ",
  strns: "¯",
  sub: "⊂",
  subE: "⫅",
  subdot: "⪽",
  sube: "⊆",
  subedot: "⫃",
  submult: "⫁",
  subnE: "⫋",
  subne: "⊊",
  subplus: "⪿",
  subrarr: "⥹",
  subset: "⊂",
  subseteq: "⊆",
  subseteqq: "⫅",
  subsetneq: "⊊",
  subsetneqq: "⫋",
  subsim: "⫇",
  subsub: "⫕",
  subsup: "⫓",
  succ: "≻",
  succapprox: "⪸",
  succcurlyeq: "≽",
  succeq: "⪰",
  succnapprox: "⪺",
  succneqq: "⪶",
  succnsim: "⋩",
  succsim: "≿",
  sum: "∑",
  sung: "♪",
  sup: "⊃",
  sup1: "¹",
  sup2: "²",
  sup3: "³",
  supE: "⫆",
  supdot: "⪾",
  supdsub: "⫘",
  supe: "⊇",
  supedot: "⫄",
  suphsol: "⟉",
  suphsub: "⫗",
  suplarr: "⥻",
  supmult: "⫂",
  supnE: "⫌",
  supne: "⊋",
  supplus: "⫀",
  supset: "⊃",
  supseteq: "⊇",
  supseteqq: "⫆",
  supsetneq: "⊋",
  supsetneqq: "⫌",
  supsim: "⫈",
  supsub: "⫔",
  supsup: "⫖",
  swArr: "⇙",
  swarhk: "⤦",
  swarr: "↙",
  swarrow: "↙",
  swnwar: "⤪",
  szli: "ß",
  szlig: "ß",
  target: "⌖",
  tau: "τ",
  tbrk: "⎴",
  tcaron: "ť",
  tcedil: "ţ",
  tcy: "т",
  tdot: "⃛",
  telrec: "⌕",
  tfr: "𝔱",
  there4: "∴",
  therefore: "∴",
  theta: "θ",
  thetasym: "ϑ",
  thetav: "ϑ",
  thickapprox: "≈",
  thicksim: "∼",
  thinsp: " ",
  thkap: "≈",
  thksim: "∼",
  thor: "þ",
  thorn: "þ",
  tilde: "˜",
  time: "×",
  times: "×",
  timesb: "⊠",
  timesbar: "⨱",
  timesd: "⨰",
  tint: "∭",
  toea: "⤨",
  top: "⊤",
  topbot: "⌶",
  topcir: "⫱",
  topf: "𝕥",
  topfork: "⫚",
  tosa: "⤩",
  tprime: "‴",
  trade: "™",
  triangle: "▵",
  triangledown: "▿",
  triangleleft: "◃",
  trianglelefteq: "⊴",
  triangleq: "≜",
  triangleright: "▹",
  trianglerighteq: "⊵",
  tridot: "◬",
  trie: "≜",
  triminus: "⨺",
  triplus: "⨹",
  trisb: "⧍",
  tritime: "⨻",
  trpezium: "⏢",
  tscr: "𝓉",
  tscy: "ц",
  tshcy: "ћ",
  tstrok: "ŧ",
  twixt: "≬",
  twoheadleftarrow: "↞",
  twoheadrightarrow: "↠",
  uArr: "⇑",
  uHar: "⥣",
  uacut: "ú",
  uacute: "ú",
  uarr: "↑",
  ubrcy: "ў",
  ubreve: "ŭ",
  ucir: "û",
  ucirc: "û",
  ucy: "у",
  udarr: "⇅",
  udblac: "ű",
  udhar: "⥮",
  ufisht: "⥾",
  ufr: "𝔲",
  ugrav: "ù",
  ugrave: "ù",
  uharl: "↿",
  uharr: "↾",
  uhblk: "▀",
  ulcorn: "⌜",
  ulcorner: "⌜",
  ulcrop: "⌏",
  ultri: "◸",
  umacr: "ū",
  um: "¨",
  uml: "¨",
  uogon: "ų",
  uopf: "𝕦",
  uparrow: "↑",
  updownarrow: "↕",
  upharpoonleft: "↿",
  upharpoonright: "↾",
  uplus: "⊎",
  upsi: "υ",
  upsih: "ϒ",
  upsilon: "υ",
  upuparrows: "⇈",
  urcorn: "⌝",
  urcorner: "⌝",
  urcrop: "⌎",
  uring: "ů",
  urtri: "◹",
  uscr: "𝓊",
  utdot: "⋰",
  utilde: "ũ",
  utri: "▵",
  utrif: "▴",
  uuarr: "⇈",
  uum: "ü",
  uuml: "ü",
  uwangle: "⦧",
  vArr: "⇕",
  vBar: "⫨",
  vBarv: "⫩",
  vDash: "⊨",
  vangrt: "⦜",
  varepsilon: "ϵ",
  varkappa: "ϰ",
  varnothing: "∅",
  varphi: "ϕ",
  varpi: "ϖ",
  varpropto: "∝",
  varr: "↕",
  varrho: "ϱ",
  varsigma: "ς",
  varsubsetneq: "⊊︀",
  varsubsetneqq: "⫋︀",
  varsupsetneq: "⊋︀",
  varsupsetneqq: "⫌︀",
  vartheta: "ϑ",
  vartriangleleft: "⊲",
  vartriangleright: "⊳",
  vcy: "в",
  vdash: "⊢",
  vee: "∨",
  veebar: "⊻",
  veeeq: "≚",
  vellip: "⋮",
  verbar: "|",
  vert: "|",
  vfr: "𝔳",
  vltri: "⊲",
  vnsub: "⊂⃒",
  vnsup: "⊃⃒",
  vopf: "𝕧",
  vprop: "∝",
  vrtri: "⊳",
  vscr: "𝓋",
  vsubnE: "⫋︀",
  vsubne: "⊊︀",
  vsupnE: "⫌︀",
  vsupne: "⊋︀",
  vzigzag: "⦚",
  wcirc: "ŵ",
  wedbar: "⩟",
  wedge: "∧",
  wedgeq: "≙",
  weierp: "℘",
  wfr: "𝔴",
  wopf: "𝕨",
  wp: "℘",
  wr: "≀",
  wreath: "≀",
  wscr: "𝓌",
  xcap: "⋂",
  xcirc: "◯",
  xcup: "⋃",
  xdtri: "▽",
  xfr: "𝔵",
  xhArr: "⟺",
  xharr: "⟷",
  xi: "ξ",
  xlArr: "⟸",
  xlarr: "⟵",
  xmap: "⟼",
  xnis: "⋻",
  xodot: "⨀",
  xopf: "𝕩",
  xoplus: "⨁",
  xotime: "⨂",
  xrArr: "⟹",
  xrarr: "⟶",
  xscr: "𝓍",
  xsqcup: "⨆",
  xuplus: "⨄",
  xutri: "△",
  xvee: "⋁",
  xwedge: "⋀",
  yacut: "ý",
  yacute: "ý",
  yacy: "я",
  ycirc: "ŷ",
  ycy: "ы",
  ye: "¥",
  yen: "¥",
  yfr: "𝔶",
  yicy: "ї",
  yopf: "𝕪",
  yscr: "𝓎",
  yucy: "ю",
  yum: "ÿ",
  yuml: "ÿ",
  zacute: "ź",
  zcaron: "ž",
  zcy: "з",
  zdot: "ż",
  zeetrf: "ℨ",
  zeta: "ζ",
  zfr: "𝔷",
  zhcy: "ж",
  zigrarr: "⇝",
  zopf: "𝕫",
  zscr: "𝓏",
  zwj: "‍",
  zwnj: "‌",
  default: et
})),
    nt = function nt(r) {
  return !!ot.call(tt, r) && tt[r];
},
    ot = {}.hasOwnProperty;

var it = ir(Xe),
    at = ir(Ze),
    lt = function lt(r, e) {
  var t,
      n,
      o = {};
  e || (e = {});

  for (n in pt) {
    t = e[n], o[n] = null == t ? pt[n] : t;
  }

  (o.position.indent || o.position.start) && (o.indent = o.position.indent || [], o.position = o.position.start);
  return function (r, e) {
    var t,
        n,
        o,
        i,
        a,
        l,
        s,
        c,
        u,
        p,
        f,
        d,
        g,
        h,
        m,
        b,
        y,
        v,
        w,
        k = e.additional,
        q = e.nonTerminated,
        A = e.text,
        x = e.reference,
        S = e.warning,
        E = e.textContext,
        L = e.referenceContext,
        T = e.warningContext,
        R = e.position,
        C = e.indent || [],
        D = r.length,
        O = 0,
        B = -1,
        N = R.column || 1,
        I = R.line || 1,
        z = "",
        j = [];
    "string" == typeof k && (k = k.charCodeAt(0));
    b = P(), c = S ? function (r, e) {
      var t = P();
      t.column += e, t.offset += e, S.call(T, mt[r], t, r);
    } : ut, O--, D++;

    for (; ++O < D;) {
      if (10 === a && (N = C[B] || 1), 38 === (a = r.charCodeAt(O))) {
        if (9 === (s = r.charCodeAt(O + 1)) || 10 === s || 12 === s || 32 === s || 38 === s || 60 === s || s != s || k && s === k) {
          z += ct(a), N++;
          continue;
        }

        for (d = g = O + 1, w = g, 35 === s ? (w = ++d, 88 === (s = r.charCodeAt(w)) || 120 === s ? (h = dt, w = ++d) : h = "decimal") : h = ft, t = "", f = "", i = "", m = ht[h], w--; ++w < D && (s = r.charCodeAt(w), m(s));) {
          i += ct(s), h === ft && st.call(it, i) && (t = i, f = it[i]);
        }

        (o = 59 === r.charCodeAt(w)) && (w++, (n = h === ft && nt(i)) && (t = i, f = n)), v = 1 + w - g, (o || q) && (i ? h === ft ? (o && !f ? c(5, 1) : (t !== i && (w = d + t.length, v = 1 + w - d, o = !1), o || (u = t ? 1 : 3, e.attribute ? 61 === (s = r.charCodeAt(w)) ? (c(u, v), f = null) : rt(s) ? f = null : c(u, v) : c(u, v))), l = f) : (o || c(2, v), l = parseInt(i, gt[h]), (U = l) >= 55296 && U <= 57343 || U > 1114111 ? (c(7, v), l = ct(65533)) : l in at ? (c(6, v), l = at[l]) : (p = "", bt(l) && c(6, v), l > 65535 && (p += ct((l -= 65536) >>> 10 | 55296), l = 56320 | 1023 & l), l = p + ct(l))) : h !== ft && c(4, v)), l ? (H(), b = P(), O = w - 1, N += w - g + 1, j.push(l), (y = P()).offset++, x && x.call(L, l, {
          start: b,
          end: y
        }, r.slice(g - 1, w)), b = y) : (i = r.slice(g - 1, w), z += i, N += i.length, O = w - 1);
      } else 10 === a && (I++, B++, N = 0), a == a ? (z += ct(a), N++) : H();
    }

    var U;
    return j.join("");

    function P() {
      return {
        line: I,
        column: N,
        offset: O + (R.offset || 0)
      };
    }

    function H() {
      z && (j.push(z), A && A.call(E, z, {
        start: b,
        end: P()
      }), z = "");
    }
  }(r, o);
},
    st = {}.hasOwnProperty,
    ct = String.fromCharCode,
    ut = Function.prototype,
    pt = {
  warning: null,
  reference: null,
  text: null,
  warningContext: null,
  referenceContext: null,
  textContext: null,
  position: {},
  additional: null,
  attribute: !1,
  nonTerminated: !0
},
    ft = "named",
    dt = "hexadecimal",
    gt = {
  hexadecimal: 16,
  decimal: 10
},
    ht = {};

ht.named = rt, ht.decimal = Je, ht[dt] = Ke;
var mt = {};

function bt(r) {
  return r >= 1 && r <= 8 || 11 === r || r >= 13 && r <= 31 || r >= 127 && r <= 159 || r >= 64976 && r <= 65007 || 65535 == (65535 & r) || 65534 == (65535 & r);
}

mt[1] = "Named character references must be terminated by a semicolon", mt[2] = "Numeric character references must be terminated by a semicolon", mt[3] = "Named character references cannot be empty", mt[4] = "Numeric character references cannot be empty", mt[5] = "Named character references must be known", mt[6] = "Numeric character references cannot be disallowed", mt[7] = "Numeric character references cannot be outside the permissible Unicode range";

var yt = function yt(r) {
  return n.raw = o, n;

  function e(e) {
    for (var t = r.offset, n = e.line, o = []; ++n && n in t;) {
      o.push((t[n] || 0) + 1);
    }

    return {
      start: e,
      indent: o
    };
  }

  function t(e, t, n) {
    3 !== n && r.file.message(e, t);
  }

  function n(n, o, i) {
    lt(n, {
      position: e(o),
      warning: t,
      text: i,
      reference: i,
      textContext: r,
      referenceContext: r
    });
  }

  function o(r, n, o) {
    return lt(r, Hr(o, {
      position: e(n),
      warning: t
    }));
  }
};

var vt = function vt(r) {
  return function (e, t) {
    var n,
        o,
        i,
        a,
        l,
        s,
        c = this,
        u = c.offset,
        p = [],
        f = c[r + "Methods"],
        d = c[r + "Tokenizers"],
        g = t.line,
        h = t.column;
    if (!e) return p;
    v.now = b, v.file = c.file, m("");

    for (; e;) {
      for (n = -1, o = f.length, l = !1; ++n < o && (a = f[n], !(i = d[a]) || i.onlyAtStart && !c.atStart || i.notInList && c.inList || i.notInBlock && c.inBlock || i.notInLink && c.inLink || (s = e.length, i.apply(c, [v, e]), !(l = s !== e.length)));) {
        ;
      }

      l || c.file.fail(new Error("Infinite loop"), v.now());
    }

    return c.eof = b(), p;

    function m(r) {
      for (var e = -1, t = r.indexOf("\n"); -1 !== t;) {
        g++, e = t, t = r.indexOf("\n", t + 1);
      }

      -1 === e ? h += r.length : h = r.length - e, g in u && (-1 !== e ? h += u[g] : h <= u[g] && (h = u[g] + 1));
    }

    function b() {
      var r = {
        line: g,
        column: h
      };
      return r.offset = c.toOffset(r), r;
    }

    function y(r) {
      this.start = r, this.end = b();
    }

    function v(r) {
      var t,
          n = function () {
        var r = [],
            e = g + 1;
        return function () {
          for (var t = g + 1; e < t;) {
            r.push((u[e] || 0) + 1), e++;
          }

          return r;
        };
      }(),
          o = (t = b(), function (r, e) {
        var n = r.position,
            o = n ? n.start : t,
            i = [],
            a = n && n.end.line,
            l = t.line;

        if (r.position = new y(o), n && e && n.indent) {
          if (i = n.indent, a < l) {
            for (; ++a < l;) {
              i.push((u[a] || 0) + 1);
            }

            i.push(t.column);
          }

          e = i.concat(e);
        }

        return r.position.indent = e || [], r;
      }),
          i = b();

      return function (r) {
        e.substring(0, r.length) !== r && c.file.fail(new Error("Incorrectly eaten value: please report this warning on http://git.io/vg5Ft"), b());
      }(r), a.reset = l, l.test = s, a.test = s, e = e.substring(r.length), m(r), n = n(), a;

      function a(r, e) {
        return o(function (r, e) {
          var t = e ? e.children : p,
              n = t[t.length - 1];
          return n && r.type === n.type && r.type in wt && kt(n) && kt(r) && (r = wt[r.type].call(c, n, r)), r !== n && t.push(r), c.atStart && 0 !== p.length && c.exitStart(), r;
        }(o(r), e), n);
      }

      function l() {
        var t = a.apply(null, arguments);
        return g = i.line, h = i.column, e = r + e, t;
      }

      function s() {
        var t = o({});
        return g = i.line, h = i.column, e = r + e, t.position;
      }
    }
  };
},
    wt = {
  text: function text(r, e) {
    return r.value += e.value, r;
  },
  blockquote: function blockquote(r, e) {
    if (this.options.commonmark) return e;
    return r.children = r.children.concat(e.children), r;
  }
};

function kt(r) {
  var e, t;
  return "text" !== r.type || !r.position || (e = r.position.start, t = r.position.end, e.line !== t.line || t.column - e.column === r.value.length);
}

var qt = Et,
    At = ["\\", "`", "*", "{", "}", "[", "]", "(", ")", "#", "+", "-", ".", "!", "_", ">"],
    xt = At.concat(["~", "|"]),
    St = xt.concat(["\n", '"', "$", "%", "&", "'", ",", "/", ":", ";", "<", "=", "?", "@", "^"]);

function Et(r) {
  var e = r || {};
  return e.commonmark ? St : e.gfm ? xt : At;
}

Et.default = At, Et.gfm = xt, Et.commonmark = St;

var Lt = {
  position: !0,
  gfm: !0,
  commonmark: !1,
  footnotes: !1,
  pedantic: !1,
  blocks: ir(Object.freeze({
    __proto__: null,
    default: ["address", "article", "aside", "base", "basefont", "blockquote", "body", "caption", "center", "col", "colgroup", "dd", "details", "dialog", "dir", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "legend", "li", "link", "main", "menu", "menuitem", "meta", "nav", "noframes", "ol", "optgroup", "option", "p", "param", "pre", "section", "source", "title", "summary", "table", "tbody", "td", "tfoot", "th", "thead", "title", "tr", "track", "ul"]
  }))
},
    Tt = function Tt(r) {
  var e,
      t,
      n = this.options;
  if (null == r) r = {};else {
    if ("object" != typeof r) throw new Error("Invalid value `" + r + "` for setting `options`");
    r = Hr(r);
  }

  for (e in Lt) {
    if (null == (t = r[e]) && (t = n[e]), "blocks" !== e && "boolean" != typeof t || "blocks" === e && "object" != typeof t) throw new Error("Invalid value `" + t + "` for setting `options." + e + "`");
    r[e] = t;
  }

  return this.options = r, this.escape = qt(r), this;
};

var Rt = Ct;

function Ct(r) {
  if ("string" == typeof r) return function (r) {
    return function (e) {
      return Boolean(e && e.type === r);
    };
  }(r);
  if (null == r) return Bt;
  if ("object" == typeof r) return ("length" in r ? Ot : Dt)(r);
  if ("function" == typeof r) return r;
  throw new Error("Expected function, string, or object as test");
}

function Dt(r) {
  return function (e) {
    var t;

    for (t in r) {
      if (e[t] !== r[t]) return !1;
    }

    return !0;
  };
}

function Ot(r) {
  var e = function (r) {
    for (var e = [], t = r.length, n = -1; ++n < t;) {
      e[n] = Ct(r[n]);
    }

    return e;
  }(r),
      t = e.length;

  return function () {
    var r = -1;

    for (; ++r < t;) {
      if (e[r].apply(this, arguments)) return !0;
    }

    return !1;
  };
}

function Bt() {
  return !0;
}

var Nt = It;

function It(r, e, t, n) {
  var o;

  function i(r, a, l) {
    var s,
        c = [];
    return (e && !o(r, a, l[l.length - 1] || null) || !1 !== (c = zt(t(r, l)))[0]) && r.children && "skip" !== c[0] && !1 === (s = zt(function (r, e) {
      var t,
          o = n ? -1 : 1,
          a = (n ? r.length : -1) + o;

      for (; a > -1 && a < r.length;) {
        if (!1 === (t = i(r[a], a, e))[0]) return t;
        a = "number" == typeof t[1] ? t[1] : a + o;
      }
    }(r.children, l.concat(r))))[0] ? s : c;
  }

  "function" == typeof e && "function" != typeof t && (n = t, t = e, e = null), o = Rt(e), i(r, null, []);
}

function zt(r) {
  return null !== r && "object" == typeof r && "length" in r ? r : "number" == typeof r ? [!0, r] : [r];
}

It.CONTINUE = !0, It.SKIP = "skip", It.EXIT = !1;
var jt = Vt,
    Ut = Nt.CONTINUE,
    Pt = Nt.SKIP,
    Ht = Nt.EXIT;

function Vt(r, e, t, n) {
  "function" == typeof e && "function" != typeof t && (n = t, t = e, e = null), Nt(r, e, function (r, e) {
    var n = e[e.length - 1],
        o = n ? n.children.indexOf(r) : null;
    return t(r, o, n);
  }, n);
}

Vt.CONTINUE = Ut, Vt.SKIP = Pt, Vt.EXIT = Ht;

var Gt = function Gt(r, e) {
  return jt(r, e ? Wt : _t), r;
};

function Wt(r) {
  delete r.position;
}

function _t(r) {
  r.position = void 0;
}

var Ft = function Ft() {
  var r,
      e = String(this.file),
      t = {
    line: 1,
    column: 1,
    offset: 0
  },
      n = Hr(t);
  65279 === (e = e.replace(Mt, "\n")).charCodeAt(0) && (e = e.slice(1), n.column++, n.offset++);
  r = {
    type: "root",
    children: this.tokenizeBlock(e, n),
    position: {
      start: t,
      end: this.eof || Hr(t)
    }
  }, this.options.position || Gt(r, !0);
  return r;
},
    Mt = /\r\n|\r/g;

var Yt = function Yt(r) {
  return Xt.test("number" == typeof r ? $t(r) : r.charAt(0));
},
    $t = String.fromCharCode,
    Xt = /\s/;

var Zt = function Zt(r, e, t) {
  var n,
      o,
      i,
      a,
      l = e.charAt(0);
  if ("\n" !== l) return;
  if (t) return !0;
  a = 1, n = e.length, o = l, i = "";

  for (; a < n && (l = e.charAt(a), Yt(l));) {
    i += l, "\n" === l && (o += i, i = ""), a++;
  }

  r(o);
}
/*!
 * repeat-string <https://github.com/jonschlinkert/repeat-string>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */
;

var Jt,
    Kt = "",
    Qt = function Qt(r, e) {
  if ("string" != typeof r) throw new TypeError("expected a string");
  if (1 === e) return r;
  if (2 === e) return r + r;
  var t = r.length * e;
  if (Jt !== r || void 0 === Jt) Jt = r, Kt = "";else if (Kt.length >= t) return Kt.substr(0, t);

  for (; t > Kt.length && e > 1;) {
    1 & e && (Kt += r), e >>= 1, r += r;
  }

  return Kt = (Kt += r).substr(0, t);
};

var rn = function rn(r) {
  return String(r).replace(/\n+$/, "");
};

var en = function en(r, e, t) {
  var n,
      o,
      i,
      a = -1,
      l = e.length,
      s = "",
      c = "",
      u = "",
      p = "";

  for (; ++a < l;) {
    if (n = e.charAt(a), i) {
      if (i = !1, s += u, c += p, u = "", p = "", "\n" === n) u = n, p = n;else for (s += n, c += n; ++a < l;) {
        if (!(n = e.charAt(a)) || "\n" === n) {
          p = n, u = n;
          break;
        }

        s += n, c += n;
      }
    } else if (" " === n && e.charAt(a + 1) === n && e.charAt(a + 2) === n && e.charAt(a + 3) === n) u += tn, a += 3, i = !0;else if ("\t" === n) u += n, i = !0;else {
      for (o = ""; "\t" === n || " " === n;) {
        o += n, n = e.charAt(++a);
      }

      if ("\n" !== n) break;
      u += o + n, p += n;
    }
  }

  if (c) return !!t || r(s)({
    type: "code",
    lang: null,
    value: rn(c)
  });
},
    tn = Qt(" ", 4);

var nn = function nn(r, e, t) {
  var n,
      o,
      i,
      a,
      l,
      s,
      c,
      u,
      p,
      f,
      d,
      g = this.options,
      h = e.length + 1,
      m = 0,
      b = "";
  if (!g.gfm) return;

  for (; m < h && (" " === (i = e.charAt(m)) || "\t" === i);) {
    b += i, m++;
  }

  if (f = m, "~" !== (i = e.charAt(m)) && "`" !== i) return;
  m++, o = i, n = 1, b += i;

  for (; m < h && (i = e.charAt(m)) === o;) {
    b += i, n++, m++;
  }

  if (n < 3) return;

  for (; m < h && (" " === (i = e.charAt(m)) || "\t" === i);) {
    b += i, m++;
  }

  a = "", l = "";

  for (; m < h && "\n" !== (i = e.charAt(m)) && "~" !== i && "`" !== i;) {
    " " === i || "\t" === i ? l += i : (a += l + i, l = ""), m++;
  }

  if ((i = e.charAt(m)) && "\n" !== i) return;
  if (t) return !0;
  (d = r.now()).column += b.length, d.offset += b.length, b += a, a = this.decode.raw(this.unescape(a), d), l && (b += l);
  l = "", u = "", p = "", s = "", c = "";

  for (; m < h;) {
    if (i = e.charAt(m), s += u, c += p, u = "", p = "", "\n" === i) {
      for (s ? (u += i, p += i) : b += i, l = "", m++; m < h && " " === (i = e.charAt(m));) {
        l += i, m++;
      }

      if (u += l, p += l.slice(f), !(l.length >= 4)) {
        for (l = ""; m < h && (i = e.charAt(m)) === o;) {
          l += i, m++;
        }

        if (u += l, p += l, !(l.length < n)) {
          for (l = ""; m < h && (" " === (i = e.charAt(m)) || "\t" === i);) {
            u += i, p += i, m++;
          }

          if (!i || "\n" === i) break;
        }
      }
    } else s += i, p += i, m++;
  }

  return r(b += s + u)({
    type: "code",
    lang: a || null,
    value: rn(c)
  });
};

var on = or(function (r, e) {
  (e = r.exports = function (r) {
    return r.replace(/^\s*|\s*$/g, "");
  }).left = function (r) {
    return r.replace(/^\s*/, "");
  }, e.right = function (r) {
    return r.replace(/\s*$/, "");
  };
}),
    an = (on.left, on.right, function (r, e, t, n) {
  var o,
      i,
      a,
      l,
      s,
      c,
      u = ["pedantic", "commonmark"],
      p = u.length,
      f = r.length,
      d = -1;

  for (; ++d < f;) {
    for (o = r[d], i = o[1] || {}, a = o[0], l = -1, c = !1; ++l < p;) {
      if (void 0 !== i[s = u[l]] && i[s] !== t.options[s]) {
        c = !0;
        break;
      }
    }

    if (!c && e[a].apply(t, n)) return !0;
  }

  return !1;
});

var ln = function ln(r, e, t) {
  var n,
      o,
      i,
      a,
      l,
      s,
      c,
      u,
      p,
      f = this.offset,
      d = this.blockTokenizers,
      g = this.interruptBlockquote,
      h = r.now(),
      m = h.line,
      b = e.length,
      y = [],
      v = [],
      w = [],
      k = 0;

  for (; k < b && (" " === (o = e.charAt(k)) || "\t" === o);) {
    k++;
  }

  if (">" !== e.charAt(k)) return;
  if (t) return !0;
  k = 0;

  for (; k < b;) {
    for (a = e.indexOf("\n", k), c = k, u = !1, -1 === a && (a = b); k < b && (" " === (o = e.charAt(k)) || "\t" === o);) {
      k++;
    }

    if (">" === e.charAt(k) ? (k++, u = !0, " " === e.charAt(k) && k++) : k = c, l = e.slice(k, a), !u && !on(l)) {
      k = c;
      break;
    }

    if (!u && (i = e.slice(k), an(g, d, this, [r, i, !0]))) break;
    s = c === k ? l : e.slice(c, a), w.push(k - c), y.push(s), v.push(l), k = a + 1;
  }

  k = -1, b = w.length, n = r(y.join("\n"));

  for (; ++k < b;) {
    f[m] = (f[m] || 0) + w[k], m++;
  }

  return p = this.enterBlock(), v = this.tokenizeBlock(v.join("\n"), h), p(), n({
    type: "blockquote",
    children: v
  });
};

var sn = function sn(r, e, t) {
  var n,
      o,
      i,
      a = this.options,
      l = e.length + 1,
      s = -1,
      c = r.now(),
      u = "",
      p = "";

  for (; ++s < l;) {
    if (" " !== (n = e.charAt(s)) && "\t" !== n) {
      s--;
      break;
    }

    u += n;
  }

  i = 0;

  for (; ++s <= l;) {
    if ("#" !== (n = e.charAt(s))) {
      s--;
      break;
    }

    u += n, i++;
  }

  if (i > 6) return;
  if (!i || !a.pedantic && "#" === e.charAt(s + 1)) return;
  l = e.length + 1, o = "";

  for (; ++s < l;) {
    if (" " !== (n = e.charAt(s)) && "\t" !== n) {
      s--;
      break;
    }

    o += n;
  }

  if (!a.pedantic && 0 === o.length && n && "\n" !== n) return;
  if (t) return !0;
  u += o, o = "", p = "";

  for (; ++s < l && (n = e.charAt(s)) && "\n" !== n;) {
    if (" " === n || "\t" === n || "#" === n) {
      for (; " " === n || "\t" === n;) {
        o += n, n = e.charAt(++s);
      }

      for (; "#" === n;) {
        o += n, n = e.charAt(++s);
      }

      for (; " " === n || "\t" === n;) {
        o += n, n = e.charAt(++s);
      }

      s--;
    } else p += o + n, o = "";
  }

  return c.column += u.length, c.offset += u.length, r(u += p + o)({
    type: "heading",
    depth: i,
    children: this.tokenizeInline(p, c)
  });
};

var cn = function cn(r, e, t) {
  var n,
      o,
      i,
      a,
      l = -1,
      s = e.length + 1,
      c = "";

  for (; ++l < s && ("\t" === (n = e.charAt(l)) || " " === n);) {
    c += n;
  }

  if ("*" !== n && "-" !== n && "_" !== n) return;
  o = n, c += n, i = 1, a = "";

  for (; ++l < s;) {
    if ((n = e.charAt(l)) === o) i++, c += a + o, a = "";else {
      if (" " !== n) return i >= 3 && (!n || "\n" === n) ? (c += a, !!t || r(c)({
        type: "thematicBreak"
      })) : void 0;
      a += n;
    }
  }
};

var un = function un(r) {
  var e,
      t = 0,
      n = 0,
      o = r.charAt(t),
      i = {};

  for (; (o in pn);) {
    n += e = pn[o], e > 1 && (n = Math.floor(n / e) * e), i[n] = t, o = r.charAt(++t);
  }

  return {
    indent: n,
    stops: i
  };
},
    pn = {
  " ": 1,
  "\t": 4
};

var fn = function fn(r, e) {
  var t,
      n,
      o,
      i,
      a = r.split("\n"),
      l = a.length + 1,
      s = 1 / 0,
      c = [];
  a.unshift(Qt(" ", e) + "!");

  for (; l--;) {
    if (n = un(a[l]), c[l] = n.stops, 0 !== on(a[l]).length) {
      if (!n.indent) {
        s = 1 / 0;
        break;
      }

      n.indent > 0 && n.indent < s && (s = n.indent);
    }
  }

  if (s !== 1 / 0) for (l = a.length; l--;) {
    for (o = c[l], t = s; t && !(t in o);) {
      t--;
    }

    i = 0 !== on(a[l]).length && s && t !== s ? "\t" : "", a[l] = i + a[l].slice(t in o ? o[t] + 1 : 0);
  }
  return a.shift(), a.join("\n");
};

var dn = function dn(r, e, t) {
  var n,
      o,
      i,
      a,
      l,
      s,
      c,
      u,
      p,
      f,
      d,
      g,
      h,
      m,
      b,
      y,
      v,
      w,
      k,
      q,
      A,
      x,
      S,
      E,
      L = this.options.commonmark,
      T = this.options.pedantic,
      R = this.blockTokenizers,
      C = this.interruptList,
      D = 0,
      O = e.length,
      B = null,
      N = 0;

  for (; D < O;) {
    if ("\t" === (a = e.charAt(D))) N += 4 - N % 4;else {
      if (" " !== a) break;
      N++;
    }
    D++;
  }

  if (N >= 4) return;
  if (a = e.charAt(D), n = L ? kn : wn, !0 === vn[a]) l = a, i = !1;else {
    for (i = !0, o = ""; D < O && (a = e.charAt(D), Je(a));) {
      o += a, D++;
    }

    if (a = e.charAt(D), !o || !0 !== n[a]) return;
    B = parseInt(o, 10), l = a;
  }
  if (" " !== (a = e.charAt(++D)) && "\t" !== a) return;
  if (t) return !0;
  D = 0, m = [], b = [], y = [];

  for (; D < O;) {
    for (s = e.indexOf("\n", D), c = D, u = !1, E = !1, -1 === s && (s = O), S = D + 4, N = 0; D < O;) {
      if ("\t" === (a = e.charAt(D))) N += 4 - N % 4;else {
        if (" " !== a) break;
        N++;
      }
      D++;
    }

    if (N >= 4 && (E = !0), v && N >= v.indent && (E = !0), a = e.charAt(D), p = null, !E) {
      if (!0 === vn[a]) p = a, D++, N++;else {
        for (o = ""; D < O && (a = e.charAt(D), Je(a));) {
          o += a, D++;
        }

        a = e.charAt(D), D++, o && !0 === n[a] && (p = a, N += o.length + 1);
      }
      if (p) if ("\t" === (a = e.charAt(D))) N += 4 - N % 4, D++;else if (" " === a) {
        for (S = D + 4; D < S && " " === e.charAt(D);) {
          D++, N++;
        }

        D === S && " " === e.charAt(D) && (D -= 3, N -= 3);
      } else "\n" !== a && "" !== a && (p = null);
    }

    if (p) {
      if (!T && l !== p) break;
      u = !0;
    } else L || E || " " !== e.charAt(c) ? L && v && (E = N >= v.indent || N > 4) : E = !0, u = !1, D = c;

    if (d = e.slice(c, s), f = c === D ? d : e.slice(D, s), ("*" === p || "_" === p || "-" === p) && R.thematicBreak.call(this, r, d, !0)) break;
    if (g = h, h = !on(f).length, E && v) v.value = v.value.concat(y, d), b = b.concat(y, d), y = [];else if (u) 0 !== y.length && (v.value.push(""), v.trail = y.concat()), v = {
      value: [d],
      indent: N,
      trail: []
    }, m.push(v), b = b.concat(y, d), y = [];else if (h) {
      if (g) break;
      y.push(d);
    } else {
      if (g) break;
      if (an(C, R, this, [r, d, !0])) break;
      v.value = v.value.concat(y, d), b = b.concat(y, d), y = [];
    }
    D = s + 1;
  }

  A = r(b.join("\n")).reset({
    type: "list",
    ordered: i,
    start: B,
    loose: null,
    children: []
  }), w = this.enterList(), k = this.enterBlock(), q = !1, D = -1, O = m.length;

  for (; ++D < O;) {
    v = m[D].value.join("\n"), x = r.now(), (v = r(v)(qn(this, v, x), A)).loose && (q = !0), v = m[D].trail.join("\n"), D !== O - 1 && (v += "\n"), r(v);
  }

  return w(), k(), A.loose = q, A;
},
    gn = /\n\n(?!\s*$)/,
    hn = /^\[([ \t]|x|X)][ \t]/,
    mn = /^([ \t]*)([*+-]|\d+[.)])( {1,4}(?! )| |\t|$|(?=\n))([^\n]*)/,
    bn = /^([ \t]*)([*+-]|\d+[.)])([ \t]+)/,
    yn = /^( {1,4}|\t)?/gm,
    vn = {
  "*": !0,
  "+": !0,
  "-": !0
},
    wn = {
  ".": !0
},
    kn = {};

function qn(r, e, t) {
  var n,
      o,
      i = r.offset,
      a = r.options.pedantic ? An : xn,
      l = null;
  return e = a.apply(null, arguments), r.options.gfm && (n = e.match(hn)) && (o = n[0].length, l = "x" === n[1].toLowerCase(), i[t.line] += o, e = e.slice(o)), {
    type: "listItem",
    loose: gn.test(e) || "\n" === e.charAt(e.length - 1),
    checked: l,
    children: r.tokenizeBlock(e, t)
  };
}

function An(r, e, t) {
  var n = r.offset,
      o = t.line;
  return e = e.replace(bn, i), o = t.line, e.replace(yn, i);

  function i(r) {
    return n[o] = (n[o] || 0) + r.length, o++, "";
  }
}

function xn(r, e, t) {
  var n,
      o,
      i,
      a,
      l,
      s,
      c,
      u = r.offset,
      p = t.line;

  for (a = (e = e.replace(mn, function (r, e, t, a, l) {
    o = e + t + a, i = l, Number(t) < 10 && o.length % 2 == 1 && (t = " " + t);
    return (n = e + Qt(" ", t.length) + a) + i;
  })).split("\n"), (l = fn(e, un(n).indent).split("\n"))[0] = i, u[p] = (u[p] || 0) + o.length, p++, s = 0, c = a.length; ++s < c;) {
    u[p] = (u[p] || 0) + a[s].length - l[s].length, p++;
  }

  return l.join("\n");
}

kn["."] = !0, kn[")"] = !0;

var Sn = function Sn(r, e, t) {
  var n,
      o,
      i,
      a,
      l,
      s = r.now(),
      c = e.length,
      u = -1,
      p = "";

  for (; ++u < c;) {
    if (" " !== (i = e.charAt(u)) || u >= 3) {
      u--;
      break;
    }

    p += i;
  }

  n = "", o = "";

  for (; ++u < c;) {
    if ("\n" === (i = e.charAt(u))) {
      u--;
      break;
    }

    " " === i || "\t" === i ? o += i : (n += o + i, o = "");
  }

  if (s.column += p.length, s.offset += p.length, p += n + o, i = e.charAt(++u), a = e.charAt(++u), "\n" !== i || !En[a]) return;
  p += i, o = a, l = En[a];

  for (; ++u < c;) {
    if ((i = e.charAt(u)) !== a) {
      if ("\n" !== i) return;
      u--;
      break;
    }

    o += i;
  }

  if (t) return !0;
  return r(p + o)({
    type: "heading",
    depth: l,
    children: this.tokenizeInline(n, s)
  });
},
    En = {};

En["="] = 1, En["-"] = 2;

var Ln = "<[A-Za-z][A-Za-z0-9\\-]*(?:\\s+[a-zA-Z_:][a-zA-Z0-9:._-]*(?:\\s*=\\s*(?:[^\"'=<>`\\u0000-\\u0020]+|'[^']*'|\"[^\"]*\"))?)*\\s*\\/?>",
    Tn = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>",
    Rn = {
  openCloseTag: new RegExp("^(?:" + Ln + "|" + Tn + ")"),
  tag: new RegExp("^(?:" + Ln + "|" + Tn + "|\x3c!----\x3e|\x3c!--(?:-?[^>-])(?:-?[^-])*--\x3e|<[?].*?[?]>|<![A-Za-z]+\\s+[^>]*>|<!\\[CDATA\\[[\\s\\S]*?\\]\\]>)")
},
    Cn = Rn.openCloseTag,
    Dn = function Dn(r, e, t) {
  var n,
      o,
      i,
      a,
      l,
      s,
      c,
      u = this.options.blocks,
      p = e.length,
      f = 0,
      d = [[/^<(script|pre|style)(?=(\s|>|$))/i, /<\/(script|pre|style)>/i, !0], [/^<!--/, /-->/, !0], [/^<\?/, /\?>/, !0], [/^<![A-Za-z]/, />/, !0], [/^<!\[CDATA\[/, /\]\]>/, !0], [new RegExp("^</?(" + u.join("|") + ")(?=(\\s|/?>|$))", "i"), /^$/, !0], [new RegExp(Cn.source + "\\s*$"), /^$/, !1]];

  for (; f < p && ("\t" === (a = e.charAt(f)) || " " === a);) {
    f++;
  }

  if ("<" !== e.charAt(f)) return;
  n = -1 === (n = e.indexOf("\n", f + 1)) ? p : n, o = e.slice(f, n), i = -1, l = d.length;

  for (; ++i < l;) {
    if (d[i][0].test(o)) {
      s = d[i];
      break;
    }
  }

  if (!s) return;
  if (t) return s[2];
  if (f = n, !s[1].test(o)) for (; f < p;) {
    if (n = -1 === (n = e.indexOf("\n", f + 1)) ? p : n, o = e.slice(f + 1, n), s[1].test(o)) {
      o && (f = n);
      break;
    }

    f = n;
  }
  return c = e.slice(0, f), r(c)({
    type: "html",
    value: c
  });
};

var On = function On(r) {
  return String(r).replace(/\s+/g, " ");
};

var Bn = function Bn(r) {
  return On(r).toLowerCase();
};

var Nn = zn;
zn.notInList = !0, zn.notInBlock = !0;
var In = /^( {4}|\t)?/gm;

function zn(r, e, t) {
  var n,
      o,
      i,
      a,
      l,
      s,
      c,
      u,
      p,
      f,
      d,
      g,
      h = this.offset;

  if (this.options.footnotes) {
    for (n = 0, o = e.length, i = "", a = r.now(), l = a.line; n < o && (p = e.charAt(n), Yt(p));) {
      i += p, n++;
    }

    if ("[" === e.charAt(n) && "^" === e.charAt(n + 1)) {
      for (n = (i += "[^").length, c = ""; n < o && "]" !== (p = e.charAt(n));) {
        "\\" === p && (c += p, n++, p = e.charAt(n)), c += p, n++;
      }

      if (c && "]" === e.charAt(n) && ":" === e.charAt(n + 1)) {
        if (t) return !0;

        for (f = Bn(c), n = (i += c + "]:").length; n < o && ("\t" === (p = e.charAt(n)) || " " === p);) {
          i += p, n++;
        }

        for (a.column += i.length, a.offset += i.length, c = "", s = "", u = ""; n < o;) {
          if ("\n" === (p = e.charAt(n))) {
            for (u = p, n++; n < o && "\n" === (p = e.charAt(n));) {
              u += p, n++;
            }

            for (c += u, u = ""; n < o && " " === (p = e.charAt(n));) {
              u += p, n++;
            }

            if (0 === u.length) break;
            c += u;
          }

          c && (s += c, c = ""), s += p, n++;
        }

        return i += s, s = s.replace(In, function (r) {
          return h[l] = (h[l] || 0) + r.length, l++, "";
        }), d = r(i), g = this.enterBlock(), s = this.tokenizeBlock(s, a), g(), d({
          type: "footnoteDefinition",
          identifier: f,
          children: s
        });
      }
    }
  }
}

var jn = Un;
Un.notInList = !0, Un.notInBlock = !0;

function Un(r, e, t) {
  for (var n, o, i, a, l, s, c, u, p = this.options.commonmark, f = 0, d = e.length, g = ""; f < d && (" " === (a = e.charAt(f)) || "\t" === a);) {
    g += a, f++;
  }

  if ("[" === (a = e.charAt(f))) {
    for (f++, g += a, i = ""; f < d && "]" !== (a = e.charAt(f));) {
      "\\" === a && (i += a, f++, a = e.charAt(f)), i += a, f++;
    }

    if (i && "]" === e.charAt(f) && ":" === e.charAt(f + 1)) {
      for (s = i, f = (g += i + "]:").length, i = ""; f < d && ("\t" === (a = e.charAt(f)) || " " === a || "\n" === a);) {
        g += a, f++;
      }

      if (i = "", n = g, "<" === (a = e.charAt(f))) {
        for (f++; f < d && Pn(a = e.charAt(f));) {
          i += a, f++;
        }

        if ((a = e.charAt(f)) === Pn.delimiter) g += "<" + i + a, f++;else {
          if (p) return;
          f -= i.length + 1, i = "";
        }
      }

      if (!i) {
        for (; f < d && Hn(a = e.charAt(f));) {
          i += a, f++;
        }

        g += i;
      }

      if (i) {
        for (c = i, i = ""; f < d && ("\t" === (a = e.charAt(f)) || " " === a || "\n" === a);) {
          i += a, f++;
        }

        if (l = null, '"' === (a = e.charAt(f)) ? l = '"' : "'" === a ? l = "'" : "(" === a && (l = ")"), l) {
          if (!i) return;

          for (f = (g += i + a).length, i = ""; f < d && (a = e.charAt(f)) !== l;) {
            if ("\n" === a) {
              if (f++, "\n" === (a = e.charAt(f)) || a === l) return;
              i += "\n";
            }

            i += a, f++;
          }

          if ((a = e.charAt(f)) !== l) return;
          o = g, g += i + a, f++, u = i, i = "";
        } else i = "", f = g.length;

        for (; f < d && ("\t" === (a = e.charAt(f)) || " " === a);) {
          g += a, f++;
        }

        return (a = e.charAt(f)) && "\n" !== a ? void 0 : !!t || (n = r(n).test().end, c = this.decode.raw(this.unescape(c), n, {
          nonTerminated: !1
        }), u && (o = r(o).test().end, u = this.decode.raw(this.unescape(u), o)), r(g)({
          type: "definition",
          identifier: Bn(s),
          title: u || null,
          url: c
        }));
      }
    }
  }
}

function Pn(r) {
  return ">" !== r && "[" !== r && "]" !== r;
}

function Hn(r) {
  return "[" !== r && "]" !== r && !Yt(r);
}

Pn.delimiter = ">";

var Vn = function Vn(r, e, t) {
  var n, o, i, a, l, s, c, u, p, f, d, g, h, m, b, y, v, w, k, q, A, x, S, E;
  if (!this.options.gfm) return;
  n = 0, w = 0, s = e.length + 1, c = [];

  for (; n < s;) {
    if (x = e.indexOf("\n", n), S = e.indexOf("|", n + 1), -1 === x && (x = e.length), -1 === S || S > x) {
      if (w < 2) return;
      break;
    }

    c.push(e.slice(n, x)), w++, n = x + 1;
  }

  a = c.join("\n"), o = c.splice(1, 1)[0] || [], n = 0, s = o.length, w--, i = !1, d = [];

  for (; n < s;) {
    if ("|" === (p = o.charAt(n))) {
      if (f = null, !1 === i) {
        if (!1 === E) return;
      } else d.push(i), i = !1;

      E = !1;
    } else if ("-" === p) f = !0, i = i || null;else if (":" === p) i = "left" === i ? "center" : f && null === i ? "right" : "left";else if (!Yt(p)) return;

    n++;
  }

  !1 !== i && d.push(i);
  if (d.length < 1) return;
  if (t) return !0;
  v = -1, q = [], A = r(a).reset({
    type: "table",
    align: d,
    children: q
  });

  for (; ++v < w;) {
    for (k = c[v], l = {
      type: "tableRow",
      children: []
    }, v && r("\n"), r(k).reset(l, A), s = k.length + 1, n = 0, u = "", g = "", h = !0, m = null, b = null; n < s;) {
      if ("\t" !== (p = k.charAt(n)) && " " !== p) {
        if ("" === p || "|" === p) {
          if (h) r(p);else {
            if (p && b) {
              u += p, n++;
              continue;
            }

            !g && !p || h || (a = g, u.length > 1 && (p ? (a += u.slice(0, u.length - 1), u = u.charAt(u.length - 1)) : (a += u, u = "")), y = r.now(), r(a)({
              type: "tableCell",
              children: this.tokenizeInline(g, y)
            }, l)), r(u + p), u = "", g = "";
          }
        } else if (u && (g += u, u = ""), g += p, "\\" === p && n !== s - 2 && (g += k.charAt(n + 1), n++), "`" === p) {
          for (m = 1; k.charAt(n + 1) === p;) {
            g += p, n++, m++;
          }

          b ? m >= b && (b = 0) : b = m;
        }
        h = !1, n++;
      } else g ? u += p : r(p), n++;
    }

    v || r("\n" + o);
  }

  return A;
};

var Gn = function Gn(r, e, t) {
  var n,
      o,
      i,
      a,
      l,
      s = this.options,
      c = s.commonmark,
      u = s.gfm,
      p = this.blockTokenizers,
      f = this.interruptParagraph,
      d = e.indexOf("\n"),
      g = e.length;

  for (; d < g;) {
    if (-1 === d) {
      d = g;
      break;
    }

    if ("\n" === e.charAt(d + 1)) break;

    if (c) {
      for (a = 0, n = d + 1; n < g;) {
        if ("\t" === (i = e.charAt(n))) {
          a = 4;
          break;
        }

        if (" " !== i) break;
        a++, n++;
      }

      if (a >= 4) {
        d = e.indexOf("\n", d + 1);
        continue;
      }
    }

    if (o = e.slice(d + 1), an(f, p, this, [r, o, !0])) break;
    if (p.list.call(this, r, o, !0) && (this.inList || c || u && !Je(on.left(o).charAt(0)))) break;

    if (n = d, -1 !== (d = e.indexOf("\n", d + 1)) && "" === on(e.slice(n, d))) {
      d = n;
      break;
    }
  }

  if (o = e.slice(0, d), "" === on(o)) return r(o), null;
  if (t) return !0;
  return l = r.now(), o = rn(o), r(o)({
    type: "paragraph",
    children: this.tokenizeInline(o, l)
  });
};

var Wn = function Wn(r, e) {
  return r.indexOf("\\", e);
};

var _n = Fn;

function Fn(r, e, t) {
  var n, o;
  if ("\\" === e.charAt(0) && (n = e.charAt(1), -1 !== this.escape.indexOf(n))) return !!t || (o = "\n" === n ? {
    type: "break"
  } : {
    type: "text",
    value: n
  }, r("\\" + n)(o));
}

Fn.locator = Wn;

var Mn = function Mn(r, e) {
  return r.indexOf("<", e);
};

var Yn = Xn;
Xn.locator = Mn, Xn.notInLink = !0;
var $n = "mailto:".length;

function Xn(r, e, t) {
  var n, o, i, a, l, s, c, u, p, f, d;

  if ("<" === e.charAt(0)) {
    for (this, n = "", o = e.length, i = 0, a = "", s = !1, c = "", i++, n = "<"; i < o && (l = e.charAt(i), !(Yt(l) || ">" === l || "@" === l || ":" === l && "/" === e.charAt(i + 1)));) {
      a += l, i++;
    }

    if (a) {
      if (c += a, a = "", c += l = e.charAt(i), i++, "@" === l) s = !0;else {
        if (":" !== l || "/" !== e.charAt(i + 1)) return;
        c += "/", i++;
      }

      for (; i < o && (l = e.charAt(i), !Yt(l) && ">" !== l);) {
        a += l, i++;
      }

      if (l = e.charAt(i), a && ">" === l) return !!t || (p = c += a, n += c + l, (u = r.now()).column++, u.offset++, s && ("mailto:" === c.slice(0, $n).toLowerCase() ? (p = p.substr($n), u.column += $n, u.offset += $n) : c = "mailto:" + c), f = this.inlineTokenizers, this.inlineTokenizers = {
        text: f.text
      }, d = this.enterLink(), p = this.tokenizeInline(p, u), this.inlineTokenizers = f, d(), r(n)({
        type: "link",
        title: null,
        url: lt(c, {
          nonTerminated: !1
        }),
        children: p
      }));
    }
  }
}

var Zn = function Zn(r, e) {
  var t,
      n = Jn.length,
      o = -1,
      i = -1;
  if (!this.options.gfm) return -1;

  for (; ++o < n;) {
    -1 !== (t = r.indexOf(Jn[o], e)) && (t < i || -1 === i) && (i = t);
  }

  return i;
},
    Jn = ["https://", "http://", "mailto:"];

var Kn = eo;
eo.locator = Zn, eo.notInLink = !0;
var Qn = ["http://", "https://", "mailto:"],
    ro = Qn.length;

function eo(r, e, t) {
  var n, o, i, a, l, s, c, u, p, f, d, g;

  if (this.options.gfm) {
    for (n = "", a = -1, u = ro; ++a < u;) {
      if (s = Qn[a], (c = e.slice(0, s.length)).toLowerCase() === s) {
        n = c;
        break;
      }
    }

    if (n) {
      for (a = n.length, u = e.length, p = "", f = 0; a < u && (i = e.charAt(a), !Yt(i) && "<" !== i) && ("." !== i && "," !== i && ":" !== i && ";" !== i && '"' !== i && "'" !== i && ")" !== i && "]" !== i || (d = e.charAt(a + 1)) && !Yt(d)) && ("(" !== i && "[" !== i || f++, ")" !== i && "]" !== i || !(--f < 0));) {
        p += i, a++;
      }

      if (p) {
        if (o = n += p, "mailto:" === s) {
          if (-1 === (l = p.indexOf("@")) || l === u - 1) return;
          o = o.substr("mailto:".length);
        }

        return !!t || (g = this.enterLink(), o = this.tokenizeInline(o, r.now()), g(), r(n)({
          type: "link",
          title: null,
          url: lt(n, {
            nonTerminated: !1
          }),
          children: o
        }));
      }
    }
  }
}

var to = Rn.tag,
    no = ao;
ao.locator = Mn;
var oo = /^<a /i,
    io = /^<\/a>/i;

function ao(r, e, t) {
  var n,
      o,
      i = e.length;
  if (!("<" !== e.charAt(0) || i < 3) && (n = e.charAt(1), (Qe(n) || "?" === n || "!" === n || "/" === n) && (o = e.match(to)))) return !!t || (o = o[0], !this.inLink && oo.test(o) ? this.inLink = !0 : this.inLink && io.test(o) && (this.inLink = !1), r(o)({
    type: "html",
    value: o
  }));
}

var lo = function lo(r, e) {
  var t = r.indexOf("[", e),
      n = r.indexOf("![", e);
  if (-1 === n) return t;
  return t < n ? t : n;
};

var so = fo;
fo.locator = lo;
var co = {}.hasOwnProperty,
    uo = {
  '"': '"',
  "'": "'"
},
    po = {};

function fo(r, e, t) {
  var n,
      o,
      i,
      a,
      l,
      s,
      c,
      u,
      p,
      f,
      d,
      g,
      h,
      m,
      b,
      y,
      v,
      w,
      k,
      q = "",
      A = 0,
      x = e.charAt(0),
      S = this.options.pedantic,
      E = this.options.commonmark,
      L = this.options.gfm;

  if ("!" === x && (p = !0, q = x, x = e.charAt(++A)), "[" === x && (p || !this.inLink)) {
    for (q += x, b = "", A++, g = e.length, m = 0, (v = r.now()).column += A, v.offset += A; A < g;) {
      if (s = x = e.charAt(A), "`" === x) {
        for (o = 1; "`" === e.charAt(A + 1);) {
          s += x, A++, o++;
        }

        i ? o >= i && (i = 0) : i = o;
      } else if ("\\" === x) A++, s += e.charAt(A);else if (i && !L || "[" !== x) {
        if ((!i || L) && "]" === x) {
          if (!m) {
            if (!S) for (; A < g && (x = e.charAt(A + 1), Yt(x));) {
              s += x, A++;
            }
            if ("(" !== e.charAt(A + 1)) return;
            s += "(", n = !0, A++;
            break;
          }

          m--;
        }
      } else m++;

      b += s, s = "", A++;
    }

    if (n) {
      for (f = b, q += b + s, A++; A < g && (x = e.charAt(A), Yt(x));) {
        q += x, A++;
      }

      if (x = e.charAt(A), u = E ? po : uo, b = "", a = q, "<" === x) {
        for (A++, a += "<"; A < g && ">" !== (x = e.charAt(A));) {
          if (E && "\n" === x) return;
          b += x, A++;
        }

        if (">" !== e.charAt(A)) return;
        q += "<" + b + ">", y = b, A++;
      } else {
        for (x = null, s = ""; A < g && (x = e.charAt(A), !s || !co.call(u, x));) {
          if (Yt(x)) {
            if (!S) break;
            s += x;
          } else {
            if ("(" === x) m++;else if (")" === x) {
              if (0 === m) break;
              m--;
            }
            b += s, s = "", "\\" === x && (b += "\\", x = e.charAt(++A)), b += x;
          }

          A++;
        }

        y = b, A = (q += b).length;
      }

      for (b = ""; A < g && (x = e.charAt(A), Yt(x));) {
        b += x, A++;
      }

      if (x = e.charAt(A), q += b, b && co.call(u, x)) if (A++, q += x, b = "", d = u[x], l = q, E) {
        for (; A < g && (x = e.charAt(A)) !== d;) {
          "\\" === x && (b += "\\", x = e.charAt(++A)), A++, b += x;
        }

        if ((x = e.charAt(A)) !== d) return;

        for (h = b, q += b + x, A++; A < g && (x = e.charAt(A), Yt(x));) {
          q += x, A++;
        }
      } else for (s = ""; A < g;) {
        if ((x = e.charAt(A)) === d) c && (b += d + s, s = ""), c = !0;else if (c) {
          if (")" === x) {
            q += b + d + s, h = b;
            break;
          }

          Yt(x) ? s += x : (b += d + s + x, s = "", c = !1);
        } else b += x;
        A++;
      }
      if (")" === e.charAt(A)) return !!t || (q += ")", y = this.decode.raw(this.unescape(y), r(a).test().end, {
        nonTerminated: !1
      }), h && (l = r(l).test().end, h = this.decode.raw(this.unescape(h), l)), k = {
        type: p ? "image" : "link",
        title: h || null,
        url: y
      }, p ? k.alt = this.decode.raw(this.unescape(f), v) || null : (w = this.enterLink(), k.children = this.tokenizeInline(f, v), w()), r(q)(k));
    }
  }
}

po['"'] = '"', po["'"] = "'", po["("] = ")";
var go = ho;
ho.locator = lo;

function ho(r, e, t) {
  var n,
      o,
      i,
      a,
      l,
      s,
      c,
      u,
      p = e.charAt(0),
      f = 0,
      d = e.length,
      g = "",
      h = "",
      m = "link",
      b = "shortcut";

  if ("!" === p && (m = "image", h = p, p = e.charAt(++f)), "[" === p) {
    if (f++, h += p, s = "", this.options.footnotes && "^" === e.charAt(f)) {
      if ("image" === m) return;
      h += "^", f++, m = "footnote";
    }

    for (u = 0; f < d;) {
      if ("[" === (p = e.charAt(f))) c = !0, u++;else if ("]" === p) {
        if (!u) break;
        u--;
      }
      "\\" === p && (s += "\\", p = e.charAt(++f)), s += p, f++;
    }

    if (g = s, n = s, "]" === (p = e.charAt(f))) {
      for (f++, g += p, s = ""; f < d && (p = e.charAt(f), Yt(p));) {
        s += p, f++;
      }

      if (p = e.charAt(f), "footnote" !== m && "[" === p) {
        for (o = "", s += p, f++; f < d && "[" !== (p = e.charAt(f)) && "]" !== p;) {
          "\\" === p && (o += "\\", p = e.charAt(++f)), o += p, f++;
        }

        "]" === (p = e.charAt(f)) ? (b = o ? "full" : "collapsed", s += o + p, f++) : o = "", g += s, s = "";
      } else {
        if (!n) return;
        o = n;
      }

      if ("full" === b || !c) return g = h + g, "link" === m && this.inLink ? null : !!t || ("footnote" === m && -1 !== n.indexOf(" ") ? r(g)({
        type: "footnote",
        children: this.tokenizeInline(n, r.now())
      }) : ((i = r.now()).column += h.length, i.offset += h.length, a = {
        type: m + "Reference",
        identifier: Bn(o = "full" === b ? o : n)
      }, "link" !== m && "image" !== m || (a.referenceType = b), "link" === m ? (l = this.enterLink(), a.children = this.tokenizeInline(n, i), l()) : "image" === m && (a.alt = this.decode.raw(this.unescape(n), i) || null), r(g)(a)));
    }
  }
}

var mo = function mo(r, e) {
  var t = r.indexOf("**", e),
      n = r.indexOf("__", e);
  if (-1 === n) return t;
  if (-1 === t) return n;
  return n < t ? n : t;
};

var bo = yo;
yo.locator = mo;

function yo(r, e, t) {
  var n,
      o,
      i,
      a,
      l,
      s,
      c,
      u = 0,
      p = e.charAt(u);
  if (!("*" !== p && "_" !== p || e.charAt(++u) !== p || (o = this.options.pedantic, l = (i = p) + i, s = e.length, u++, a = "", p = "", o && Yt(e.charAt(u))))) for (; u < s;) {
    if (c = p, !((p = e.charAt(u)) !== i || e.charAt(u + 1) !== i || o && Yt(c)) && (p = e.charAt(u + 2)) !== i) {
      if (!on(a)) return;
      return !!t || ((n = r.now()).column += 2, n.offset += 2, r(l + a + l)({
        type: "strong",
        children: this.tokenizeInline(a, n)
      }));
    }

    o || "\\" !== p || (a += p, p = e.charAt(++u)), a += p, u++;
  }
}

var vo = function vo(r) {
  return ko.test("number" == typeof r ? wo(r) : r.charAt(0));
},
    wo = String.fromCharCode,
    ko = /\w/;

var qo = function qo(r, e) {
  var t = r.indexOf("*", e),
      n = r.indexOf("_", e);
  if (-1 === n) return t;
  if (-1 === t) return n;
  return n < t ? n : t;
};

var Ao = xo;
xo.locator = qo;

function xo(r, e, t) {
  var n,
      o,
      i,
      a,
      l,
      s,
      c,
      u = 0,
      p = e.charAt(u);
  if (!("*" !== p && "_" !== p || (o = this.options.pedantic, l = p, i = p, s = e.length, u++, a = "", p = "", o && Yt(e.charAt(u))))) for (; u < s;) {
    if (c = p, !((p = e.charAt(u)) !== i || o && Yt(c))) {
      if ((p = e.charAt(++u)) !== i) {
        if (!on(a) || c === i) return;

        if (!o && "_" === i && vo(p)) {
          a += i;
          continue;
        }

        return !!t || ((n = r.now()).column++, n.offset++, r(l + a + i)({
          type: "emphasis",
          children: this.tokenizeInline(a, n)
        }));
      }

      a += i;
    }

    o || "\\" !== p || (a += p, p = e.charAt(++u)), a += p, u++;
  }
}

var So = function So(r, e) {
  return r.indexOf("~~", e);
};

var Eo = Lo;
Lo.locator = So;

function Lo(r, e, t) {
  var n,
      o,
      i,
      a = "",
      l = "",
      s = "",
      c = "";
  if (this.options.gfm && "~" === e.charAt(0) && "~" === e.charAt(1) && !Yt(e.charAt(2))) for (n = 1, o = e.length, (i = r.now()).column += 2, i.offset += 2; ++n < o;) {
    if (!("~" !== (a = e.charAt(n)) || "~" !== l || s && Yt(s))) return !!t || r("~~" + c + "~~")({
      type: "delete",
      children: this.tokenizeInline(c, i)
    });
    c += l, s = l, l = a;
  }
}

var To = function To(r, e) {
  return r.indexOf("`", e);
};

var Ro = Co;
Co.locator = To;

function Co(r, e, t) {
  for (var n, o, i, a, l, s, c, u, p = e.length, f = 0, d = "", g = ""; f < p && "`" === e.charAt(f);) {
    d += "`", f++;
  }

  if (d) {
    for (l = d, a = f, d = "", u = e.charAt(f), i = 0; f < p;) {
      if (s = u, u = e.charAt(f + 1), "`" === s ? (i++, g += s) : (i = 0, d += s), i && "`" !== u) {
        if (i === a) {
          l += d + g, c = !0;
          break;
        }

        d += g, g = "";
      }

      f++;
    }

    if (!c) {
      if (a % 2 != 0) return;
      d = "";
    }

    if (t) return !0;

    for (n = "", o = "", p = d.length, f = -1; ++f < p;) {
      s = d.charAt(f), Yt(s) ? o += s : (o && (n && (n += o), o = ""), n += s);
    }

    return r(l)({
      type: "inlineCode",
      value: n
    });
  }
}

var Do = function Do(r, e) {
  var t = r.indexOf("\n", e);

  for (; t > e && " " === r.charAt(t - 1);) {
    t--;
  }

  return t;
};

var Oo = Bo;
Bo.locator = Do;

function Bo(r, e, t) {
  for (var n, o = e.length, i = -1, a = ""; ++i < o;) {
    if ("\n" === (n = e.charAt(i))) {
      if (i < 2) return;
      return !!t || r(a += n)({
        type: "break"
      });
    }

    if (" " !== n) return;
    a += n;
  }
}

var No = function No(r, e, t) {
  var n, o, i, a, l, s, c, u, p, f;
  if (t) return !0;
  n = this.inlineMethods, a = n.length, o = this.inlineTokenizers, i = -1, p = e.length;

  for (; ++i < a;) {
    "text" !== (u = n[i]) && o[u] && ((c = o[u].locator) || r.file.fail("Missing locator: `" + u + "`"), -1 !== (s = c.call(this, e, 1)) && s < p && (p = s));
  }

  l = e.slice(0, p), f = r.now(), this.decode(l, f, function (e, t, n) {
    r(n || e)({
      type: "text",
      value: e
    });
  });
};

var Io = zo;

function zo(r, e) {
  this.file = e, this.offset = {}, this.options = Hr(this.options), this.setOptions({}), this.inList = !1, this.inBlock = !1, this.inLink = !1, this.atStart = !0, this.toOffset = _e(e).toOffset, this.unescape = Ye(this, "escape"), this.decode = yt(this);
}

var jo = zo.prototype;

function Uo(r) {
  var e,
      t = [];

  for (e in r) {
    t.push(e);
  }

  return t;
}

jo.setOptions = Tt, jo.parse = Ft, jo.options = Lt, jo.exitStart = We("atStart", !0), jo.enterList = We("inList", !1), jo.enterLink = We("inLink", !1), jo.enterBlock = We("inBlock", !1), jo.interruptParagraph = [["thematicBreak"], ["atxHeading"], ["fencedCode"], ["blockquote"], ["html"], ["setextHeading", {
  commonmark: !1
}], ["definition", {
  commonmark: !1
}], ["footnote", {
  commonmark: !1
}]], jo.interruptList = [["atxHeading", {
  pedantic: !1
}], ["fencedCode", {
  pedantic: !1
}], ["thematicBreak", {
  pedantic: !1
}], ["definition", {
  commonmark: !1
}], ["footnote", {
  commonmark: !1
}]], jo.interruptBlockquote = [["indentedCode", {
  commonmark: !0
}], ["fencedCode", {
  commonmark: !0
}], ["atxHeading", {
  commonmark: !0
}], ["setextHeading", {
  commonmark: !0
}], ["thematicBreak", {
  commonmark: !0
}], ["html", {
  commonmark: !0
}], ["list", {
  commonmark: !0
}], ["definition", {
  commonmark: !1
}], ["footnote", {
  commonmark: !1
}]], jo.blockTokenizers = {
  newline: Zt,
  indentedCode: en,
  fencedCode: nn,
  blockquote: ln,
  atxHeading: sn,
  thematicBreak: cn,
  list: dn,
  setextHeading: Sn,
  html: Dn,
  footnote: Nn,
  definition: jn,
  table: Vn,
  paragraph: Gn
}, jo.inlineTokenizers = {
  escape: _n,
  autoLink: Yn,
  url: Kn,
  html: no,
  link: so,
  reference: go,
  strong: bo,
  emphasis: Ao,
  deletion: Eo,
  code: Ro,
  break: Oo,
  text: No
}, jo.blockMethods = Uo(jo.blockTokenizers), jo.inlineMethods = Uo(jo.inlineTokenizers), jo.tokenizeBlock = vt("block"), jo.tokenizeInline = vt("inline"), jo.tokenizeFactory = vt;
var Po = Ho;

function Ho(r) {
  var e = Ge(Io);
  e.prototype.options = Hr(e.prototype.options, this.data("settings"), r), this.Parser = e;
}

Ho.Parser = Io;

var Vo = function Vo(r, e, t) {
  var n = [];
  "function" == typeof e && (t = e, e = null);

  function o(r) {
    var i;
    return e && r.type !== e || (i = t(r, n.concat())), r.children && !1 !== i ? function (r, e) {
      var t,
          i = r.length,
          a = -1;
      n.push(e);

      for (; ++a < i;) {
        if ((t = r[a]) && !1 === o(t)) return !1;
      }

      return n.pop(), !0;
    }(r.children, r) : i;
  }

  o(r);
};

var Go = function Go() {
  return function (r) {
    return Vo(r, "list", function (r, e) {
      var t,
          n,
          o = 0;

      for (t = 0, n = e.length; t < n; t++) {
        "list" === e[t].type && (o += 1);
      }

      for (t = 0, n = r.children.length; t < n; t++) {
        var i = r.children[t];
        i.index = t, i.ordered = r.ordered;
      }

      r.depth = o;
    }), r;
  };
},
    Wo = /^<(area|base|br|col|embed|hr|img|input|keygen|link|meta|param|source|track|wbr)\s*\/?>$/i,
    _o = /^<(\/?)([a-z]+)\s*>$/,
    Fo = function Fo(r) {
  var e, t;
  return jt(r, "html", function (r, n, o) {
    t !== o && (e = [], t = o);

    var i = function (r) {
      var e = r.value.match(Wo);
      return !!e && e[1];
    }(r);

    if (i) return o.children.splice(n, 1, {
      type: "virtualHtml",
      tag: i,
      position: r.position
    }), !0;

    var a = function (r, e) {
      var t = r.value.match(_o);
      return !!t && {
        tag: t[2],
        opening: !t[1],
        node: r
      };
    }(r);

    if (!a) return !0;

    var l = function (r, e) {
      var t = r.length;

      for (; t--;) {
        if (r[t].tag === e) return r.splice(t, 1)[0];
      }

      return !1;
    }(e, a.tag);

    return l ? o.children.splice(n, 0, function (r, e, t) {
      var n = t.children.indexOf(r.node),
          o = t.children.indexOf(e.node),
          i = t.children.splice(n, o - n + 1).slice(1, -1);
      return {
        type: "virtualHtml",
        children: i,
        tag: r.tag,
        position: {
          start: r.node.position.start,
          end: e.node.position.end,
          indent: []
        }
      };
    }(a, l, o)) : a.opening || e.push(a), !0;
  }, !0), r;
};

function Mo(r, e, t, n) {
  if ("remove" === n) t.children.splice(e, 1);else if ("unwrap" === n) {
    var o = [e, 1];
    r.children && (o = o.concat(r.children)), Array.prototype.splice.apply(t.children, o);
  }
}

var Yo = function Yo(r, e) {
  return function (e) {
    return r.forEach(function (r) {
      return jt(e, r, t, !0);
    }), e;
  };

  function t(r, t, n) {
    n && Mo(r, t, n, e);
  }
},
    $o = function $o(r, e) {
  return function (r) {
    return jt(r, t, !0), r;
  };

  function t(t, n, o) {
    o && !r(t, n, o) && Mo(t, n, o, e);
  }
},
    Xo = "function" == typeof Symbol && Symbol.for,
    Zo = Xo ? Symbol.for("react.element") : 60103,
    Jo = Xo ? Symbol.for("react.portal") : 60106,
    Ko = Xo ? Symbol.for("react.fragment") : 60107,
    Qo = Xo ? Symbol.for("react.strict_mode") : 60108,
    ri = Xo ? Symbol.for("react.profiler") : 60114,
    ei = Xo ? Symbol.for("react.provider") : 60109,
    ti = Xo ? Symbol.for("react.context") : 60110,
    ni = Xo ? Symbol.for("react.async_mode") : 60111,
    oi = Xo ? Symbol.for("react.concurrent_mode") : 60111,
    ii = Xo ? Symbol.for("react.forward_ref") : 60112,
    ai = Xo ? Symbol.for("react.suspense") : 60113,
    li = Xo ? Symbol.for("react.suspense_list") : 60120,
    si = Xo ? Symbol.for("react.memo") : 60115,
    ci = Xo ? Symbol.for("react.lazy") : 60116,
    ui = Xo ? Symbol.for("react.block") : 60121,
    pi = Xo ? Symbol.for("react.fundamental") : 60117,
    fi = Xo ? Symbol.for("react.responder") : 60118,
    di = Xo ? Symbol.for("react.scope") : 60119;
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


function gi(r) {
  if ("object" == typeof r && null !== r) {
    var e = r.$$typeof;

    switch (e) {
      case Zo:
        switch (r = r.type) {
          case ni:
          case oi:
          case Ko:
          case ri:
          case Qo:
          case ai:
            return r;

          default:
            switch (r = r && r.$$typeof) {
              case ti:
              case ii:
              case ci:
              case si:
              case ei:
                return r;

              default:
                return e;
            }

        }

      case Jo:
        return e;
    }
  }
}

function hi(r) {
  return gi(r) === oi;
}

var mi = {
  AsyncMode: ni,
  ConcurrentMode: oi,
  ContextConsumer: ti,
  ContextProvider: ei,
  Element: Zo,
  ForwardRef: ii,
  Fragment: Ko,
  Lazy: ci,
  Memo: si,
  Portal: Jo,
  Profiler: ri,
  StrictMode: Qo,
  Suspense: ai,
  isAsyncMode: function isAsyncMode(r) {
    return hi(r) || gi(r) === ni;
  },
  isConcurrentMode: hi,
  isContextConsumer: function isContextConsumer(r) {
    return gi(r) === ti;
  },
  isContextProvider: function isContextProvider(r) {
    return gi(r) === ei;
  },
  isElement: function isElement(r) {
    return "object" == typeof r && null !== r && r.$$typeof === Zo;
  },
  isForwardRef: function isForwardRef(r) {
    return gi(r) === ii;
  },
  isFragment: function isFragment(r) {
    return gi(r) === Ko;
  },
  isLazy: function isLazy(r) {
    return gi(r) === ci;
  },
  isMemo: function isMemo(r) {
    return gi(r) === si;
  },
  isPortal: function isPortal(r) {
    return gi(r) === Jo;
  },
  isProfiler: function isProfiler(r) {
    return gi(r) === ri;
  },
  isStrictMode: function isStrictMode(r) {
    return gi(r) === Qo;
  },
  isSuspense: function isSuspense(r) {
    return gi(r) === ai;
  },
  isValidElementType: function isValidElementType(r) {
    return "string" == typeof r || "function" == typeof r || r === Ko || r === oi || r === ri || r === Qo || r === ai || r === li || "object" == typeof r && null !== r && (r.$$typeof === ci || r.$$typeof === si || r.$$typeof === ei || r.$$typeof === ti || r.$$typeof === ii || r.$$typeof === pi || r.$$typeof === fi || r.$$typeof === di || r.$$typeof === ui);
  },
  typeOf: gi
},
    bi = or(function (r) {
  r.exports = mi;
}),
    yi = {
  start: {
    line: 1,
    column: 1,
    offset: 0
  },
  end: {
    line: 1,
    column: 1,
    offset: 0
  }
};

function vi(r, e) {
  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
      o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
      i = e.renderers[r.type];
  void 0 === r.position && (r.position = n.node && n.node.position || yi);
  var a = r.position.start,
      l = [r.type, a.line, a.column, o].join("-");
  if (!bi.isValidElementType(i)) throw new Error("Renderer for type `".concat(r.type, "` not defined or is not renderable"));
  var s = wi(r, l, e, i, n, o);
  return t.createElement(i, s, s.children || c() || void 0);

  function c() {
    return r.children && r.children.map(function (t, n) {
      return vi(t, e, {
        node: r,
        props: s
      }, n);
    });
  }
}

function wi(r, e, n, o, i, a) {
  var l,
      s = {
    key: e
  },
      c = "string" == typeof o;
  n.sourcePos && r.position && (s["data-sourcepos"] = [(l = r.position).start.line, ":", l.start.column, "-", l.end.line, ":", l.end.column].map(String).join("")), n.rawSourcePos && !c && (s.sourcePosition = r.position), n.includeNodeIndex && i.node && i.node.children && !c && (s.index = i.node.children.indexOf(r), s.parentChildCount = i.node.children.length);
  var u = null !== r.identifier && void 0 !== r.identifier ? n.definitions[r.identifier] || {} : null;

  switch (r.type) {
    case "root":
      ki(s, {
        className: n.className
      });
      break;

    case "text":
      s.nodeKey = e, s.children = r.value;
      break;

    case "heading":
      s.level = r.depth;
      break;

    case "list":
      s.start = r.start, s.ordered = r.ordered, s.tight = !r.loose, s.depth = r.depth;
      break;

    case "listItem":
      s.checked = r.checked, s.tight = !r.loose, s.ordered = r.ordered, s.index = r.index, s.children = function (r, e) {
        if (r.loose) return r.children;
        if (e.node && r.index > 0 && e.node.children[r.index - 1].loose) return r.children;
        return function (r) {
          return r.children.reduce(function (r, e) {
            return r.concat("paragraph" === e.type ? e.children || [] : [e]);
          }, []);
        }(r);
      }(r, i).map(function (e, t) {
        return vi(e, n, {
          node: r,
          props: s
        }, t);
      });
      break;

    case "definition":
      ki(s, {
        identifier: r.identifier,
        title: r.title,
        url: r.url
      });
      break;

    case "code":
      ki(s, {
        language: r.lang && r.lang.split(/\s/, 1)[0]
      });
      break;

    case "inlineCode":
      s.children = r.value, s.inline = !0;
      break;

    case "link":
      ki(s, {
        title: r.title || void 0,
        target: "function" == typeof n.linkTarget ? n.linkTarget(r.url, r.children, r.title) : n.linkTarget,
        href: n.transformLinkUri ? n.transformLinkUri(r.url, r.children, r.title) : r.url
      });
      break;

    case "image":
      ki(s, {
        alt: r.alt || void 0,
        title: r.title || void 0,
        src: n.transformImageUri ? n.transformImageUri(r.url, r.children, r.title, r.alt) : r.url
      });
      break;

    case "linkReference":
      ki(s, Hr(u, {
        href: n.transformLinkUri ? n.transformLinkUri(u.href) : u.href
      }));
      break;

    case "imageReference":
      ki(s, {
        src: n.transformImageUri && u.href ? n.transformImageUri(u.href, r.children, u.title, r.alt) : u.href,
        title: u.title || void 0,
        alt: r.alt || void 0
      });
      break;

    case "table":
    case "tableHead":
    case "tableBody":
      s.columnAlignment = r.align;
      break;

    case "tableRow":
      s.isHeader = "tableHead" === i.node.type, s.columnAlignment = i.props.columnAlignment;
      break;

    case "tableCell":
      ki(s, {
        isHeader: i.props.isHeader,
        align: i.props.columnAlignment[a]
      });
      break;

    case "virtualHtml":
      s.tag = r.tag;
      break;

    case "html":
      s.isBlock = r.position.start.line !== r.position.end.line, s.escapeHtml = n.escapeHtml, s.skipHtml = n.skipHtml;
      break;

    case "parsedHtml":
      var p;
      r.children && (p = r.children.map(function (e, t) {
        return vi(e, n, {
          node: r,
          props: s
        }, t);
      })), s.escapeHtml = n.escapeHtml, s.skipHtml = n.skipHtml, s.element = function (r, e) {
        var n = r.element;

        if (Array.isArray(n)) {
          var o = t.Fragment || "div";
          return t.createElement(o, null, n);
        }

        if (n.props.children || e) {
          var i = t.Children.toArray(n.props.children).concat(e);
          return t.cloneElement(n, null, i);
        }

        return t.cloneElement(n, null);
      }(r, p);
      break;

    default:
      ki(s, Hr(r, {
        type: void 0,
        position: void 0,
        children: void 0
      }));
  }

  return !c && r.value && (s.value = r.value), s;
}

function ki(r, e) {
  for (var t in e) {
    void 0 !== e[t] && (r[t] = e[t]);
  }
}

var qi = vi,
    Ai = function Ai(r) {
  return jt(r, "table", xi), r;
};

function xi(r) {
  var e = r.children;
  r.children = [{
    type: "tableHead",
    align: r.align,
    children: [e[0]],
    position: e[0].position
  }], e.length > 1 && r.children.push({
    type: "tableBody",
    align: r.align,
    children: e.slice(1),
    position: {
      start: e[1].position.start,
      end: e[e.length - 1].position.end
    }
  });
}

var Si = function r(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  return (e.children || []).reduce(function (e, t) {
    return "definition" === t.type && (e[t.identifier] = {
      href: t.url,
      title: t.title
    }), r(t, e);
  }, t);
},
    Ei = ["http", "https", "mailto", "tel"],
    Li = function Li(r) {
  var e = (r || "").trim(),
      t = e.charAt(0);
  if ("#" === t || "/" === t) return e;
  var n = e.indexOf(":");
  if (-1 === n) return e;

  for (var o = Ei.length, i = -1; ++i < o;) {
    var a = Ei[i];
    if (n === a.length && e.slice(0, a.length).toLowerCase() === a) return e;
  }

  return -1 !== (i = e.indexOf("?")) && n > i || -1 !== (i = e.indexOf("#")) && n > i ? e : "javascript:void(0)";
},
    Ti = parseInt((t.version || "16").slice(0, 2), 10) >= 16,
    Ri = t.createElement,
    Ci = {
  break: "br",
  paragraph: "p",
  emphasis: "em",
  strong: "strong",
  thematicBreak: "hr",
  blockquote: "blockquote",
  delete: "del",
  link: "a",
  image: "img",
  linkReference: "a",
  imageReference: "img",
  table: Di.bind(null, "table"),
  tableHead: Di.bind(null, "thead"),
  tableBody: Di.bind(null, "tbody"),
  tableRow: Di.bind(null, "tr"),
  tableCell: function tableCell(r) {
    var e = r.align ? {
      textAlign: r.align
    } : void 0,
        t = Oi(r);
    return Ri(r.isHeader ? "th" : "td", e ? Hr({
      style: e
    }, t) : t, r.children);
  },
  root: function root(r) {
    var e = !r.className,
        n = e && t.Fragment || "div";
    return Ri(n, e ? null : r, r.children);
  },
  text: function text(r) {
    return Ti ? r.children : Ri("span", null, r.children);
  },
  list: function list(r) {
    var e = Oi(r);
    null !== r.start && 1 !== r.start && void 0 !== r.start && (e.start = r.start.toString());
    return Ri(r.ordered ? "ol" : "ul", e, r.children);
  },
  listItem: function listItem(r) {
    var e = null;

    if (null !== r.checked && void 0 !== r.checked) {
      var t = r.checked;
      e = Ri("input", {
        type: "checkbox",
        checked: t,
        readOnly: !0
      });
    }

    return Ri("li", Oi(r), e, r.children);
  },
  definition: function definition() {
    return null;
  },
  heading: function heading(r) {
    return Ri("h".concat(r.level), Oi(r), r.children);
  },
  inlineCode: function inlineCode(r) {
    return Ri("code", Oi(r), r.children);
  },
  code: function code(r) {
    var e = r.language && "language-".concat(r.language),
        t = Ri("code", e ? {
      className: e
    } : null, r.value);
    return Ri("pre", Oi(r), t);
  },
  html: function html(r) {
    if (r.skipHtml) return null;
    var e = r.isBlock ? "div" : "span";

    if (r.escapeHtml) {
      var n = t.Fragment || e;
      return Ri(n, null, r.value);
    }

    var o = {
      dangerouslySetInnerHTML: {
        __html: r.value
      }
    };
    return Ri(e, o);
  },
  virtualHtml: function virtualHtml(r) {
    return Ri(r.tag, Oi(r), r.children);
  },
  parsedHtml: function parsedHtml(r) {
    return r["data-sourcepos"] ? t.cloneElement(r.element, {
      "data-sourcepos": r["data-sourcepos"]
    }) : r.element;
  }
};

function Di(r, e) {
  return Ri(r, Oi(e), e.children);
}

function Oi(r) {
  return r["data-sourcepos"] ? {
    "data-sourcepos": r["data-sourcepos"]
  } : {};
}

var Bi = "undefined" == typeof Symbol ? "__RMD_HTML_PARSER__" : Symbol("__RMD_HTML_PARSER__");

function Ni(r) {
  return function (r) {
    if (Array.isArray(r)) {
      for (var e = 0, t = new Array(r.length); e < r.length; e++) {
        t[e] = r[e];
      }

      return t;
    }
  }(r) || function (r) {
    if (Symbol.iterator in Object(r) || "[object Arguments]" === Object.prototype.toString.call(r)) return Array.from(r);
  }(r) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }();
}

var Ii = Object.keys(Ci),
    zi = function zi(r) {
  var e = r.source || r.children || "",
      t = r.parserOptions;
  if (r.allowedTypes && r.disallowedTypes) throw new Error("Only one of `allowedTypes` and `disallowedTypes` should be defined");

  var n = Hr(Ci, r.renderers),
      o = [[Po, t]].concat(r.plugins || []).reduce(ji, Ce()),
      i = o.parse(e),
      a = Hr(r, {
    renderers: n,
    definitions: Si(i)
  }),
      l = function (r) {
    var e = [Ai, Go()],
        t = r.disallowedTypes;
    r.allowedTypes && (t = Ii.filter(function (e) {
      return "root" !== e && -1 === r.allowedTypes.indexOf(e);
    }));
    var n = r.unwrapDisallowed ? "unwrap" : "remove";
    t && t.length > 0 && e.push(Yo(t, n));
    r.allowNode && e.push($o(r.allowNode, n));
    var o = !r.escapeHtml && !r.skipHtml,
        i = (r.astPlugins || []).some(function (r) {
      return (Array.isArray(r) ? r[0] : r).identity === Bi;
    });
    o && !i && e.push(Fo);
    return r.astPlugins ? e.concat(r.astPlugins) : e;
  }(r),
      s = o.runSync(i),
      c = l.reduce(function (r, e) {
    return e(r, a);
  }, s);

  return qi(c, a);
};

function ji(r, e) {
  return Array.isArray(e) ? r.use.apply(r, Ni(e)) : r.use(e);
}

zi.defaultProps = {
  renderers: {},
  escapeHtml: !0,
  skipHtml: !1,
  sourcePos: !1,
  rawSourcePos: !1,
  transformLinkUri: Li,
  astPlugins: [],
  plugins: [],
  parserOptions: {}
}, zi.propTypes = {
  className: cr.string,
  source: cr.string,
  children: cr.string,
  sourcePos: cr.bool,
  rawSourcePos: cr.bool,
  escapeHtml: cr.bool,
  skipHtml: cr.bool,
  allowNode: cr.func,
  allowedTypes: cr.arrayOf(cr.oneOf(Ii)),
  disallowedTypes: cr.arrayOf(cr.oneOf(Ii)),
  transformLinkUri: cr.oneOfType([cr.func, cr.bool]),
  linkTarget: cr.oneOfType([cr.func, cr.string]),
  transformImageUri: cr.func,
  astPlugins: cr.arrayOf(cr.func),
  unwrapDisallowed: cr.bool,
  renderers: cr.object,
  plugins: cr.array,
  parserOptions: cr.object
}, zi.types = Ii, zi.renderers = Ci, zi.uriTransformer = Li;
var Ui,
    Pi,
    Hi = zi,
    Vi = er({
  prop: "columns",
  cssProperty: "width",
  transformValue: function transformValue(r) {
    return 100 / r + "%";
  }
}),
    Gi = o(nr)(Ui || (Ui = c(["\n  ", "\n\n  ", "\n"])), Vi, x({
  s: {
    properties: ["paddingTop", "paddingLeft"],
    scale: "spacing"
  },
  vs: {
    property: "paddingTop",
    scale: "spacing"
  },
  hs: {
    property: "paddingLeft",
    scale: "spacing"
  }
})),
    Wi = o(vr)(Pi || (Pi = c(["\n  ", "\n"])), x({
  vs: {
    property: "marginTop",
    scale: "spacing",
    transform: function transform(r, e) {
      return void 0 !== e[r] ? "-" + e[r] : "-" + r;
    }
  },
  hs: {
    property: "marginLeft",
    scale: "spacing",
    transform: function transform(r, e) {
      return void 0 !== e[r] ? "-" + e[r] : "-" + r;
    }
  }
})),
    _i = {
  Markdown: function Markdown(r) {
    var e = r.renderers,
        n = r.allowAllTypes,
        o = r.source;
    return t.createElement(Hi, {
      escapeHtml: !1,
      source: o,
      disallowedTypes: n ? [] : ["paragraph"],
      unwrapDisallowed: !0,
      renderers: e
    });
  },
  Link: function Link(r) {
    var e = r.isDisabled,
        n = r.isExternal,
        o = r.onClick,
        i = r.children,
        a = s(r, ["isDisabled", "isExternal", "onClick", "children"]),
        c = n && {
      target: "_blank",
      rel: "noopener noreferrer"
    };
    return t.createElement(yr, l({
      as: "a",
      display: "inline",
      tabIndex: e ? -1 : void 0,
      "aria-disabled": e,
      onClick: e ? function (r) {
        return r.preventDefault();
      } : o
    }, c, a, {
      _css: e ? "not-allowed" : "pointer"
    }), i);
  },
  VisuallyHidden: function VisuallyHidden(r) {
    var e = l({}, r);
    return t.createElement("span", l({
      style: {
        position: "absolute",
        clip: "rect(0 0 0 0)",
        overflow: "hidden",
        height: "1px",
        width: "1px",
        margin: "-1px",
        padding: 0,
        border: 0,
        whiteSpace: "nowrap",
        wordWrap: "normal"
      }
    }, e));
  },
  Flex: vr,
  Box: nr,
  Columns: function Columns(r) {
    var e = r.cols,
        n = r.hs,
        o = r.vs,
        i = r.children,
        a = r.justifyContent,
        c = void 0 === a ? "flex-start" : a,
        u = r.alignItems,
        p = void 0 === u ? "flex-start" : u,
        f = r.overflow,
        d = void 0 === f ? "hidden" : f,
        g = s(r, ["cols", "hs", "vs", "children", "justifyContent", "alignItems", "overflow"]);
    return t.createElement(zr, l({
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: c,
      alignItems: p,
      vs: o || 0,
      hs: n || 0,
      overflow: d
    }, g), e ? t.Children.map(i, function (r, i) {
      return t.createElement(Ir, l({
        key: i,
        cols: e,
        vs: o || "",
        hs: n || ""
      }, r.props), r.props.children);
    }) : t.Children.map(i, function (r) {
      return t.cloneElement(r, {
        pl: n,
        pt: o
      });
    }));
  },
  Column: function Column(r) {
    r.justifyContent, r.alignItems;
    var e = r.children,
        n = s(r, ["justifyContent", "alignItems", "children"]);
    return t.createElement(Ur, n, e);
  },
  Stack: function Stack(r) {
    var e = r.children,
        n = s(r, ["children"]);
    return t.createElement(Br, n, e);
  },
  HStack: function HStack(r) {
    var e = r.alignItems,
        n = r.justifyContent,
        o = r.children,
        i = r.gap,
        a = void 0 === i ? "0" : i,
        c = s(r, ["alignItems", "justifyContent", "children", "gap"]);
    return t.createElement(vr, l({
      flexDirection: "row"
    }, c), void 0 === (null == o ? void 0 : o.length) || "string" == typeof o ? o : o.filter(Boolean).map(function (r, o) {
      return r ? t.createElement(vr, {
        key: o,
        flexDirection: e ? "row" : null,
        alignItems: e,
        justifyContent: n,
        display: e ? "flex" : "block",
        pl: 0 === o ? "0" : a
      }, r) : null;
    }));
  },
  VStack: function VStack(r) {
    var e = r.alignItems,
        n = r.justifyContent,
        o = r.children,
        i = r.gap,
        a = void 0 === i ? "0" : i,
        l = s(r, ["alignItems", "justifyContent", "children", "gap"]);
    return t.createElement(nr, l, void 0 === (null == o ? void 0 : o.length) || "string" == typeof o ? o : o.filter(Boolean).map(function (r, o) {
      return r ? t.createElement(vr, {
        key: o,
        flexDirection: e ? "column" : null,
        alignItems: e,
        justifyContent: n,
        display: e ? "flex" : "block",
        pt: 0 === o ? "0" : a
      }, r) : null;
    }));
  },
  Inline: function Inline(r) {
    var e = r.flexWrap,
        n = r.children,
        o = s(r, ["flexWrap", "children"]);
    return t.createElement(Dr, l({
      flexWrap: e || "wrap"
    }, o), n);
  },
  Anchor: function Anchor(r) {
    var e = r.children,
        n = s(r, ["children"]);
    return t.createElement(hr, l({
      as: "a"
    }, n), e);
  },
  BreadCrumb: function BreadCrumb(r) {
    var e = r.children,
        n = r.separator,
        o = void 0 === n ? "/" : n,
        i = s(r, ["children", "separator"]),
        a = t.Children.count(e);
    return t.createElement(vr, l({
      alignItems: "center",
      as: "ol"
    }, i), t.Children.map(e, function (r, e) {
      return t.createElement(vr, {
        as: "li",
        alignItems: "center"
      }, t.cloneElement(r), e < a - 1 && o);
    }));
  },
  Button: function Button(r) {
    var e = r.loading,
        n = r.loadingContent,
        o = r.disabled,
        i = r.children,
        a = r.focusable,
        c = r.href,
        u = s(r, ["loading", "loadingContent", "disabled", "children", "focusable", "href"]);
    return t.createElement(Pr, l({
      as: "button",
      href: c,
      role: "button",
      type: c ? null : "button",
      focusable: a,
      loading: e,
      disabled: !!o && !a,
      "aria-disabled": o
    }, u), e ? n : i);
  },
  MaxWidth: function MaxWidth(r) {
    var o = r.children,
        i = r.fluid,
        a = r.useContainers,
        c = r.flexDirection,
        u = void 0 === c ? "column" : c,
        p = r.m,
        f = void 0 === p ? "auto" : p,
        d = (r.width, r.maxWidth, s(r, ["children", "fluid", "useContainers", "flexDirection", "m", "width", "maxWidth"])),
        g = [].concat(e.useContext(n.ThemeContext).mediaquery.mediaqueries.map(function (r) {
      return r.container ? r.container : r.minWidth;
    }));
    return t.createElement(vr, l({
      useContainers: a,
      flexDirection: u,
      m: f,
      fluid: i,
      width: i ? "100%" : g,
      maxWidth: i ? "100%" : g
    }, d), o);
  },
  Image: function Image(r) {
    var e = r.src,
        n = (r.webp, r.alt),
        o = r.webpsrc,
        i = s(r, ["src", "webp", "alt", "webpsrc"]);
    return o ? t.createElement("picture", i, t.createElement("source", {
      srcSet: wr(o, "webp"),
      type: "image/webp"
    }), t.createElement("source", {
      srcSet: e,
      type: "image/jpeg"
    }), t.createElement("img", {
      src: e,
      alt: n
    })) : t.createElement("img", l({
      src: e,
      alt: n
    }, i));
  },
  Normalize: Rr,
  Text: hr,
  Truncate: function Truncate(r) {
    var e = r.children,
        n = s(r, ["children"]);
    return t.createElement(Cr, n, e);
  },
  Tiles: function Tiles(r) {
    var e = r.children,
        n = r.columns,
        o = void 0 === n ? [1] : n,
        i = r.justifyContent,
        a = void 0 === i ? "flex-start" : i,
        c = r.alignItems,
        u = void 0 === c ? "flex-start" : c,
        p = r.overflow,
        f = void 0 === p ? "hidden" : p,
        d = r.hs,
        g = r.vs,
        h = r.flexWrap,
        m = void 0 === h ? "wrap" : h,
        b = r.flexDirection,
        y = void 0 === b ? "row" : b,
        v = s(r, ["children", "columns", "justifyContent", "alignItems", "overflow", "hs", "vs", "flexWrap", "flexDirection"]);
    return t.createElement(Wi, l({
      flexDirection: y,
      flexWrap: m,
      justifyContent: a,
      alignItems: u,
      overflow: f,
      vs: g,
      hs: d
    }, v), t.Children.map(e, function (r, e) {
      return t.createElement(Gi, {
        columns: o,
        vs: g,
        hs: d,
        key: e
      }, r);
    }));
  }
};
module.exports = _i;